import type React from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';
import MdiIcon from '@mdi/react';
import * as mdiIcons from '@mdi/js/mdi';
import ListIcon from '@mui/icons-material/List';
import clsx from 'clsx';
import { LibraryAddCheckOutlined } from '@mui/icons-material';

type MdiIconProps = React.ComponentProps<typeof MdiIcon>;

export const StarterLogo = (props: SvgIconProps) => (
	<SvgIcon viewBox="16.4 11.4 1366.2 235.9" {...props}>
		<style type="text/css">{`
			.st0-DispatcherLogo{fill:url(#SVGID_1_);}
			.st1-DispatcherLogo{fill:url(#SVGID_00000002365623955516137640000004671488360052553121_);}

				.st2-DispatcherLogo{display:none;clip-path:url(#SVGID_00000132767043709528592540000016186195822080224153_);fill:url(#SVGID_00000040535164268144382740000007547128131427708053_);}
			.st3-DispatcherLogo{display:none;clip-path:url(#SVGID_00000003789004848413429430000014966690038044133016_);fill:#F0E3FC;}

				.st4-DispatcherLogo{clip-path:url(#SVGID_00000008136343564228465260000016084474228312539520_);fill:url(#SVGID_00000028286045580589563830000015358030318490520977_);}
			.st5-DispatcherLogo{clip-path:url(#SVGID_00000131330936573274988420000003129891811175820696_);fill:#F0E3FC;}

				.st6-DispatcherLogo{clip-path:url(#SVGID_00000133502692655169635070000005657403139187121803_);fill:url(#SVGID_00000009591067850299772600000016946873893934909825_);}
			.st7-DispatcherLogo{clip-path:url(#SVGID_00000077322191968845268610000005514041250154188965_);fill:#F0E3FC;}
			.st8-DispatcherLogo{fill:url(#SVGID_00000151527988501241088130000010193468904131991980_);}
			.st9-DispatcherLogo{fill:url(#SVGID_00000132786600369773780000000011019244614657462436_);}
			.st10-DispatcherLogo{fill:url(#SVGID_00000013180685853643278420000009148773385390388140_);}
			.st11-DispatcherLogo{fill:url(#SVGID_00000045589210664497915950000009611551907812600201_);}
			.st12-DispatcherLogo{fill:url(#SVGID_00000162322428717695902840000006218273471524827018_);}
			.st13-DispatcherLogo{fill:url(#SVGID_00000134942997441343795620000003077257760075822014_);}
			.st14-DispatcherLogo{enable-background:new    ;}
			.st15-DispatcherLogo{fill:#FFFFFF;}
			.st16-DispatcherLogo{fill:#38256E;}
			.st17-DispatcherLogo{display:none;fill:#FFFFFF;}
			.st18-DispatcherLogo{fill:none;stroke:#38256E;stroke-width:1.9275;}
	`}</style>
		<g id="Layer_1_00000013194088144880065740000017061373937390487967_">
			<linearGradient
				id="SVGID_1_"
				gradientUnits="userSpaceOnUse"
				x1="174.1293"
				y1="232.079"
				x2="170.3702"
				y2="16.721"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#652D90' }} />
				<stop offset={1} style={{ stopColor: '#262261' }} />
			</linearGradient>
			<path
				className="st0-DispatcherLogo"
				d="M264.2,219.6c0,2.3-2.5,4.2-5.5,4.2h-173c-3,0-5.5-1.9-5.5-4.2v-204c0-2.3,2.5-4.2,5.5-4.2h173.1   c3,0,5.5,1.9,5.5,4.2L264.2,219.6L264.2,219.6z"
			/>
			<linearGradient
				id="SVGID_00000041285228167392454390000004629383885181772174_"
				gradientUnits="userSpaceOnUse"
				x1="172.2"
				y1="24.1"
				x2="172.2"
				y2="224.7"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#652D90' }} />
				<stop offset="1.469358e-03" style={{ stopColor: '#6A3597' }} />
				<stop offset="3.767386e-03" style={{ stopColor: '#7A4BA8' }} />
				<stop offset="6.590164e-03" style={{ stopColor: '#926FC6' }} />
				<stop offset="8.379889e-03" style={{ stopColor: '#A48ADB' }} />
				<stop offset="8.379889e-03" style={{ stopColor: '#A48ADB' }} />
				<stop offset={1} style={{ stopColor: '#7D61BC' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000041285228167392454390000004629383885181772174_)',
				}}
				d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5   c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
			/>
			<g id="Layer_4" />
			<g>
				<g>
					<defs>
						<path
							id="SVGID_00000070796665058485671230000007856016415373090705_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000119800931402249822930000007097203158514766241_">
						<use
							xlinkHref="#SVGID_00000070796665058485671230000007856016415373090705_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<radialGradient
						id="SVGID_00000072271514542179063340000016179791507362764687_"
						cx="176.9"
						cy="43.05"
						r="75.8028"
						gradientTransform="matrix(1 0 0 -1 0 242)"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset={0} style={{ stopColor: '#652D90' }} />
						<stop offset="0.2315" style={{ stopColor: '#5D2C8A' }} />
						<stop offset="0.5934" style={{ stopColor: '#472879' }} />
						<stop offset={1} style={{ stopColor: '#262261' }} />
					</radialGradient>
					<path
						style={{
							display: 'none',
							clipPath: 'url(#SVGID_00000119800931402249822930000007097203158514766241_)',
							fill: 'url(#SVGID_00000072271514542179063340000016179791507362764687_)',
						}}
						d="     M277.9,234.6c0.1-0.6,0.1-1.2,0.1-1.8c0-15.8-17.5-28.6-39.4-29.2c0.6-1.6,1-3.2,1-4.9c0-10-11.3-18.1-25.3-18.1     c-3.5,0-6.8,0.5-9.8,1.4c-3.3-10.7-16.7-18.7-32.6-18.7c-18.5,0-33.4,10.7-33.4,23.9c0,0,0,0,0,0.1c-0.7,0-1.3-0.1-2-0.1     c-13.6,0-24.9,7.1-27,16.4c-1.1-0.1-2.2-0.1-3.4-0.1c-16.8,0-30.3,9.7-30.3,21.7c0,3.4,1.1,6.5,3,9.4L277.9,234.6L277.9,234.6z"
					/>
				</g>
				<g>
					<defs>
						<path
							id="SVGID_00000001664502602007708480000002974140201123775411_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000036947482181468571760000018026151734725216131_">
						<use
							xlinkHref="#SVGID_00000001664502602007708480000002974140201123775411_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<path
						style={{
							display: 'none',
							clipPath: 'url(#SVGID_00000036947482181468571760000018026151734725216131_)',
							fill: '#F0E3FC',
						}}
						d="     M275.9,236.2c0.1-0.6,0.1-1.2,0.1-1.8c0-15.8-17.5-28.6-39.4-29.2c0.6-1.6,1-3.2,1-4.9c0-10-11.3-18.1-25.3-18.1     c-3.5,0-6.8,0.5-9.8,1.4c-3.3-10.7-16.7-18.7-32.6-18.7c-18.5,0-33.4,10.7-33.4,23.9c0,0,0,0,0,0.1c-0.7,0-1.3-0.1-2-0.1     c-13.6,0-24.9,7.1-27,16.4c-1.1-0.1-2.2-0.1-3.4-0.1c-16.8,0-30.3,9.7-30.3,21.7c0,3.4,1.1,6.5,3,9.4L275.9,236.2L275.9,236.2z"
					/>
				</g>
				<g>
					<defs>
						<path
							id="SVGID_00000063632112640895157060000001842241596263223486_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000068642338699180484160000015029524001177959854_">
						<use
							xlinkHref="#SVGID_00000063632112640895157060000001842241596263223486_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<radialGradient
						id="SVGID_00000177471877967020915320000001530498103170541476_"
						cx="212.75"
						cy="32.3"
						r="72.6722"
						gradientTransform="matrix(1 0 0 -1 0 242)"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset={0} style={{ stopColor: '#652D90' }} />
						<stop offset="0.2315" style={{ stopColor: '#5D2C8A' }} />
						<stop offset="0.5934" style={{ stopColor: '#472879' }} />
						<stop offset={1} style={{ stopColor: '#262261' }} />
					</radialGradient>
					<path
						style={{
							clipPath: 'url(#SVGID_00000068642338699180484160000015029524001177959854_)',
							fill: 'url(#SVGID_00000177471877967020915320000001530498103170541476_)',
						}}
						d="     M308.9,226.3c0-11.9-9.6-21.5-21.5-21.5c-2.2,0-4.3,0.3-6.3,1c-3.6-11.6-14.4-20-27.1-20c-7.4,0-14,2.8-19.1,7.4     c-4.6-11.6-16-19.8-29.2-19.8c-13.5,0-25,8.5-29.5,20.4c-12.2,0.4-22.1,9.8-23.3,21.7c-1.4-0.3-2.9-0.5-4.4-0.5     c-8.2,0-15.1,5.3-17.6,12.6c-0.6-0.1-1.2-0.2-1.9-0.2c-6.9,0-12.4,5.6-12.4,12.4c0,2.3,0.6,4.4,1.7,6.2h178v-0.1     C303.7,242.5,308.9,235,308.9,226.3z"
					/>
				</g>
				<g>
					<defs>
						<path
							id="SVGID_00000100356313963960232590000015903028045410164866_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000074403877887726854320000017983392470320784318_">
						<use
							xlinkHref="#SVGID_00000100356313963960232590000015903028045410164866_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<path
						style={{
							clipPath: 'url(#SVGID_00000074403877887726854320000017983392470320784318_)',
							fill: '#F0E3FC',
						}}
						d="M307.4,227.6     c0-11.9-9.6-21.5-21.5-21.5c-2.2,0-4.3,0.3-6.3,1c-3.6-11.6-14.4-20-27.1-20c-7.4,0-14,2.8-19.1,7.4c-4.6-11.6-16-19.8-29.2-19.8     c-13.5,0-25,8.5-29.5,20.4c-12.2,0.4-22.1,9.8-23.3,21.7c-1.4-0.3-2.9-0.5-4.4-0.5c-8.2,0-15.1,5.3-17.6,12.6     c-0.6-0.1-1.2-0.2-1.9-0.2c-6.9,0-12.4,5.6-12.4,12.4c0,2.3,0.6,4.4,1.7,6.2h178v-0.1C302.2,243.8,307.4,236.3,307.4,227.6z"
					/>
				</g>
				<g>
					<defs>
						<path
							id="SVGID_00000026876442603572864850000008540552788318943889_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000098919323257675843810000009808057932471462308_">
						<use
							xlinkHref="#SVGID_00000026876442603572864850000008540552788318943889_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<radialGradient
						id="SVGID_00000054966472190796030240000009201105784534568353_"
						cx="145.3493"
						cy="42.6"
						r="72.6727"
						gradientTransform="matrix(1 0 0 -1 0 242)"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset={0} style={{ stopColor: '#652D90' }} />
						<stop offset="0.2315" style={{ stopColor: '#5D2C8A' }} />
						<stop offset="0.5934" style={{ stopColor: '#472879' }} />
						<stop offset={1} style={{ stopColor: '#262261' }} />
					</radialGradient>
					<path
						style={{
							clipPath: 'url(#SVGID_00000098919323257675843810000009808057932471462308_)',
							fill: 'url(#SVGID_00000054966472190796030240000009201105784534568353_)',
						}}
						d="     M61.8,235.6v0.1h178c1.1-1.8,1.7-3.9,1.7-6.2c0-6.9-5.6-12.4-12.4-12.4c-0.6,0-1.3,0.1-1.9,0.2c-2.5-7.3-9.4-12.6-17.6-12.6     c-1.5,0-3,0.2-4.4,0.5c-1.3-11.9-11.2-21.3-23.3-21.7c-4.5-11.9-16-20.4-29.5-20.4c-13.3,0-24.6,8.2-29.2,19.8     c-5-4.6-11.7-7.4-19.1-7.4c-12.8,0-23.5,8.4-27.1,20c-2-0.6-4.1-1-6.3-1c-11.9,0-21.5,9.6-21.5,21.5     C49.1,224.7,54.3,232.2,61.8,235.6z"
					/>
				</g>
				<g>
					<defs>
						<path
							id="SVGID_00000070116026933806641560000015214305612945087644_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000064334759721226034530000001502323346090349242_">
						<use
							xlinkHref="#SVGID_00000070116026933806641560000015214305612945087644_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<path
						style={{
							clipPath: 'url(#SVGID_00000064334759721226034530000001502323346090349242_)',
							fill: '#F0E3FC',
						}}
						d="M59.6,237.5v0.1h178     c1.1-1.8,1.7-3.9,1.7-6.2c0-6.9-5.6-12.4-12.4-12.4c-0.6,0-1.3,0.1-1.9,0.2c-2.5-7.3-9.4-12.6-17.6-12.6c-1.5,0-3,0.2-4.4,0.5     c-1.3-11.9-11.2-21.3-23.3-21.7c-4.5-11.9-16-20.4-29.5-20.4c-13.3,0-24.6,8.2-29.2,19.8c-5-4.6-11.7-7.4-19.1-7.4     c-12.8,0-23.5,8.4-27.1,20c-2-0.6-4.1-1-6.3-1c-11.9,0-21.5,9.6-21.5,21.5C47,226.6,52.2,234.1,59.6,237.5z"
					/>
				</g>
			</g>
			<linearGradient
				id="SVGID_00000158731775335847339040000016874825706913258424_"
				gradientUnits="userSpaceOnUse"
				x1="323.3"
				y1="163.95"
				x2="16.4"
				y2="163.95"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000158731775335847339040000016874825706913258424_)',
				}}
				d="M16.4,114.4c0,0,60.6-72.7,156.5-72.7   s150.4,72.7,150.4,72.7s-72.7-55.7-151.1-55.7C93.9,58.7,16.4,114.4,16.4,114.4z"
			/>
			<linearGradient
				id="SVGID_00000120544072886256165710000007104369613713975939_"
				gradientUnits="userSpaceOnUse"
				x1="311.6"
				y1="116.9"
				x2="28.1"
				y2="116.9"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000120544072886256165710000007104369613713975939_)',
				}}
				d="M28.1,158.8c0,0,56-67.4,144.6-67.4   s138.9,67.4,138.9,67.4s-67.1-53.1-139.6-53.1C99.7,105.7,28.1,158.8,28.1,158.8z"
			/>
			<linearGradient
				id="SVGID_00000000220903810881611400000003171512407082279845_"
				gradientUnits="userSpaceOnUse"
				x1="298.9"
				y1="79.4"
				x2="40.9"
				y2="79.4"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000000220903810881611400000003171512407082279845_)',
				}}
				d="M40.9,190.8c0,0,50.9-56.4,131.6-56.4   s126.4,56.4,126.4,56.4S235.9,146,170,146S40.9,190.8,40.9,190.8z"
			/>
			<linearGradient
				id="SVGID_00000076581861014547783360000005273743619199920544_"
				gradientUnits="userSpaceOnUse"
				x1="22.5"
				y1="168.5"
				x2="317.4"
				y2="168.5"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000076581861014547783360000005273743619199920544_)',
				}}
				d="M22.5,108.4c0,0,58.2-69.8,150.4-69.8   s144.5,69.8,144.5,69.8S247.5,55,172.2,55S22.5,108.4,22.5,108.4z"
			/>
			<linearGradient
				id="SVGID_00000118390640982573243060000006990520875794201006_"
				gradientUnits="userSpaceOnUse"
				x1="33.7"
				y1="123.25"
				x2="306.1"
				y2="123.25"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000118390640982573243060000006990520875794201006_)',
				}}
				d="M33.7,151.1c0,0,53.8-64.7,138.9-64.7   c85.2,0,133.5,64.7,133.5,64.7s-64.5-51-134.1-51C102.4,100.1,33.7,151.1,33.7,151.1z"
			/>
			<linearGradient
				id="SVGID_00000172427342366094383290000005473911128423917451_"
				gradientUnits="userSpaceOnUse"
				x1="45.9"
				y1="87.3"
				x2="293.8"
				y2="87.3"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000172427342366094383290000005473911128423917451_)',
				}}
				d="M45.9,181.8c0,0,48.9-54.2,126.4-54.2   s121.5,54.2,121.5,54.2s-60.5-43-123.8-43C106.7,138.9,45.9,181.8,45.9,181.8z"
			/>
			<g className="st14-DispatcherLogo">
				<path
					className="st15-DispatcherLogo"
					d="M330.6,14.7H368c27.8,0,39.8,20.2,39.8,45.1c0,24.9-12,45.1-39.8,45.1h-37.4V14.7z M346.4,92h15.5    c24.8,0,30.1-14.2,30.1-32.2s-5.3-32.2-30.1-32.2h-15.5V92z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M420.2,14.7h14.4v13.6h-14.4V14.7z M420.2,39.6h14.4v65.3h-14.4V39.6z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M461.1,83.9c0.8,8.3,7.1,11.4,14.8,11.4c5.4,0,14.9-1.1,14.5-8.6c-0.4-7.6-10.9-8.5-21.4-10.9    c-10.6-2.3-21-6.1-21-19.3c0-14.3,15.4-18.7,27.3-18.7c13.4,0,25.5,5.6,27.3,20.1h-15c-1.3-6.8-7-8.7-13.3-8.7    c-4.2,0-11.9,1-11.9,6.7c0,7.1,10.6,8.1,21.2,10.5c10.5,2.4,21.1,6.2,21.1,19.1c0,15.5-15.7,21.2-29.2,21.2    c-16.4,0-28.7-7.3-28.9-22.8H461.1z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M516.2,39.6h13.6v8.8h0.3c4-7.5,11.9-10.6,20.2-10.6c20.6,0,30.6,15.7,30.6,34.8c0,17.6-8.8,34.1-28.2,34.1    c-8.3,0-17.3-3-21.9-10.2h-0.3V129h-14.4V39.6z M548.5,49.2c-12.1,0-18.3,9.2-18.3,23.1c0,13.1,6.7,23,18.3,23    c13.1,0,18.1-11.6,18.1-23C566.5,60.4,560.3,49.2,548.5,49.2z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M647.8,90.4c0,3.5,0.8,4.9,3.4,4.9c0.9,0,2,0,3.5-0.3v10c-2.1,0.8-6.7,1.6-9.1,1.6c-5.8,0-10-2-11.1-8    c-5.7,5.6-14.9,8-22.6,8c-11.8,0-22.4-6.3-22.4-19.1c0-16.3,13-19,25.2-20.3c10.4-1.9,19.6-0.8,19.6-9.2c0-7.5-7.7-8.8-13.5-8.8    c-8.1,0-13.8,3.3-14.4,10.4h-14.4c1-16.8,15.3-21.7,29.7-21.7c12.8,0,26.2,5.2,26.2,19V90.4z M633.4,72.2    c-4.4,2.9-11.4,2.8-17.7,3.9c-6.2,1-11.8,3.3-11.8,10.9c0,6.4,8.2,8.3,13.3,8.3c6.3,0,16.2-3.3,16.2-12.4V72.2z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M656.8,39.6h10.9V20h14.4v19.6h13v10.7h-13v34.9c0,5.9,0.5,9,7,9c2,0,4,0,6.1-0.5v11.1    c-3.2,0.3-6.2,0.8-9.4,0.8c-15,0-17.8-5.8-18.1-16.7V50.3h-10.9V39.6z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M749.5,61.4c-1.1-8-7-12.3-14.9-12.3c-7.5,0-17.9,3.9-17.9,23.8c0,10.9,4.8,22.4,17.3,22.4    c8.3,0,14.2-5.6,15.5-14.9H764c-2.7,16.9-13.1,26.3-30,26.3c-20.5,0-31.7-14.5-31.7-33.7c0-19.7,10.7-35.1,32.2-35.1    c15.2,0,28.1,7.6,29.4,23.6H749.5z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M775.7,14.7h14.4v33.5h0.3c3.5-5.9,11-10.4,19.6-10.4c14.2,0,23.1,7.6,23.1,22.2v44.9h-14.4V63.8    c-0.3-10.2-4.3-14.7-12.8-14.7c-9.6,0-15.8,7.6-15.8,17.2v38.5h-14.4V14.7z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M859.5,76c0,10.2,5.6,19.3,17.6,19.3c8.3,0,13.4-3.7,15.9-10.9h13.6c-3.2,14.3-15.3,22.2-29.6,22.2    c-20.5,0-32-14.3-32-34.4c0-18.6,12.1-34.5,31.6-34.5c20.6,0,33.2,18.6,30.8,38.2H859.5z M893.1,66.5c-0.5-9.1-6.7-17.3-16.4-17.3    c-10,0-16.8,7.6-17.2,17.3H893.1z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M918.5,39.6H932v12.6h0.3c1.6-7,10.2-14.4,19.1-14.4c3.3,0,4.2,0.3,5.4,0.4v13.9c-2-0.3-4.2-0.6-6.2-0.6    c-9.9,0-17.7,8-17.7,22.4v31.1h-14.4V39.6z"
				/>
			</g>
			<g className="st14-DispatcherLogo">
				<path
					className="st15-DispatcherLogo"
					d="M578.3,155c-0.1-15-7.8-19.8-22-19.8c-10.2,0-21.2,4.9-21.2,17.2c0,9.1,7,12,14,14.2l8.8,2.8    c11.4,3.6,22.3,7.4,22.3,21.8c0,8.4-5.1,26.4-32.1,26.4c-18.6,0-32.2-9.2-31.3-30h7.9c-0.8,16.7,8.8,23,24,23    c10.8,0,23.6-5.5,23.6-18.4c0-12.1-11.4-14.3-20.6-17l-8.1-2.5c-9.7-2.9-16.4-8.9-16.4-19.9c0-17.2,14.7-24.5,29.4-24.5    c16.9,0,30.5,7,29.6,26.8H578.3z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M638.2,173.1c0.6-9.2-5.8-14.8-14.4-14.8c-17.6,0-26,17.5-26,33.6c0,11,5.4,19.2,16.8,19.2    c9.7,0,16.6-6.5,19.8-15.5h7.3c-4.4,14.2-13.5,21.8-28.1,21.8c-14.9,0-23.2-10.3-23.2-25.6c0-19.3,12-40,32.6-40    c13,0,22.9,6.7,22.5,21.1H638.2z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M656.5,172.3c2-14,12.5-20.3,25.4-20.3c8.1,0,20.8,2.9,20.8,13.8c0,6-2.6,15.4-3.7,20.9    c-2.7,13.9-4,17.2-4,20.9c0,2.2,2.1,2.5,3.8,2.5c1,0,1.9-0.1,2.9-0.2l-1,6c-1.6,0.4-4.1,0.6-6.1,0.6c-4.1,0-6.3-2.6-6.4-6.7    c0-1.1,0.1-2.3,0.2-3.4l-0.2-0.2c-4.2,7.2-12.5,11.4-20.8,11.4c-10.9,0-19.2-5-19.2-17.2c0-13.1,10.1-17.3,20.8-19.2    c7.7-1.2,14.4-0.6,19.1-1.8c4.8-1.2,7.2-4,7.2-12.1c0-7.3-7.1-8.9-12.7-8.9c-9.3,0-17.3,3.6-18.9,13.9H656.5z M692.8,182.6    l-0.2-0.2c-2.3,3-9.5,3.2-13.3,3.5c-9,0.7-23.7,1.2-23.7,14.2c0,7.9,6.4,11.2,13.4,11.2c11.8,0,19.2-7.3,21.5-18.1L692.8,182.6z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M721.3,153.8h6.8l-2.1,11.3h0.2c4.5-7.3,12.5-13.1,21.4-13.1c10.5,0,18.2,4.8,18.2,16.7    c0,1.9-0.3,4.4-0.9,7.3l-8.3,39.7h-7.3l8.4-40c0.5-1.9,0.8-4.2,0.8-6.2c0-8.2-6.1-11.2-12.6-11.2c-10.6,0-20.3,9.8-23.5,25.6    l-6.6,31.8h-7.3L721.3,153.8z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M781.6,130h64.9l-1.4,7h-28.5L800,215.7h-7.9l16.6-78.7h-28.5L781.6,130z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M837.8,153.8h6.6l-3,14.3h0.2c4.7-8.9,11.1-15.2,21.8-15.1c1.3,0,2.7,0,4,0.1l-1.6,7.6    c-1.4,0-2.8-0.1-4.2-0.1c-13.2,0.2-20.1,11.2-22.6,22.8l-6.8,32.4h-7.3L837.8,153.8z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M874.5,153.8h7.3l-12.9,61.9h-7.3L874.5,153.8z M879.5,130h7.3l-2.6,12.1h-7.3L879.5,130z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M896.7,153.8h6.6l-2.3,11.2h0.2c5.1-8.2,11.3-13,21.9-13c15.4,0,22.8,10.2,22.8,25.3    c0,19-12.7,40.2-32.8,40.2c-9.4,0-17.6-4.1-19.2-14.2h-0.2l-7.3,35.3H879L896.7,153.8z M896.3,193.3c0,10.8,6.1,17.9,16.8,17.9    c16.9,0,25.6-19.2,25.6-34.3c0-10.6-5.1-18.5-16.2-18.5C905.6,158.3,896.3,177.9,896.3,193.3z"
				/>
			</g>
		</g>
		<g id="Layer_6">
			<rect x={974} y="110.9" className="st16-DispatcherLogo" width="408.6" height="128.2" />
			<g>
				<path
					className="st17-DispatcherLogo"
					d="M870,129.3c22.1,0,36.7,15.2,36.7,36.7c0,35.3-22,51.3-44.5,51.3c-24,0-37.3-15.9-37.3-36.7    C824.9,145.3,848.1,129.3,870,129.3z M862.7,205.4c19.4,0,29.3-20.1,29.3-38.9c0-15.7-7.8-25.2-22.5-25.2    c-20,0-29.9,20.1-29.9,38.9C839.6,195.8,847.9,205.4,862.7,205.4z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M1078.1,159.3c0-11.8-6.9-18-19-18c-20,0-29.9,20.1-29.9,38.9c0,15.7,8.4,25.2,23.1,25.2    c15.2,0,20.1-13.5,21.8-19.3h14.7c-4.8,21.2-19.4,31.3-37,31.3c-24,0-37.3-15.9-37.3-36.7c0-35.3,23.2-51.3,45.1-51.3    c19.9,0,33.8,10.7,33.2,30h-14.7V159.3z"
				/>
				<path className="st15-DispatcherLogo" d="M1111.9,131.3h13.4l-17.4,84.1h-13.4L1111.9,131.3z" />
				<path
					className="st15-DispatcherLogo"
					d="M1125.7,190.4c0-20,13.8-37.6,34.7-37.6c16.7,0,26.6,9.2,26.6,26.1c0,21.3-13.1,38-34.7,38    C1135.6,217,1125.7,207.4,1125.7,190.4z M1139.1,190.8c0,8.9,4.2,15.7,14,15.7c13.8,0,20.5-15,20.5-27.3c0-8.9-4.2-15.7-14-15.7    C1145.8,163.5,1139.1,178.6,1139.1,190.8z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M1245.8,215.4h-12.6l1.9-8.8l-0.2-0.2c-4.8,6.7-12.6,10.7-21,10.7c-12.2,0-17.8-6.4-17.8-16.1    c0-2.2,0.1-5.4,0.6-7.5l8.1-38.9h13.4l-7.8,37.6c-0.5,2-0.9,4-0.9,5.7c0,2-0.6,8.7,9.3,8.7c10.4,0,17.4-9.9,19.3-19l6.8-33h13.4    L1245.8,215.4z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M1316.8,215.4H1304l1.9-8.2l-0.2-0.2c-5.3,7.9-11.9,10.1-19.1,10.1c-6.9,0-23.7-2.1-23.7-25    c0-19.7,12.1-39.2,33.1-39.2c8.1,0,15.2,2.6,18.4,10h0.2l6.7-31.6h13.4L1316.8,215.4z M1297.6,163.5c-15,0-21.3,15-21.3,28.6    c0,9.1,4.7,14.4,13.9,14.4c13.8,0,20.8-16.1,20.8-28.4C1311,170,1307.1,163.5,1297.6,163.5z"
				/>
			</g>
			<line className="st18-DispatcherLogo" x1="1287.8" y1="238.1" x2="570.2" y2="238.1" />
		</g>
	</SvgIcon>
);

export const EnterpriseLogo = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 976 241.8" {...props}>
		<linearGradient
			id="SVGID_1_"
			x1="174.129"
			x2="170.37"
			y1="232.079"
			y2="16.721"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#652D90" />
			<stop offset="1" stopColor="#262261" />
		</linearGradient>
		<path
			fill="url(#SVGID_1_)"
			d="M264.2 219.6c0 2.3-2.5 4.2-5.5 4.2h-173c-3 0-5.5-1.9-5.5-4.2v-204c0-2.3 2.5-4.2 5.5-4.2h173.1c3 0 5.5 1.9 5.5 4.2l-.1 204z"
		/>
		<radialGradient
			id="SVGID_00000044867621217590515610000007539254232463081375_"
			cx="157.102"
			cy="141.681"
			r="139.543"
			fx="86.534"
			fy="47.657"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#652D90" />
			<stop offset="0.232" stopColor="#5D2C8A" />
			<stop offset="0.593" stopColor="#472879" />
			<stop offset="1" stopColor="#262261" />
		</radialGradient>
		<path
			fill="url(#SVGID_00000044867621217590515610000007539254232463081375_)"
			d="M259.1 213.9c0 2.2-2.3 4-5.2 4H90.5c-2.9 0-5.2-1.8-5.2-4V21.3c0-2.2 2.3-4 5.2-4h163.4c2.9 0 5.2 1.8 5.2 4v192.6z"
		/>
		<linearGradient
			id="SVGID_00000180338547123919905580000006638438823608830385_"
			x1="323.3"
			x2="16.4"
			y1="163.95"
			y2="163.95"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000180338547123919905580000006638438823608830385_)"
			d="M16.4 114.4S77 41.7 172.9 41.7s150.4 72.7 150.4 72.7-72.7-55.7-151.1-55.7c-78.3 0-155.8 55.7-155.8 55.7z"
		/>
		<linearGradient
			id="SVGID_00000115496975107213465920000017461114203528088730_"
			x1="311.6"
			x2="28.1"
			y1="116.9"
			y2="116.9"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000115496975107213465920000017461114203528088730_)"
			d="M28.1 158.8s56-67.4 144.6-67.4 138.9 67.4 138.9 67.4-67.1-53.1-139.6-53.1c-72.3 0-143.9 53.1-143.9 53.1z"
		/>
		<linearGradient
			id="SVGID_00000042728904086291139350000006740508432388759720_"
			x1="298.9"
			x2="40.9"
			y1="79.4"
			y2="79.4"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000042728904086291139350000006740508432388759720_)"
			d="M40.9 190.8s50.9-56.4 131.6-56.4 126.4 56.4 126.4 56.4S235.9 146 170 146 40.9 190.8 40.9 190.8z"
		/>
		<linearGradient
			id="SVGID_00000107582082218647554340000007826131576691228848_"
			x1="22.5"
			x2="317.4"
			y1="168.5"
			y2="168.5"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000107582082218647554340000007826131576691228848_)"
			d="M22.5 108.4s58.2-69.8 150.4-69.8 144.5 69.8 144.5 69.8S247.5 55 172.2 55 22.5 108.4 22.5 108.4z"
		/>
		<linearGradient
			id="SVGID_00000070102584321948264040000003837661530533234621_"
			x1="33.7"
			x2="306.1"
			y1="123.25"
			y2="123.25"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000070102584321948264040000003837661530533234621_)"
			d="M33.7 151.1s53.8-64.7 138.9-64.7c85.2 0 133.5 64.7 133.5 64.7s-64.5-51-134.1-51-138.3 51-138.3 51z"
		/>
		<linearGradient
			id="SVGID_00000011730519720946581670000015713484023938053793_"
			x1="45.9"
			x2="293.8"
			y1="87.3"
			y2="87.3"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000011730519720946581670000015713484023938053793_)"
			d="M45.9 181.8s48.9-54.2 126.4-54.2 121.5 54.2 121.5 54.2-60.5-43-123.8-43c-63.3.1-124.1 43-124.1 43z"
		/>
		<g fill="currentColor">
			<path d="M330.6 14.7H368c27.8 0 39.8 20.2 39.8 45.1 0 24.9-12 45.1-39.8 45.1h-37.4V14.7zM346.4 92h15.5c24.8 0 30.1-14.2 30.1-32.2s-5.3-32.2-30.1-32.2h-15.5V92zM420.2 14.7h14.4v13.6h-14.4V14.7zm0 24.9h14.4v65.3h-14.4V39.6zM461.1 83.9c.8 8.3 7.1 11.4 14.8 11.4 5.4 0 14.9-1.1 14.5-8.6-.4-7.6-10.9-8.5-21.4-10.9-10.6-2.3-21-6.1-21-19.3 0-14.3 15.4-18.7 27.3-18.7 13.4 0 25.5 5.6 27.3 20.1h-15c-1.3-6.8-7-8.7-13.3-8.7-4.2 0-11.9 1-11.9 6.7 0 7.1 10.6 8.1 21.2 10.5 10.5 2.4 21.1 6.2 21.1 19.1 0 15.5-15.7 21.2-29.2 21.2-16.4 0-28.7-7.3-28.9-22.8h14.5zM516.2 39.6h13.6v8.8h.3c4-7.5 11.9-10.6 20.2-10.6 20.6 0 30.6 15.7 30.6 34.8 0 17.6-8.8 34.1-28.2 34.1-8.3 0-17.3-3-21.9-10.2h-.3V129h-14.4V39.6zm32.3 9.6c-12.1 0-18.3 9.2-18.3 23.1 0 13.1 6.7 23 18.3 23 13.1 0 18.1-11.6 18.1-23-.1-11.9-6.3-23.1-18.1-23.1zM647.8 90.4c0 3.5.8 4.9 3.4 4.9.9 0 2 0 3.5-.3v10c-2.1.8-6.7 1.6-9.1 1.6-5.8 0-10-2-11.1-8-5.7 5.6-14.9 8-22.6 8-11.8 0-22.4-6.3-22.4-19.1 0-16.3 13-19 25.2-20.3 10.4-1.9 19.6-.8 19.6-9.2 0-7.5-7.7-8.8-13.5-8.8-8.1 0-13.8 3.3-14.4 10.4H592c1-16.8 15.3-21.7 29.7-21.7 12.8 0 26.2 5.2 26.2 19v33.5zm-14.4-18.2c-4.4 2.9-11.4 2.8-17.7 3.9-6.2 1-11.8 3.3-11.8 10.9 0 6.4 8.2 8.3 13.3 8.3 6.3 0 16.2-3.3 16.2-12.4V72.2zM656.8 39.6h10.9V20h14.4v19.6h13v10.7h-13v34.9c0 5.9.5 9 7 9 2 0 4 0 6.1-.5v11.1c-3.2.3-6.2.8-9.4.8-15 0-17.8-5.8-18.1-16.7V50.3h-10.9V39.6zM749.5 61.4c-1.1-8-7-12.3-14.9-12.3-7.5 0-17.9 3.9-17.9 23.8 0 10.9 4.8 22.4 17.3 22.4 8.3 0 14.2-5.6 15.5-14.9H764c-2.7 16.9-13.1 26.3-30 26.3-20.5 0-31.7-14.5-31.7-33.7 0-19.7 10.7-35.1 32.2-35.1 15.2 0 28.1 7.6 29.4 23.6h-14.4zM775.7 14.7h14.4v33.5h.3c3.5-5.9 11-10.4 19.6-10.4 14.2 0 23.1 7.6 23.1 22.2v44.9h-14.4V63.8c-.3-10.2-4.3-14.7-12.8-14.7-9.6 0-15.8 7.6-15.8 17.2v38.5h-14.4V14.7zM859.5 76c0 10.2 5.6 19.3 17.6 19.3 8.3 0 13.4-3.7 15.9-10.9h13.6c-3.2 14.3-15.3 22.2-29.6 22.2-20.5 0-32-14.3-32-34.4 0-18.6 12.1-34.5 31.6-34.5 20.6 0 33.2 18.6 30.8 38.2h-47.9zm33.6-9.5c-.5-9.1-6.7-17.3-16.4-17.3-10 0-16.8 7.6-17.2 17.3h33.6zM918.5 39.6H932v12.6h.3c1.6-7 10.2-14.4 19.1-14.4 3.3 0 4.2.3 5.4.4v13.9c-2-.3-4.2-.6-6.2-.6-9.9 0-17.7 8-17.7 22.4V105h-14.4V39.6z" />
		</g>
		<g fill="currentColor">
			<path d="M666.8 155c-.1-15-7.8-19.8-22-19.8-10.2 0-21.2 4.9-21.2 17.2 0 9.1 7 12 14 14.2l8.8 2.8c11.4 3.6 22.3 7.4 22.3 21.8 0 8.4-5.1 26.4-32.1 26.4-18.6 0-32.2-9.2-31.3-30h7.9c-.8 16.7 8.8 23 24 23 10.8 0 23.6-5.5 23.6-18.4 0-12.1-11.4-14.3-20.6-17l-8.1-2.5c-9.7-2.9-16.4-8.9-16.4-19.9 0-17.2 14.7-24.5 29.4-24.5 16.9 0 30.5 7 29.6 26.8h-7.9zM682.4 153.8h10.8l3.8-18.7h7.3l-3.8 18.7h12l-1.2 6.4h-12.2l-8.3 39.7c-.6 2.9-.8 4-.8 5.9 0 2.2 1 4.3 3.8 4.3 2.9 0 5.7-.2 8.6-.7l-1.3 6.6c-2.4.2-5 .5-7.4.5-5.5 0-11.1-1.4-11.1-8.9 0-1.3.2-3.6.8-6.4l8.3-41H681l1.4-6.4zM723.5 153.8h6.6l-3 14.3h.2c4.7-8.9 11.1-15.2 21.8-15.1 1.3 0 2.7 0 4 .1l-1.6 7.6c-1.4 0-2.8-.1-4.2-.1-13.2.2-20.1 11.2-22.6 22.8l-6.8 32.4h-7.3l12.9-62zM755.8 172.3c2-14 12.5-20.3 25.4-20.3 8.1 0 20.8 2.9 20.8 13.8 0 6-2.6 15.4-3.7 20.9-2.7 13.9-4 17.2-4 20.9 0 2.2 2.1 2.5 3.8 2.5 1 0 1.9-.1 2.9-.2l-1 6c-1.6.4-4.1.6-6.1.6-4.1 0-6.3-2.6-6.4-6.7 0-1.1.1-2.3.2-3.4l-.2-.2c-4.2 7.2-12.5 11.4-20.8 11.4-10.9 0-19.2-5-19.2-17.2 0-13.1 10.1-17.3 20.8-19.2 7.7-1.2 14.4-.6 19.1-1.8 4.8-1.2 7.2-4 7.2-12.1 0-7.3-7.1-8.9-12.7-8.9-9.3 0-17.3 3.6-18.9 13.9h-7.2zm36.3 10.3l-.2-.2c-2.3 3-9.5 3.2-13.3 3.5-9 .7-23.7 1.2-23.7 14.2 0 7.9 6.4 11.2 13.4 11.2 11.8 0 19.2-7.3 21.5-18.1l2.3-10.6zM814 153.8h10.8l3.8-18.7h7.3l-3.8 18.7h12l-1.2 6.4h-12.2l-8.3 39.7c-.6 2.9-.8 4-.8 5.9 0 2.2 1 4.3 3.8 4.3 2.9 0 5.7-.2 8.6-.7l-1.3 6.6c-2.4.2-5 .5-7.4.5-5.5 0-11.1-1.4-11.1-8.9 0-1.3.2-3.6.8-6.4l8.3-41h-10.8l1.5-6.4zM890.2 215.7h-6.8l2.1-11.3h-.2c-4.5 7.3-12.5 13.1-21.4 13.1-10.5 0-18.2-4.8-18.2-16.7 0-1.9.3-4.4.9-7.3l8.3-39.7h7.3l-8.4 40c-.5 1.9-.8 4.2-.8 6.2 0 8.2 6.1 11.2 12.6 11.2 10.6 0 20.3-9.8 23.5-25.6l6.6-31.8h7.3l-12.8 61.9zM913.1 195.5c-.1 12 8.5 15.6 17 15.6 6.5 0 15.1-3.5 15.1-11.4 0-8-8.3-10.6-16.2-13.7-8-3.2-16.1-7-16.1-17.2 0-12 12.6-16.9 22.2-16.9 12.6 0 21.6 5.6 21.4 19.9h-7.3c.6-9.5-5.8-13.6-14.1-13.6-6.4 0-14.9 2-14.9 10.6 0 5.8 5.9 8.6 12.7 11.4 8.3 3.4 19.6 6.8 19.6 18.2 0 13.9-12.8 19-24.2 19-11.5 0-23.3-6.5-22.6-22h7.4z" />
		</g>
		<g>
			<defs>
				<path
					id="SVGID_00000077299778435145290620000009785151112440614297_"
					d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
				/>
			</defs>
			<clipPath>
				<use overflow="visible" xlinkHref="#SVGID_00000077299778435145290620000009785151112440614297_" />
			</clipPath>
			<radialGradient
				cx="176.9"
				cy="44.05"
				r="75.803"
				gradientTransform="matrix(1 0 0 -1 0 242)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#652D90" />
				<stop offset="0.232" stopColor="#5D2C8A" />
				<stop offset="0.593" stopColor="#472879" />
				<stop offset="1" stopColor="#262261" />
			</radialGradient>
			<defs>
				<path
					id="SVGID_00000169541521165433195990000017580546638327539077_"
					d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
				/>
			</defs>
			<clipPath>
				<use overflow="visible" xlinkHref="#SVGID_00000169541521165433195990000017580546638327539077_" />
			</clipPath>
			<defs>
				<path
					id="SVGID_00000137854696551782938230000003212650779968310930_"
					d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
				/>
			</defs>
			<clipPath id="SVGID_00000130638750412591470650000012460507851406900891_">
				<use overflow="visible" xlinkHref="#SVGID_00000137854696551782938230000003212650779968310930_" />
			</clipPath>
			<radialGradient
				id="SVGID_00000142890061831351477130000000448148074455887509_"
				cx="212.75"
				cy="33.3"
				r="72.672"
				gradientTransform="matrix(1 0 0 -1 0 242)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#652D90" />
				<stop offset="0.232" stopColor="#5D2C8A" />
				<stop offset="0.593" stopColor="#472879" />
				<stop offset="1" stopColor="#262261" />
			</radialGradient>
			<path
				fill="url(#SVGID_00000142890061831351477130000000448148074455887509_)"
				d="M308.9 225.3c0-11.9-9.6-21.5-21.5-21.5-2.2 0-4.3.3-6.3 1-3.6-11.6-14.4-20-27.1-20-7.4 0-14 2.8-19.1 7.4-4.6-11.6-16-19.8-29.2-19.8-13.5 0-25 8.5-29.5 20.4-12.2.4-22.1 9.8-23.3 21.7-1.4-.3-2.9-.5-4.4-.5-8.2 0-15.1 5.3-17.6 12.6-.6-.1-1.2-.2-1.9-.2-6.9 0-12.4 5.6-12.4 12.4 0 2.3.6 4.4 1.7 6.2h178v-.1c7.4-3.4 12.6-10.9 12.6-19.6z"
				clipPath="url(#SVGID_00000130638750412591470650000012460507851406900891_)"
			/>
			<g>
				<defs>
					<path
						id="SVGID_00000108289202153189116670000012143909518394247585_"
						d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
					/>
				</defs>
				<clipPath id="SVGID_00000163030627674340773890000013090708013523077552_">
					<use overflow="visible" xlinkHref="#SVGID_00000108289202153189116670000012143909518394247585_" />
				</clipPath>
				<path
					fill="#F0E3FC"
					d="M307.5 226.6c0-11.9-9.6-21.5-21.5-21.5-2.2 0-4.3.3-6.3 1-3.6-11.6-14.4-20-27.1-20-7.4 0-14 2.8-19.1 7.4-4.6-11.6-16-19.8-29.2-19.8-13.5 0-25 8.5-29.5 20.4-12.2.4-22.1 9.8-23.3 21.7-1.4-.3-2.9-.5-4.4-.5-8.2 0-15.1 5.3-17.6 12.6-.6-.1-1.2-.2-1.9-.2-6.9 0-12.4 5.6-12.4 12.4 0 2.3.6 4.4 1.7 6.2h178v-.1c7.4-3.4 12.6-10.9 12.6-19.6z"
					clipPath="url(#SVGID_00000163030627674340773890000013090708013523077552_)"
				/>
			</g>
			<g>
				<defs>
					<path
						id="SVGID_00000002354032302746218140000013774416712513780634_"
						d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
					/>
				</defs>
				<clipPath id="SVGID_00000015313719685158652840000017337947964771246527_">
					<use overflow="visible" xlinkHref="#SVGID_00000002354032302746218140000013774416712513780634_" />
				</clipPath>
				<radialGradient
					id="SVGID_00000150094893712890088820000016125505892426926484_"
					cx="145.35"
					cy="43.6"
					r="72.672"
					gradientTransform="matrix(1 0 0 -1 0 242)"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0" stopColor="#652D90" />
					<stop offset="0.232" stopColor="#5D2C8A" />
					<stop offset="0.593" stopColor="#472879" />
					<stop offset="1" stopColor="#262261" />
				</radialGradient>
				<path
					fill="url(#SVGID_00000150094893712890088820000016125505892426926484_)"
					d="M61.8 234.6v.1h178c1.1-1.8 1.7-3.9 1.7-6.2 0-6.9-5.6-12.4-12.4-12.4-.6 0-1.3.1-1.9.2-2.5-7.3-9.4-12.6-17.6-12.6-1.5 0-3 .2-4.4.5-1.3-11.9-11.2-21.3-23.3-21.7-4.5-11.9-16-20.4-29.5-20.4-13.3 0-24.6 8.2-29.2 19.8-5-4.6-11.7-7.4-19.1-7.4-12.8 0-23.5 8.4-27.1 20-2-.6-4.1-1-6.3-1-11.9 0-21.5 9.6-21.5 21.5 0 8.7 5.2 16.2 12.6 19.6z"
					clipPath="url(#SVGID_00000015313719685158652840000017337947964771246527_)"
				/>
			</g>
			<g>
				<defs>
					<path
						id="SVGID_00000057113606027203086730000004364511563572098468_"
						d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
					/>
				</defs>
				<clipPath id="SVGID_00000124858318944601487760000003660471649870897552_">
					<use overflow="visible" xlinkHref="#SVGID_00000057113606027203086730000004364511563572098468_" />
				</clipPath>
				<path
					fill="#F0E3FC"
					d="M59.7 236.5v.1h178c1.1-1.8 1.7-3.9 1.7-6.2 0-6.9-5.6-12.4-12.4-12.4-.6 0-1.3.1-1.9.2-2.5-7.3-9.4-12.6-17.6-12.6-1.5 0-3 .2-4.4.5-1.3-11.9-11.2-21.3-23.3-21.7-4.5-11.9-16-20.4-29.5-20.4-13.3 0-24.6 8.2-29.2 19.8-5-4.6-11.7-7.4-19.1-7.4-12.8 0-23.5 8.4-27.1 20-2-.6-4.1-1-6.3-1-11.9 0-21.5 9.6-21.5 21.5 0 8.7 5.2 16.2 12.6 19.6z"
					clipPath="url(#SVGID_00000124858318944601487760000003660471649870897552_)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PieChartIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
		<g id="Component_44_6" data-name="Component 44 – 6" transform="translate(2 3)">
			<g id="pie_chart_black_24dp" transform="translate(-2 -3)">
				<path id="Path_6182" data-name="Path 6182" d="M0,0H20V20H0Z" fill="none" />
				<path
					id="Path_6183"
					data-name="Path 6183"
					d="M10,2a8,8,0,1,0,8,8A8,8,0,0,0,10,2Zm6.344,7.2H10.8V3.656A6.4,6.4,0,0,1,16.344,9.2ZM3.6,10A6.4,6.4,0,0,1,9.2,3.656V16.344A6.4,6.4,0,0,1,3.6,10Zm7.2,6.344V10.8h5.544A6.4,6.4,0,0,1,10.8,16.344Z"
					fill="#7d61bc"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const MFPIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 14.676 21.242">
		<path
			id="Union_98"
			data-name="Union 98"
			d="M15713.879,21928.242a.621.621,0,0,1-.562-.348h-4.865a.621.621,0,0,1-.562.348h-1.2a.621.621,0,0,1-.562-.348h-.011a1.123,1.123,0,0,1-1.123-1.121v-10.365l-2.675-1.137a.527.527,0,1,1,.413-.969l2.262.961v-1.236a.627.627,0,0,1,.628-.627h10.429a.625.625,0,0,1,.621.627v12.746a1.129,1.129,0,0,1-1.034,1.121.621.621,0,0,1-.556.348Zm-7.634-1.6h9.18v-12h-9.18Zm-.621-13.682a.627.627,0,0,1-.628-.621v-3.605a1.125,1.125,0,0,1,1.123-1.123h3.5a1.126,1.126,0,0,1,1.063.762l4.727-1.355a.524.524,0,1,1,.286,1.008l-3.718,1.066h3.569a1.127,1.127,0,0,1,1.122,1.123v2.125a.625.625,0,0,1-.621.621Zm.621-1.25h9.18v-1.369h-5.3a.626.626,0,0,1-.622-.627v-.854h-3.253Z"
			transform="translate(-15701.998 -21907)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const TonerIconFull = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="bounding-box" width="24" height="24" fill="none" />
		<g id="Group_9998" data-name="Group 9998" transform="translate(0 0.004)">
			<g id="Group_9774" data-name="Group 9774" transform="translate(1.955 2.714)">
				<g id="Group_9995" data-name="Group 9995" transform="translate(0 6.089)">
					<g id="Group_9993" data-name="Group 9993" transform="translate(0 6.395)">
						<circle
							id="Ellipse_169"
							data-name="Ellipse 169"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(14.003 0)"
							fill="currentColor"
						/>
						<circle
							id="Ellipse_168"
							data-name="Ellipse 168"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(7.001 0)"
							fill="currentColor"
						/>
						<circle
							id="Ellipse_167"
							data-name="Ellipse 167"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(0 0)"
							fill="currentColor"
						/>
					</g>
					<g id="Group_9994" data-name="Group 9994" transform="translate(3.653 0)">
						<circle
							id="Ellipse_171"
							data-name="Ellipse 171"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(6.84 0)"
							fill="currentColor"
						/>
						<circle
							id="Ellipse_170"
							data-name="Ellipse 170"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(0 0)"
							fill="currentColor"
						/>
					</g>
				</g>
				<circle
					id="Ellipse_172"
					data-name="Ellipse 172"
					cx="3.044"
					cy="3.044"
					r="3.044"
					transform="translate(7.001)"
					fill="currentColor"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const TonerIconLow = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="bounding-box" width="24" height="24" fill="none" />
		<g id="Group_9997" data-name="Group 9997" transform="translate(0 0.004)">
			<g id="Group_9774" data-name="Group 9774" transform="translate(1.955 2.714)">
				<g id="Group_9995" data-name="Group 9995" transform="translate(0 6.089)">
					<g id="Group_9993" data-name="Group 9993" transform="translate(0 6.395)">
						<circle
							id="Ellipse_169"
							data-name="Ellipse 169"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(14.003 0)"
							fill="#f9971c"
						/>
						<circle
							id="Ellipse_168"
							data-name="Ellipse 168"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(7.001 0)"
							fill="#f9971c"
						/>
						<circle
							id="Ellipse_167"
							data-name="Ellipse 167"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(0 0)"
							fill="#f9971c"
						/>
					</g>
					<g id="Group_9994" data-name="Group 9994" transform="translate(3.653 0)">
						<g
							id="Ellipse_171"
							data-name="Ellipse 171"
							transform="translate(6.84 0)"
							fill="none"
							stroke="#fa971e"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
						<g
							id="Ellipse_170"
							data-name="Ellipse 170"
							transform="translate(0 0)"
							fill="none"
							stroke="#fa971e"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
					</g>
				</g>
				<g
					id="Ellipse_172"
					data-name="Ellipse 172"
					transform="translate(7.001)"
					fill="none"
					stroke="#fa971e"
					strokeWidth="1"
				>
					<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
					<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
				</g>
			</g>
		</g>
		<g id="Group_9998" data-name="Group 9998" transform="translate(0 0.004)">
			<g id="Group_9774-2" data-name="Group 9774" transform="translate(1.955 2.714)">
				<g id="Group_9995-2" data-name="Group 9995" transform="translate(0 6.089)">
					<g id="Group_9993-2" data-name="Group 9993" transform="translate(0 6.395)">
						<circle
							id="Ellipse_169-2"
							data-name="Ellipse 169"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(14.003 0)"
							fill="#f9971c"
						/>
						<circle
							id="Ellipse_168-2"
							data-name="Ellipse 168"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(7.001 0)"
							fill="#f9971c"
						/>
						<circle
							id="Ellipse_167-2"
							data-name="Ellipse 167"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(0 0)"
							fill="#f9971c"
						/>
					</g>
					<g id="Group_9994-2" data-name="Group 9994" transform="translate(3.653 0)">
						<g
							id="Ellipse_171-2"
							data-name="Ellipse 171"
							transform="translate(6.84 0)"
							fill="none"
							stroke="#fa971c"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
						<g
							id="Ellipse_170-2"
							data-name="Ellipse 170"
							transform="translate(0 0)"
							fill="none"
							stroke="#fa971c"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
					</g>
				</g>
				<g
					id="Ellipse_172-2"
					data-name="Ellipse 172"
					transform="translate(7.001)"
					fill="none"
					stroke="#fa971c"
					strokeWidth="1"
				>
					<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
					<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const TonerIconEmpty = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="bounding-box" width="24" height="24" fill="none" />
		<g id="Group_9998" data-name="Group 9998" transform="translate(0 0.004)">
			<g id="Group_9774" data-name="Group 9774" transform="translate(1.955 2.714)">
				<g id="Group_9995" data-name="Group 9995" transform="translate(0 6.089)">
					<g id="Group_9993" data-name="Group 9993" transform="translate(0 6.395)">
						<g
							id="Ellipse_169"
							data-name="Ellipse 169"
							transform="translate(14.003 0)"
							fill="none"
							stroke="#cc1f02"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
						<g
							id="Ellipse_168"
							data-name="Ellipse 168"
							transform="translate(7.001 0)"
							fill="none"
							stroke="#cc1f02"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
						<g
							id="Ellipse_167"
							data-name="Ellipse 167"
							transform="translate(0 0)"
							fill="none"
							stroke="#cc1f02"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
					</g>
					<g id="Group_9994" data-name="Group 9994" transform="translate(3.653 0)">
						<g
							id="Ellipse_171"
							data-name="Ellipse 171"
							transform="translate(6.84 0)"
							fill="none"
							stroke="#cc1f02"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
						<g
							id="Ellipse_170"
							data-name="Ellipse 170"
							transform="translate(0 0)"
							fill="none"
							stroke="#cc1f02"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
					</g>
				</g>
				<g
					id="Ellipse_172"
					data-name="Ellipse 172"
					transform="translate(7.001)"
					fill="none"
					stroke="#cc1f02"
					strokeWidth="1"
				>
					<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
					<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const PaperTrayFullIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" fill="none" />
		<g transform="translate(1.324 6.135)">
			<path
				d="M162.669-475.126a2.57,2.57,0,0,1-1.885-.784,2.57,2.57,0,0,1-.784-1.885V-486h2.669v8.206h16.014V-486h2.669v8.206a2.57,2.57,0,0,1-.784,1.885,2.57,2.57,0,0,1-1.885.784Z"
				transform="translate(-160 486.855)"
				fill="#1a5395"
			/>
			<g transform="translate(4.044 0)">
				<path d="M240-198.144V-200h13.181v2.2Z" transform="translate(-240 206)" fill="#1a5395" />
				<path d="M240-198.144V-200h13.181v2.2Z" transform="translate(-240 202.5)" fill="#1a5395" />
				<path d="M240-198.144V-200h13.181v2.2Z" transform="translate(-240 199)" fill="#1a5395" />
			</g>
		</g>
	</SvgIcon>
);

export const PaperTrayLowIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" fill="none" />
		<g transform="translate(1.324 6.135)">
			<path
				d="M162.669-475.126a2.57,2.57,0,0,1-1.885-.784,2.57,2.57,0,0,1-.784-1.885V-486h2.669v8.206h16.014V-486h2.669v8.206a2.57,2.57,0,0,1-.784,1.885,2.57,2.57,0,0,1-1.885.784Z"
				transform="translate(-160 486.855)"
				fill="#f9971c"
			/>
			<g transform="translate(4.044 0)">
				<path d="M240-198.144V-200h13.181v2.2Z" transform="translate(-240 206)" fill="#f9971c" />
			</g>
		</g>
	</SvgIcon>
);

export const PaperTrayEmptyIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" fill="none" />
		<g transform="translate(1.324 6.135)">
			<path
				d="M162.669-475.126a2.57,2.57,0,0,1-1.885-.784,2.57,2.57,0,0,1-.784-1.885V-486h2.669v8.206h16.014V-486h2.669v8.206a2.57,2.57,0,0,1-.784,1.885,2.57,2.57,0,0,1-1.885.784Z"
				transform="translate(-160 486.855)"
				fill="#cc1f02"
			/>
		</g>
	</SvgIcon>
);

export const PaperStackMonoIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="62" height="34" viewBox="0 0 62 34" {...props}>
		<g transform="translate(-652 -248.256)">
			<g transform="translate(652 264.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 262.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 260.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 258.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 256.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 254.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 252.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 250.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 248.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 246.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
					<g transform="translate(11.352 3.137)">
						<g transform="translate(0)">
							<path
								d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
								transform="translate(3.75 0.947)"
								fill="#282828"
							/>
						</g>
						<g transform="translate(4.37 1.092)">
							<path
								d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
								transform="translate(3.75 0.947)"
								fill="#282828"
							/>
						</g>
						<g transform="translate(8.679 2.185)">
							<path
								d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
								transform="translate(3.75 0.947)"
								fill="#282828"
							/>
						</g>
						<g transform="translate(13.109 3.277)">
							<path
								d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
								transform="translate(3.75 0.947)"
								fill="#282828"
							/>
						</g>
						<g transform="translate(17.595 4.538)">
							<path
								d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
								transform="translate(3.75 0.947)"
								fill="#282828"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const PaperStackColorIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="62" height="34" viewBox="0 0 62 34" {...props}>
		<g id="Group_10533" data-name="Group 10533" transform="translate(0 16.25)">
			<g id="Group_10515" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460" data-name="Group 10460">
					<g id="Group_9985" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987" data-name="Group 9987">
								<g id="Polygon_6" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#8368bf"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10532" data-name="Group 10532" transform="translate(0 14.25)">
			<g id="Group_10515-2" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-2" data-name="Group 10460">
					<g id="Group_9985-2" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-2" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-2" data-name="Group 9987">
								<g id="Polygon_6-2" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10531" data-name="Group 10531" transform="translate(0 12.25)">
			<g id="Group_10515-3" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-3" data-name="Group 10460">
					<g id="Group_9985-3" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-3" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-3" data-name="Group 9987">
								<g id="Polygon_6-3" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10530" data-name="Group 10530" transform="translate(0 10.25)">
			<g id="Group_10515-4" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-4" data-name="Group 10460">
					<g id="Group_9985-4" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-4" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-4" data-name="Group 9987">
								<g id="Polygon_6-4" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10529" data-name="Group 10529" transform="translate(0 8.25)">
			<g id="Group_10515-5" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-5" data-name="Group 10460">
					<g id="Group_9985-5" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-5" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-5" data-name="Group 9987">
								<g id="Polygon_6-5" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#8368bf"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10528" data-name="Group 10528" transform="translate(0 6.25)">
			<g id="Group_10515-6" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-6" data-name="Group 10460">
					<g id="Group_9985-6" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-6" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-6" data-name="Group 9987">
								<g id="Polygon_6-6" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10527" data-name="Group 10527" transform="translate(0 4.25)">
			<g id="Group_10515-7" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-7" data-name="Group 10460">
					<g id="Group_9985-7" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-7" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-7" data-name="Group 9987">
								<g id="Polygon_6-7" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10526" data-name="Group 10526" transform="translate(0 2.25)">
			<g id="Group_10515-8" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-8" data-name="Group 10460">
					<g id="Group_9985-8" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-8" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-8" data-name="Group 9987">
								<g id="Polygon_6-8" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10525" data-name="Group 10525" transform="translate(0 0.25)">
			<g id="Group_10515-9" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-9" data-name="Group 10460">
					<g id="Group_9985-9" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-9" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-9" data-name="Group 9987">
								<g id="Polygon_6-9" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10507" data-name="Group 10507" transform="translate(0 -1.75)">
			<g id="Group_10515-10" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-10" data-name="Group 10460">
					<g id="Group_9985-10" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-10" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-10" data-name="Group 9987">
								<g id="Polygon_6-10" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
				<g id="Group_10467" data-name="Group 10467" transform="translate(11.352 3.137)">
					<g id="Group_10462" data-name="Group 10462" transform="translate(0)">
						<path
							id="Line_593"
							data-name="Line 593"
							d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
							transform="translate(3.75 0.947)"
							fill="#de11eb"
						/>
					</g>
					<g id="Group_10463" data-name="Group 10463" transform="translate(4.37 1.092)">
						<path
							id="Line_593-2"
							data-name="Line 593"
							d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
							transform="translate(3.75 0.947)"
							fill="#10b2ec"
						/>
					</g>
					<g id="Group_10464" data-name="Group 10464" transform="translate(8.679 2.185)">
						<path
							id="Line_593-3"
							data-name="Line 593"
							d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
							transform="translate(3.75 0.947)"
							fill="#ecd611"
						/>
					</g>
					<g id="Group_10465" data-name="Group 10465" transform="translate(13.109 3.277)">
						<path
							id="Line_593-4"
							data-name="Line 593"
							d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
							transform="translate(3.75 0.947)"
							fill="#37f016"
						/>
					</g>
					<g id="Group_10466" data-name="Group 10466" transform="translate(17.595 4.538)">
						<path
							id="Line_593-5"
							data-name="Line 593"
							d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
							transform="translate(3.75 0.947)"
							fill="#ef7913"
						/>
					</g>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const LongFeedPaperDirectionIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="38.365" height="47.001" viewBox="0 0 38.365 47.001" {...props}>
		<defs>
			<filter id="Rectangle_2305" x="0" y="0" width="38.365" height="47.001" filterUnits="userSpaceOnUse">
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1.5" result="blur" />
				<feFlood floodOpacity="0.278" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="portrait-lef-icon-paper-trays" transform="translate(4.5 3.5)">
			<g transform="matrix(1, 0, 0, 1, -4.5, -3.5)" filter="url(#Rectangle_2305)">
				<g
					id="Rectangle_2305-2"
					data-name="Rectangle 2305"
					transform="translate(4.5 3.5)"
					fill="#fff"
					stroke="#262626"
					strokeWidth="0.5"
				>
					<rect width="29.365" height="38.001" stroke="none" />
					<rect x="0.25" y="0.25" width="28.865" height="37.501" fill="none" />
				</g>
			</g>
			<path
				id="Path_10460"
				data-name="Path 10460"
				d="M.883,0V-6.425H1.63V-.677H4.465V0ZM9.136,0H5.555V-6.425H9.136v.664H6.3v2.07H8.965v.659H6.3V-.668H9.136Zm2.171,0H10.56V-6.425h3.582v.664H11.307V-3.41H13.97v.664H11.307Z"
				transform="translate(8 23)"
				fill="#d7d7d7"
			/>
		</g>
	</SvgIcon>
);

export const ShortFeedPaperDirectionIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="47.001" height="38.365" viewBox="0 0 47.001 38.365" {...props}>
		<defs>
			<filter id="Rectangle_2305_sef" x="0" y="0" width="47.001" height="38.365" filterUnits="userSpaceOnUse">
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1.5" result="blur" />
				<feFlood floodOpacity="0.278" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="landscape-sef-icon-paper-trays" transform="translate(4.501 3.5)">
			<g id="Group_9890" data-name="Group 9890" transform="translate(-20320 -10199) rotate(90)">
				<g transform="matrix(0, -1, 1, 0, 10195.5, -20315.5)" filter="url(#Rectangle_2305_sef)">
					<g
						id="Rectangle_2305-2"
						data-name="Rectangle 2305"
						transform="translate(42.5 3.5) rotate(90)"
						fill="#fff"
						stroke="#262626"
						strokeWidth="0.5"
					>
						<rect width="29.365" height="38.001" stroke="none" />
						<rect x="0.25" y="0.25" width="28.865" height="37.501" fill="none" />
					</g>
				</g>
				<path
					id="Path_10459"
					data-name="Path 10459"
					d="M4.509-1.709A1.576,1.576,0,0,1,3.894-.387a2.668,2.668,0,0,1-1.67.475A4.183,4.183,0,0,1,.466-.207V-.927a4.628,4.628,0,0,0,.861.264,4.532,4.532,0,0,0,.923.1A1.862,1.862,0,0,0,3.375-.85a.93.93,0,0,0,.378-.789,1.013,1.013,0,0,0-.134-.547,1.245,1.245,0,0,0-.448-.393,6.271,6.271,0,0,0-.956-.409,3.051,3.051,0,0,1-1.281-.76A1.678,1.678,0,0,1,.549-4.9a1.426,1.426,0,0,1,.558-1.182,2.319,2.319,0,0,1,1.477-.439,4.352,4.352,0,0,1,1.762.352l-.233.65a3.982,3.982,0,0,0-1.547-.334,1.5,1.5,0,0,0-.927.255.84.84,0,0,0-.334.708,1.084,1.084,0,0,0,.123.547,1.158,1.158,0,0,0,.415.391,5.16,5.16,0,0,0,.894.393,3.54,3.54,0,0,1,1.391.773A1.521,1.521,0,0,1,4.509-1.709ZM9.4,0H5.823V-6.425H9.4v.664H6.57v2.07H9.233v.659H6.57V-.668H9.4Zm2.171,0h-.747V-6.425H14.41v.664H11.575V-3.41h2.663v.664H11.575Z"
					transform="translate(10216.684 -20331.316) rotate(-90)"
					fill="#d7d7d7"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const DeviceGraySiloIcon = (props: SvgIconProps) => (
	<SvgIcon
		component="svg"
		viewBox="0 0 86.027 126.438"
		sx={{ width: 30, height: 'auto' }} // OR any size you want
		{...props}
	>
		<path
			id="Union_100"
			d="M6405.293-681.7v-.742h-2.332v.742h-1.3v-2.844h4.93v2.844Zm-48.469,0v-.742h-2.332v.742h-1.3v-2.844h4.929v2.844Zm-4.419-2.844a6,6,0,0,1-6-6v-57.373l-19.678-8.353,1.983-4.672,17.7,7.509v-21.751h66.349v84.639a6,6,0,0,1-6,6Z"
			transform="translate(-6326.727 808.139)"
			fill="#cecdcd"
		/>
		<path
			id="Union_65"
			d="M28.642,28.6H0V8.5a6,6,0,0,1,6-6H22.642a6,6,0,0,1,5.81,4.5L64.427,0,65.4,4.982,29.688,11.923H60.35a6,6,0,0,1,6,6V28.6H28.642Z"
			transform="translate(19.677 0)"
			fill="#cecdcd"
		/>
	</SvgIcon>
);

export const FitToPageIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20.664" height="23.616" viewBox="0 0 20.664 23.616" {...props}>
		<g id="Group_7169" data-name="Group 7169" transform="translate(-649 -279)">
			<path
				id="document_scanner_24dp_FILL0_wght400_GRAD0_opsz24"
				d="M202.084-778.468h16.5v-19.447h-16.5Zm.868,2.084a2.843,2.843,0,0,1-2.085-.867,2.843,2.843,0,0,1-.867-2.085v-17.712a2.842,2.842,0,0,1,.867-2.085,2.843,2.843,0,0,1,2.085-.867h14.76a2.843,2.843,0,0,1,2.085.867,2.842,2.842,0,0,1,.867,2.085v17.712a2.843,2.843,0,0,1-.867,2.085,2.843,2.843,0,0,1-2.085.867Zm-.868-2.084v0Z"
				transform="translate(449 1079)"
				fill="#fff"
			/>
			<g id="Group_7169-2" data-name="Group 7169" transform="translate(653.085 282.631)">
				<g id="Group_2279" data-name="Group 2279" transform="translate(0 0)">
					<path
						id="zoom_out_map_FILL0_wght400_GRAD0_opsz48"
						d="M6,21.927V19.406H7.025v.762L9.552,17.64l.734.734L7.759,20.9h.762v1.025Zm9.775,0V20.9h.762l-2.51-2.51.734-.734,2.51,2.51v-.762H18.3v2.521ZM9.535,10.269l-2.51-2.51v.762H6V6H8.521V7.025H7.759l2.51,2.51Zm5.226,0-.734-.734,2.51-2.51h-.762V6H18.3V8.521H17.271V7.759Z"
						transform="translate(-6 -6)"
						fill="#fff"
					/>
				</g>
				<path
					id="Path_6506"
					data-name="Path 6506"
					d="M-15031.881-6591.177h.655l.683-.7v-.646h.983v2.311h-2.321Z"
					transform="translate(15034.605 6595.261)"
					fill="#fff"
				/>
				<g id="Group_2276" data-name="Group 2276" transform="translate(7.201 2.739)">
					<path
						id="Path_6506-2"
						data-name="Path 6506"
						d="M-15029.562-6591.177h-.654l-.684-.7v-.646h-.983v2.311h2.321Z"
						transform="translate(15031.883 6592.522)"
						fill="#fff"
					/>
				</g>
				<path
					id="Path_6506-3"
					data-name="Path 6506"
					d="M-15031.881-6591.556h.655l.683.7v.647h.983v-2.311h-2.321Z"
					transform="translate(15034.605 6603.414)"
					fill="#fff"
				/>
				<g id="Group_2276-2" data-name="Group 2276" transform="translate(7.201 10.892)">
					<path
						id="Path_6506-4"
						data-name="Path 6506"
						d="M-15029.562-6591.556h-.654l-.684.7v.647h-.983v-2.311h2.321Z"
						transform="translate(15031.883 6592.522)"
						fill="#fff"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const DownloadIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3034" data-name="Rectangle 3034" width="24" height="24" fill="none" />
		<path
			id="download_FILL0_wght400_GRAD0_opsz24"
			d="M168-788l-5-5,1.4-1.45,2.6,2.6V-800h2v8.15l2.6-2.6L173-793Zm-6,4a1.925,1.925,0,0,1-1.412-.587A1.927,1.927,0,0,1,160-786v-3h2v3h12v-3h2v3a1.928,1.928,0,0,1-.587,1.413A1.926,1.926,0,0,1,174-784Z"
			transform="translate(-156 804)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const RemoveShareIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_4228" data-name="Rectangle 4228" width="26" height="26" fill="none" />
		<path
			id="share_off_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M54.4-863.8a.871.871,0,0,0,.641-.259.871.871,0,0,0,.259-.641.871.871,0,0,0-.259-.641.871.871,0,0,0-.641-.259.871.871,0,0,0-.641.259.871.871,0,0,0-.259.641.871.871,0,0,0,.259.641A.871.871,0,0,0,54.4-863.8Zm0-12.6a.871.871,0,0,0,.641-.259.871.871,0,0,0,.259-.641.871.871,0,0,0-.259-.641.871.871,0,0,0-.641-.259.871.871,0,0,0-.641.259.871.871,0,0,0-.259.641.871.871,0,0,0,.259.641A.871.871,0,0,0,54.4-876.4Zm-13.5,5.625V-871a2.6,2.6,0,0,1,.788-1.913A2.6,2.6,0,0,1,43.6-873.7a2.674,2.674,0,0,1,1.013.191,2.669,2.669,0,0,1,.833.529l6.323-3.69a1.535,1.535,0,0,1-.056-.3q-.011-.146-.011-.326a2.6,2.6,0,0,1,.788-1.913A2.6,2.6,0,0,1,54.4-880a2.6,2.6,0,0,1,1.913.788A2.6,2.6,0,0,1,57.1-877.3a2.6,2.6,0,0,1-.788,1.913,2.6,2.6,0,0,1-1.913.788,2.673,2.673,0,0,1-1.013-.191,2.669,2.669,0,0,1-.833-.529l-6.3,3.668a8.428,8.428,0,0,0-.866-.18,5.84,5.84,0,0,0-.889-.068,6.255,6.255,0,0,0-1.924.293A6.146,6.146,0,0,0,40.9-870.774ZM54.4-862a2.6,2.6,0,0,1-1.913-.788A2.6,2.6,0,0,1,51.7-864.7q0-.135.068-.63l-.968-.585a7.808,7.808,0,0,0-.158-1.046,6.186,6.186,0,0,0-.315-1l2.228,1.283a2.67,2.67,0,0,1,.833-.529A2.673,2.673,0,0,1,54.4-867.4a2.6,2.6,0,0,1,1.913.788A2.6,2.6,0,0,1,57.1-864.7a2.6,2.6,0,0,1-.788,1.913A2.6,2.6,0,0,1,54.4-862Zm-9.9.9a4.337,4.337,0,0,1-3.184-1.316A4.337,4.337,0,0,1,40-865.6a4.338,4.338,0,0,1,1.316-3.184A4.337,4.337,0,0,1,44.5-870.1a4.337,4.337,0,0,1,3.184,1.316A4.338,4.338,0,0,1,49-865.6a4.337,4.337,0,0,1-1.316,3.184A4.337,4.337,0,0,1,44.5-861.1Zm0-3.87,1.575,1.6.653-.63-1.6-1.6,1.6-1.6-.63-.63-1.6,1.6-1.6-1.6-.63.63,1.6,1.6-1.6,1.6.63.63ZM54.4-864.7ZM54.4-877.3Z"
			transform="translate(-35.551 883.549)"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const ReshareIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" {...props}>
		<path
			id="Union_108"
			data-name="Union 108"
			d="M-2331.983-13892.413l1.379-1.4h-3.649a1.683,1.683,0,0,1-1.236-.514,1.675,1.675,0,0,1-.513-1.232v-2.622h1.749v2.622h3.649l-1.4-1.376,1.246-1.246,3.5,3.5-3.5,3.5Zm8.481-2.022a2.8,2.8,0,0,1-.848-2.06,6.844,6.844,0,0,1,.073-.681l-6.819-3.98a2.836,2.836,0,0,1-.9.568,2.828,2.828,0,0,1-1.089.206,2.809,2.809,0,0,1-2.064-.848,2.814,2.814,0,0,1-.852-2.064,2.808,2.808,0,0,1,.852-2.06,2.814,2.814,0,0,1,2.064-.853,2.9,2.9,0,0,1,1.089.206,2.9,2.9,0,0,1,.9.573l6.819-3.98a1.7,1.7,0,0,1-.063-.328c-.007-.105-.01-.224-.01-.354a2.821,2.821,0,0,1,.848-2.063,2.81,2.81,0,0,1,2.063-.849,2.81,2.81,0,0,1,2.064.849,2.821,2.821,0,0,1,.848,2.063,2.811,2.811,0,0,1-.848,2.064,2.809,2.809,0,0,1-2.064.848,2.845,2.845,0,0,1-1.093-.206,2.893,2.893,0,0,1-.9-.568l-6.819,3.98a1.629,1.629,0,0,1,.06.328c.007.1.014.22.014.349s-.007.248-.014.354a1.642,1.642,0,0,1-.06.328l6.819,3.98a2.809,2.809,0,0,1,.9-.569,2.847,2.847,0,0,1,1.093-.21,2.814,2.814,0,0,1,2.064.853,2.807,2.807,0,0,1,.848,2.063,2.8,2.8,0,0,1-.848,2.06,2.8,2.8,0,0,1-2.064.853A2.8,2.8,0,0,1-2323.5-13894.436Zm1.372-2.751a.939.939,0,0,0-.28.691.946.946,0,0,0,.28.691.942.942,0,0,0,.691.279.942.942,0,0,0,.691-.279.946.946,0,0,0,.279-.691.938.938,0,0,0-.279-.691.927.927,0,0,0-.691-.279A.927.927,0,0,0-2322.129-13897.187Zm-11.652-6.8a.949.949,0,0,0-.276.691.935.935,0,0,0,.276.691.94.94,0,0,0,.695.279.938.938,0,0,0,.691-.279.938.938,0,0,0,.279-.691.952.952,0,0,0-.279-.691.954.954,0,0,0-.691-.279A.955.955,0,0,0-2333.781-13903.985Zm11.652-6.794a.95.95,0,0,0-.28.69.939.939,0,0,0,.28.691.927.927,0,0,0,.691.279.927.927,0,0,0,.691-.279.938.938,0,0,0,.279-.691.95.95,0,0,0-.279-.69.939.939,0,0,0-.691-.28A.939.939,0,0,0-2322.129-13910.779Z"
			transform="translate(2340.264 13915.096)"
			fill="#7d61bc"
		/>
		<rect id="Rectangle_4340" data-name="Rectangle 4340" width="26" height="26" fill="none" />
	</SvgIcon>
);

export const BadgeIcon = (props: SvgIconProps) => (
	<SvgIcon
		id="Component_300_18"
		data-name="Component 300 – 18"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
	>
		<g id="license-publish-icon" opacity="0">
			<rect id="Rectangle_596" data-name="Rectangle 596" width="24" height="24" rx="4" fill="none" />
		</g>
		<g id="Group_9164" data-name="Group 9164" transform="translate(15094 5296)">
			<rect
				id="Rectangle_3709"
				data-name="Rectangle 3709"
				width="24"
				height="24"
				transform="translate(-15094 -5296)"
				fill="none"
			/>
			<path
				id="id_card_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
				d="M112.186-771.336h4.777v-1.579h-4.777Zm0-3.036h4.777v-1.579h-4.777Zm-9.15,6.113h7.692v-.376a1.84,1.84,0,0,0-1.042-1.654,5.6,5.6,0,0,0-2.8-.6,5.6,5.6,0,0,0-2.8.6,1.84,1.84,0,0,0-1.041,1.654Zm3.846-4.008a1.776,1.776,0,0,0,1.3-.538,1.776,1.776,0,0,0,.538-1.3,1.776,1.776,0,0,0-.538-1.3,1.776,1.776,0,0,0-1.3-.537,1.777,1.777,0,0,0-1.3.537,1.776,1.776,0,0,0-.537,1.3,1.776,1.776,0,0,0,.537,1.3A1.777,1.777,0,0,0,106.883-772.267Zm-4.98,8.057a1.837,1.837,0,0,1-1.35-.553,1.837,1.837,0,0,1-.553-1.35V-778.1a1.837,1.837,0,0,1,.553-1.35A1.837,1.837,0,0,1,101.9-780H118.1a1.837,1.837,0,0,1,1.35.553A1.837,1.837,0,0,1,120-778.1v11.984a1.837,1.837,0,0,1-.553,1.35,1.837,1.837,0,0,1-1.35.553Zm0-1.579H118.1a.309.309,0,0,0,.223-.1.309.309,0,0,0,.1-.223V-778.1a.309.309,0,0,0-.1-.223.309.309,0,0,0-.223-.1H101.9a.309.309,0,0,0-.223.1.309.309,0,0,0-.1.223v11.984a.309.309,0,0,0,.1.223A.309.309,0,0,0,101.9-765.789Zm-.324,0v0Z"
				transform="translate(-15192 -4511.895)"
				fill="inherit"
			/>
		</g>
	</SvgIcon>
);

export const AuthenticationIcon = (props: SvgIconProps) => (
	<SvgIcon
		id="authentication-enable-icon-v4"
		xmlns="http://www.w3.org/2000/svg"
		width="25.328"
		height="24"
		viewBox="0 0 25.328 24"
	>
		<rect id="Rectangle_596" data-name="Rectangle 596" width="25" height="24" rx="4" fill="#4b9c14" opacity="0" />
		<rect
			id="Rectangle_3750"
			data-name="Rectangle 3750"
			width="24"
			height="24"
			transform="translate(1.328)"
			fill="none"
		/>
		<g id="Group_9351" data-name="Group 9351" transform="translate(0 1)">
			<g id="Group_9350" data-name="Group 9350" transform="translate(-335.84 -641.301)">
				<g id="Group_6519" data-name="Group 6519" transform="translate(1.58 2.253)">
					<path
						id="Path_6954"
						data-name="Path 6954"
						d="M5.259,3.986h4.868a.523.523,0,0,1,.523.523V6.943a.523.523,0,0,1-.523.523H5.259a.523.523,0,0,1-.523-.523V4.509a.523.523,0,0,1,.523-.523M9.6,5.032H5.782V6.42H9.6Z"
						transform="translate(340.292 642.391)"
						fill="currentColor"
					/>
					<path
						id="Path_6956"
						data-name="Path 6956"
						d="M1.043,8.218l0-7.156H3.763l.462,2.029a.525.525,0,0,0,.51.408H11.3V9.53h1.045V2.976a.524.524,0,0,0-.524-.524H5.152l-.016-.071,6.245-1.336A.524.524,0,1,0,11.163.025L4.9,1.359,4.689.421a.523.523,0,0,0-.51-.408H.524A.525.525,0,0,0,0,.538S.02,8.983,0,8.812,1.027,8.2,1.043,8.218Z"
						transform="translate(340.201 642.314)"
						fill="currentColor"
					/>
				</g>
				<rect
					id="Rectangle_3009"
					data-name="Rectangle 3009"
					width="17.933"
					height="19.971"
					transform="translate(340.201 642.315)"
					fill="none"
				/>
			</g>
			<path
				id="key_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
				d="M63.723-695.183a1.055,1.055,0,0,1-.774-.32,1.054,1.054,0,0,1-.32-.774,1.055,1.055,0,0,1,.32-.774,1.054,1.054,0,0,1,.774-.319,1.054,1.054,0,0,1,.774.319,1.055,1.055,0,0,1,.32.774,1.055,1.055,0,0,1-.32.774A1.055,1.055,0,0,1,63.723-695.183Zm0,2.63a3.59,3.59,0,0,1-2.636-1.087A3.59,3.59,0,0,1,60-696.276a3.59,3.59,0,0,1,1.087-2.636A3.59,3.59,0,0,1,63.723-700a3.582,3.582,0,0,1,1.969.562,3.734,3.734,0,0,1,1.343,1.469H73.13l1.692,1.693-2.6,2.591-1.256-.944-1.289.957-1.322-.911H67.035a3.769,3.769,0,0,1-1.343,1.466A3.566,3.566,0,0,1,63.723-692.553Zm0-1.016a2.566,2.566,0,0,0,1.687-.588,2.7,2.7,0,0,0,.93-1.442h2.33l.975.674,1.323-.967,1.15.879,1.263-1.263-.677-.677H66.34a2.7,2.7,0,0,0-.93-1.443,2.566,2.566,0,0,0-1.687-.588,2.607,2.607,0,0,0-1.913.8,2.607,2.607,0,0,0-.8,1.912,2.608,2.608,0,0,0,.8,1.912A2.608,2.608,0,0,0,63.723-693.569Z"
				transform="translate(-54.391 712.027)"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const ArrowStartIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.091" height="24" viewBox="0 0 13.091 24" {...props}>
		<g id="Group_6604" data-name="Group 6604" transform="translate(-1449 -801)">
			<g id="arrow_right_black_24dp" transform="translate(1449 801)">
				<path id="Path_7895" data-name="Path 7895" d="M13.091,0H0V24H13.091Z" fill="none" />
				<path
					id="Path_7896"
					data-name="Path 7896"
					d="M19.091,25.182,10,16.091,19.091,7Z"
					transform="translate(-8.805 -3)"
					fill="currentColor"
				/>
			</g>
			<line
				id="Line_557"
				data-name="Line 557"
				y2="11"
				transform="translate(1449.5 808.5)"
				fill="none"
				stroke="currentColor"
				strokeWidth="1"
			/>
		</g>
	</SvgIcon>
);

export const ArrowEndIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.091" height="24" viewBox="0 0 13.091 24" {...props}>
		<g id="arrow_right_black_24dp" transform="translate(0)">
			<path id="Path_7895" data-name="Path 7895" d="M0,0H13.091V24H0Z" fill="none" />
			<path
				id="Path_7896"
				data-name="Path 7896"
				d="M10,25.182l9.091-9.091L10,7Z"
				transform="translate(-7.196 -3)"
				fill="currentColor"
			/>
		</g>
		<line
			id="Line_557"
			data-name="Line 557"
			y2="11"
			transform="translate(12.591 7.5)"
			fill="none"
			stroke="currentColor"
			strokeWidth="1"
		/>
	</SvgIcon>
);

export const ArrowPreviousIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.091" height="24" viewBox="0 0 13.091 24" {...props}>
		<path d="M13.091,0H0V24H13.091Z" fill="none" />
		<path d="M19.091,25.182,10,16.091,19.091,7Z" transform="translate(-8.805 -3)" fill="currentColor" />
	</SvgIcon>
);

export const ArrowNextIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.091" height="24" viewBox="0 0 13.091 24" {...props}>
		<path id="Path_7895" data-name="Path 7895" d="M0,0H13.091V24H0Z" fill="none" />
		<path
			id="Path_7896"
			data-name="Path 7896"
			d="M10,25.182l9.091-9.091L10,7Z"
			transform="translate(-7.195 -3)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const BookmarkIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" {...props}>
		<g id="Component_44_6" data-name="Component 44 – 6" transform="translate(2 3)">
			<g id="pie_chart_black_24dp" transform="translate(-2 -3)">
				<path id="Path_6182" data-name="Path 6182" d="M0,0H20V20H0Z" fill="none" />
				<path
					id="Path_6183"
					data-name="Path 6183"
					d="M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm4-4h-2v2h-2V7h-2V5h2V3h2v2h2v2z"
					fill="#663F80"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const OpenLinkIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		{/* <rect
			id="Rectangle_1712"
			data-name="Rectangle 1712"
			width="24"
			height="24"
			rx="4"
			fill="rgba(0,0,0,0.04)"
			opacity="0"
		/> */}
		<g id="launch_black_18dp" transform="translate(2 1)">
			<path id="Path_6748" data-name="Path 6748" d="M0,0H21V21H0Z" fill="none" />
			<path
				id="Path_6749"
				data-name="Path 6749"
				d="M16.333,16.333H4.667V4.667H10.5V3H4.667A1.666,1.666,0,0,0,3,4.667V16.333A1.666,1.666,0,0,0,4.667,18H16.333A1.672,1.672,0,0,0,18,16.333V10.5H16.333ZM12.167,3V4.667h2.992L6.967,12.858l1.175,1.175,8.192-8.192V8.833H18V3Z"
				fill="#7d61bc"
			/>
		</g>
	</SvgIcon>
);

export const LoadingIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" {...props}>
		<path
			id="Surface"
			d="M22,44A21.982,21.982,0,0,1,0,22H4a18,18,0,0,0,34.585,7.007A17.995,17.995,0,0,0,22,4V0a22.006,22.006,0,0,1,8.564,42.271A21.864,21.864,0,0,1,22,44Z"
			transform="translate(0)"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const ChevronDownThin = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 20 20" {...props}>
		<path d="M17.418 6.109a.697.697 0 0 1 .979 0a.68.68 0 0 1 0 .969l-7.908 7.83a.697.697 0 0 1-.979 0l-7.908-7.83a.68.68 0 0 1 0-.969a.697.697 0 0 1 .979 0L10 13.25l7.418-7.141z" />
	</SvgIcon>
);

export const PurchaseCodeIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" fill="none" />
		<path
			d="M81.8-866.5v1.8H96.2v-1.8Zm0-9.9h1.98a1.258,1.258,0,0,1-.146-.427,3.184,3.184,0,0,1-.034-.473,2.6,2.6,0,0,1,.787-1.912A2.6,2.6,0,0,1,86.3-880a2.36,2.36,0,0,1,1.249.349,3.953,3.953,0,0,1,1,.866l.45.585.45-.585a3.264,3.264,0,0,1,.99-.878A2.48,2.48,0,0,1,91.7-880a2.6,2.6,0,0,1,1.912.788A2.6,2.6,0,0,1,94.4-877.3a3.185,3.185,0,0,1-.034.473,1.258,1.258,0,0,1-.146.427H96.2a1.734,1.734,0,0,1,1.271.529A1.733,1.733,0,0,1,98-874.6v9.9a1.733,1.733,0,0,1-.529,1.271,1.733,1.733,0,0,1-1.271.529H81.8a1.733,1.733,0,0,1-1.271-.529A1.733,1.733,0,0,1,80-864.7v-9.9a1.733,1.733,0,0,1,.529-1.271A1.734,1.734,0,0,1,81.8-876.4Zm0,7.2H96.2v-5.4H91.61l1.89,2.565L92.06-871,89-875.14,85.94-871l-1.44-1.035,1.845-2.565H81.8Zm4.5-7.2a.871.871,0,0,0,.641-.259.871.871,0,0,0,.259-.641.871.871,0,0,0-.259-.641.871.871,0,0,0-.641-.259.871.871,0,0,0-.641.259.871.871,0,0,0-.259.641.871.871,0,0,0,.259.641A.871.871,0,0,0,86.3-876.4Zm5.4,0a.871.871,0,0,0,.641-.259.871.871,0,0,0,.259-.641.871.871,0,0,0-.259-.641.871.871,0,0,0-.641-.259.871.871,0,0,0-.641.259.871.871,0,0,0-.259.641.871.871,0,0,0,.259.641A.871.871,0,0,0,91.7-876.4Z"
			transform="translate(-77 883.45)"
			fill="white"
		/>
	</SvgIcon>
);

export const LicenseGroupLineIcon = (props: SvgIconProps) => (
	<SvgIcon version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16">
		<g id="Layer_2" className="st0-LicenseGroupLineIcon">
			<rect
				x="3.8"
				y="2.7"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="1.6"
				height="12.1"
			/>
			<rect
				x="1.5"
				y="10.8"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="1.6"
				height="3.8"
			/>
			<rect
				x="13"
				y="11"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="1.6"
				height="3.8"
			/>
			<rect
				x="5.2"
				y="9.4"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="7.2"
				height="3.4"
			/>
			<rect
				x="4.6"
				y="11"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="1.6"
				height="3.8"
			/>
			<rect
				x="9.5"
				y="10.8"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="2.9"
				height="3.8"
			/>
			<rect
				x="4.5"
				y="1.2"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="7"
				height="3.2"
			/>
			<rect
				x="10.8"
				y="2.7"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="1.6"
				height="7.1"
			/>
			<rect
				x="7.1"
				y="4.2"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="2"
				height="5.4"
			/>
			<rect
				x="4.2"
				y="5.9"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="7"
				height="2"
			/>
		</g>
		<g id="Layer_1">
			<path
				className="st2-LicenseGroupLineIcon"
				style={{ fill: 'none', stroke: props.htmlColor, strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				d="M3.4,10.6c-0.6,0.1-1.5,0.2-2.2,0.4v4"
			/>
			<path
				className="st2-LicenseGroupLineIcon"
				style={{ fill: 'none', stroke: props.htmlColor, strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				d="M12.8,15l0-12.5c-0.6-0.1-0.7-0.2-1.3-0.3v-1C10.2,1.1,9.2,1,8.1,1C7,1,6,1.1,4.7,1.4v1C4.2,2.4,4,2.5,3.4,2.6   l0,12.5"
			/>
			<rect
				x="5.4"
				y="7.9"
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				width="1.6"
				height="1.6"
			/>
			<rect
				x="5.4"
				y="4.3"
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				width="1.6"
				height="1.6"
			/>
			<rect
				x="9.2"
				y="7.9"
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				width="1.6"
				height="1.6"
			/>
			<rect
				x="9.2"
				y="4.3"
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				width="1.6"
				height="1.6"
			/>
			<path
				className="st2-LicenseGroupLineIcon"
				style={{ fill: 'none', stroke: props.htmlColor, strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				d="M12.8,10.6c0.6,0.1,1.5,0.2,2.2,0.4v4"
			/>
			<path
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				d="M9.6,15v-2.2c-0.7-0.2-1.3-0.2-1.7-0.2c-0.5,0-1.2,0.1-1.7,0.2V15"
			/>
			<line
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				x1="8"
				y1="15"
				x2="8"
				y2="12.6"
			/>
			<line
				className="st2-LicenseGroupLineIcon"
				style={{ fill: 'none', stroke: props.htmlColor, strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				x1="0.5"
				y1="15"
				x2="15.7"
				y2="15"
			/>
		</g>
	</SvgIcon>
);

export const WarningIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 13.818" {...props}>
		<path
			xmlns="http://www.w3.org/2000/svg"
			id="Icon_material-warning"
			data-name="Icon material-warning"
			d="M1.5,16.818h16L9.5,3Zm8.727-2.182H8.773V13.182h1.455Zm0-2.909H8.773V8.818h1.455Z"
			transform="translate(-1.5 -3)"
			// fill="#fa0"
		/>
	</SvgIcon>
);

export const WarningIconOutlined = (props: SvgIconProps) => (
	<SvgIcon
		id="warning-outline-modal-icon-light-mode"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		{...props}
	>
		<rect id="Rectangle_1949" data-name="Rectangle 1949" width="24" height="24" fill="none" />
		<path
			id="warning_FILL0_wght400_GRAD0_opsz20"
			d="M48-844.183,59.89-864l11.89,19.817Zm3.5-1.982H68.285L59.89-860.147Zm8.389-1.321a.973.973,0,0,0,.708-.283.943.943,0,0,0,.289-.7.973.973,0,0,0-.283-.708.944.944,0,0,0-.7-.289.973.973,0,0,0-.708.283.943.943,0,0,0-.289.7.973.973,0,0,0,.283.708A.944.944,0,0,0,59.884-847.486Zm-.985-3.3h1.982v-5.284H58.9ZM59.89-853.156Z"
			transform="translate(-47.89 866.09)"
			fill="#fdb634"
		/>
	</SvgIcon>
);

export const PinFilled = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
		<g id="Layer_1">
			<path
				className="st0-PinFilled"
				d="M15.3,8.3c0,0.1-0.1,0.3-0.3,0.3h-1c-0.1,0-0.3-0.1-0.3-0.3V7h-2.9c-0.3,0-0.5,0.1-0.7,0.3L8.8,8.8   C8.6,9,8.3,9.1,8.1,9.1H7.2C7.1,9.1,7,8.9,7,8.8V1.2C7,1,7.1,0.9,7.2,0.9h0.8c0.3,0,0.5,0.1,0.7,0.3l1.4,1.4   C10.4,2.9,10.7,3,10.9,3h2.9V1.7c0-0.1,0.1-0.3,0.3-0.3h1c0.1,0,0.3,0.1,0.3,0.3V8.3z M2.2,5.7c0.1,0,0.2,0,0.2,0h3.5V4.2H2.5   c-0.1,0-0.2,0-0.2,0L0.3,4.7C0.2,4.8,0.1,4.9,0.1,5c0,0.1,0.1,0.2,0.2,0.2L2.2,5.7z"
			/>
		</g>
		<g id="Layer_1_copy" className="st1-PinFilled">
			<path
				className="st2-PinFilled"
				d="M15.3,8.3c0,0.1-0.1,0.3-0.3,0.3h-1c-0.1,0-0.3-0.1-0.3-0.3V7h-2.9c-0.3,0-0.5,0.1-0.7,0.3L8.8,8.8   C8.6,9,8.3,9.1,8.1,9.1H7.2C7.1,9.1,7,8.9,7,8.8V1.2C7,1,7.1,0.9,7.2,0.9h0.8c0.3,0,0.5,0.1,0.7,0.3l1.4,1.4   C10.4,2.9,10.7,3,10.9,3h2.9V1.7c0-0.1,0.1-0.3,0.3-0.3h1c0.1,0,0.3,0.1,0.3,0.3V8.3z M2.2,5.7c0.1,0,0.2,0,0.2,0h3.5V4.2H2.5   c-0.1,0-0.2,0-0.2,0L0.3,4.7C0.2,4.8,0.1,4.9,0.1,5c0,0.1,0.1,0.2,0.2,0.2L2.2,5.7z"
			/>
		</g>
	</SvgIcon>
);

// export const TenantsFilled = (props: SvgIconProps) => (
// 	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
// 		{/* <style type="text/css">
// 			.st0-TenantsFilled{fill:currentColor;}
// 			.st1-TenantsFilled{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-miterlimit:10;}
// 			.st2-TenantsFilled{fill:none;stroke:currentColor;stroke-width:0.5;stroke-linejoin:round;stroke-miterlimit:10;}
// 		</style> */}
// 		<g id="Layer_2">
// 			<rect x="3.8" y="2.7" className="st0-TenantsFilled" width="1.6" height="12.1"/>
// 			<rect x="1.5" y="10.8" className="st0-TenantsFilled" width="1.6" height="3.8"/>
// 			<rect x="13" y="11" className="st0-TenantsFilled" width="1.6" height="3.8"/>
// 			<rect x="5.2" y="9.4" className="st0-TenantsFilled" width="7.2" height="3.4"/>
// 			<rect x="4.6" y="11" className="st0-TenantsFilled" width="1.6" height="3.8"/>
// 			<rect x="9.5" y="10.8" className="st0-TenantsFilled" width="2.9" height="3.8"/>
// 			<rect x="4.5" y="1.2" className="st0-TenantsFilled" width="7" height="3.2"/>
// 			<rect x="10.8" y="2.7" className="st0-TenantsFilled" width="1.6" height="7.1"/>
// 			<rect x="7.1" y="4.2" className="st0-TenantsFilled" width="2" height="5.4"/>
// 			<rect x="4.2" y="5.9" className="st0-TenantsFilled" width="7" height="2"/>
// 		</g>
// 		<g id="Layer_1">
// 			<path className="st1-TenantsFilled" d="M3.4,10.6c-0.6,0.1-1.5,0.2-2.2,0.4v4"/>
// 			<path className="st1-TenantsFilled" d="M12.8,15l0-12.5c-0.6-0.1-0.7-0.2-1.3-0.3v-1C10.2,1.1,9.2,1,8.1,1C7,1,6,1.1,4.7,1.4v1C4.2,2.4,4,2.5,3.4,2.6   l0,12.5"/>
// 			<rect x="5.4" y="7.9" className="st2-TenantsFilled" width="1.6" height="1.6"/>
// 			<rect x="5.4" y="4.3" className="st2-TenantsFilled" width="1.6" height="1.6"/>
// 			<rect x="9.2" y="7.9" className="st2-TenantsFilled" width="1.6" height="1.6"/>
// 			<rect x="9.2" y="4.3" className="st2-TenantsFilled" width="1.6" height="1.6"/>
// 			<path className="st1-TenantsFilled" d="M12.8,10.6c0.6,0.1,1.5,0.2,2.2,0.4v4"/>
// 			<path className="st2-TenantsFilled" d="M9.6,15v-2.2c-0.7-0.2-1.3-0.2-1.7-0.2c-0.5,0-1.2,0.1-1.7,0.2V15"/>
// 			<line className="st2-TenantsFilled" x1="8" y1="15" x2="8" y2="12.6"/>
// 			<line className="st1-TenantsFilled" x1="0.5" y1="15" x2="15.7" y2="15"/>
// 		</g>
// 	</SvgIcon>
// );

export const InviteAdminIcon = (props: SvgIconProps) => (
	<SvgIcon id="email" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
		<path id="Path_6175" data-name="Path 6175" d="M0,0H20V20H0Z" fill="none" />
		<path
			id="Path_6176"
			data-name="Path 6176"
			d="M18,5.5A1.557,1.557,0,0,0,16.4,4H3.6A1.557,1.557,0,0,0,2,5.5v9A1.557,1.557,0,0,0,3.6,16H16.4A1.557,1.557,0,0,0,18,14.5Zm-1.6,0L10,9.25,3.6,5.5Zm0,9H3.6V7L10,10.75,16.4,7Z"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const BlockSenderIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g transform="translate(3.85 4.45)">
			<g transform="translate(-2 -2.1)">
				<path
					d="M3.8,15v-.6a.67.67,0,0,1,.4-.7,10.019,10.019,0,0,1,5.1-1.4h.1a9.465,9.465,0,0,1,.5-1.8H9.3a11.07,11.07,0,0,0-6,1.7A2.772,2.772,0,0,0,2,14.5v2.4h8.5a4.981,4.981,0,0,1-1-1.9Z"
					fill={props.fill === undefined ? '#7d61bc' : props.htmlColor}
				/>
				<path
					d="M9.3,9.5A3.691,3.691,0,0,0,13,5.8,3.63,3.63,0,0,0,9.3,2.1,3.777,3.777,0,0,0,5.6,5.9,3.608,3.608,0,0,0,9.3,9.5Zm0-5.4a1.8,1.8,0,1,1,0,3.6A1.88,1.88,0,0,1,7.4,5.9,1.817,1.817,0,0,1,9.3,4.1Z"
					fill={props.fill === undefined ? '#7d61bc' : props.htmlColor}
				/>
			</g>

			<g transform="translate(-2 -2.1)">
				<path
					d="M14.2,9a4.1,4.1,0,1,0,4.1,4.1A4.118,4.118,0,0,0,14.2,9Zm-3.3,4.1a3.329,3.329,0,0,1,3.3-3.3,3.221,3.221,0,0,1,2,.7l-4.6,4.6A3.221,3.221,0,0,1,10.9,13.1Zm3.3,3.3a3.221,3.221,0,0,1-2-.7l4.6-4.6a3.456,3.456,0,0,1,.7,2A3.329,3.329,0,0,1,14.2,16.4Z"
					fill={props.fill === undefined ? '#7d61bc' : props.htmlColor}
				/>
			</g>
		</g>
	</SvgIcon>
);

export const BlockSenderEnabledIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" rx="4" fill="#ee4035" />
		<g transform="translate(3.85 4.45)">
			<g transform="translate(-2 -2.1)">
				<path
					d="M3.8,15v-.6a.67.67,0,0,1,.4-.7,10.019,10.019,0,0,1,5.1-1.4h.1a9.465,9.465,0,0,1,.5-1.8H9.3a11.07,11.07,0,0,0-6,1.7A2.772,2.772,0,0,0,2,14.5v2.4h8.5a4.981,4.981,0,0,1-1-1.9Z"
					fill="#fff"
				/>
				<path
					d="M9.3,9.5A3.691,3.691,0,0,0,13,5.8,3.63,3.63,0,0,0,9.3,2.1,3.777,3.777,0,0,0,5.6,5.9,3.608,3.608,0,0,0,9.3,9.5Zm0-5.4a1.8,1.8,0,1,1,0,3.6A1.88,1.88,0,0,1,7.4,5.9,1.817,1.817,0,0,1,9.3,4.1Z"
					fill="#fff"
				/>
			</g>

			<g transform="translate(-2 -2.1)">
				<path
					d="M14.2,9a4.1,4.1,0,1,0,4.1,4.1A4.118,4.118,0,0,0,14.2,9Zm-3.3,4.1a3.329,3.329,0,0,1,3.3-3.3,3.221,3.221,0,0,1,2,.7l-4.6,4.6A3.221,3.221,0,0,1,10.9,13.1Zm3.3,3.3a3.221,3.221,0,0,1-2-.7l4.6-4.6a3.456,3.456,0,0,1,.7,2A3.329,3.329,0,0,1,14.2,16.4Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const RefreshIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z" />
		</g>
	</SvgIcon>
);

export const RefreshInviteIcon = (props: SvgIconProps) => (
	<SvgIcon
		id="email-resend"
		xmlns="http://www.w3.org/2000/svg"
		width="19.2"
		height="19.2"
		viewBox="0 0 19.2 19.2"
		{...props}
	>
		<g id="Layer_1_00000112633164956032736890000004167970257456723332_" transform="translate(-0.4 -0.4)">
			<g id="Group_742" data-name="Group 742">
				<rect
					id="Rectangle_660"
					data-name="Rectangle 660"
					width="19.2"
					height="19.2"
					transform="translate(0.4 0.4)"
					fill="none"
				/>
				<path
					id="Path_6179"
					data-name="Path 6179"
					d="M16.4,3.6H3.6A1.58,1.58,0,0,0,2,5.2v9.6a1.58,1.58,0,0,0,1.6,1.6H10V14.8H3.6v-8l6.4,4,6.4-4v4H18V5.2A1.58,1.58,0,0,0,16.4,3.6ZM10,9.2l-6.4-4H16.4Z"
					fill="currentColor"
				/>
			</g>
		</g>
		<g id="Layer_2_00000081623741961431659490000008462199773130730892_" transform="translate(-0.4 -0.4)">
			<path
				id="Path_6180"
				data-name="Path 6180"
				d="M17.7,13a4,4,0,0,0-2.6-1,3.6,3.6,0,1,0,0,7.2,3.547,3.547,0,0,0,3.5-2.7h-1A2.848,2.848,0,0,1,15,18.3a2.7,2.7,0,0,1,0-5.4,2.732,2.732,0,0,1,1.9.8l-1.4,1.4h3.2V11.9Z"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const CancelInviteIcon = (props: SvgIconProps) => (
	<SvgIcon id="email-cancel" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
		<g id="Layer_1_00000135651656977560700910000016907287840043262643_">
			<g id="Group_741" data-name="Group 741">
				<rect id="Rectangle_659" data-name="Rectangle 659" width="20" height="20" fill="none" />
				<path
					id="Path_6177"
					data-name="Path 6177"
					d="M16.7,3.3H3.3A1.666,1.666,0,0,0,1.7,5V15a1.752,1.752,0,0,0,1.7,1.7H10V15H3.3V6.7L10,10.9l6.7-4.2v4.2h1.7V5A1.828,1.828,0,0,0,16.7,3.3ZM10,9.2,3.3,5H16.6Z"
					fill="currentColor"
				/>
			</g>
		</g>
		<g id="Layer_2_00000052801258203231353290000008295030710211312045_">
			<path
				id="Path_6178"
				data-name="Path 6178"
				d="M18.3,12.8l-.6-.6L15,14.8l-2.6-2.6-.6.6,2.6,2.6L11.8,18l.6.6L15,16l2.6,2.6.6-.6-2.6-2.6Z"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const EditAdminIcon = (props: SvgIconProps) => (
	<SvgIcon
		id="contact_page_black_24dp"
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		{...props}
	>
		<rect id="Rectangle_662" data-name="Rectangle 662" width="20" height="20" fill="none" />
		<path
			id="Path_6184"
			data-name="Path 6184"
			d="M10.878,3.6,14.5,7.464V16.4h-9V3.6h5.378M11.5,2h-6A1.557,1.557,0,0,0,4,3.6V16.4A1.557,1.557,0,0,0,5.5,18h9A1.557,1.557,0,0,0,16,16.4V6.8L11.5,2ZM10,11.6a1.6,1.6,0,0,0,0-3.2,1.6,1.6,0,0,0,0,3.2Zm3,2.744a1.615,1.615,0,0,0-.915-1.48,4.917,4.917,0,0,0-4.17,0A1.615,1.615,0,0,0,7,14.344V14.8h6Z"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const DeviceIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<style type="text/css">{`
            .st0-DeviceIcon{fill:none;stroke:currentColor;stroke-width:1.9642;stroke-miterlimit:10;}
            .st1-DeviceIcon{fill:none;stroke:currentColor;stroke-width:1.9766;stroke-miterlimit:10;}
        `}</style>
		<line className="st0-DeviceIcon" x1="14" y1="8.7" x2="14" y2="22.8" />
		<path
			className="st1-DeviceIcon"
			d="M13.6,8.7h5.9c0.6,0,1-0.5,1-1V5.2c0-0.6-0.5-1-1-1h-5.9c-0.6,0-1,0.5-1,1v2.5C12.6,8.3,13.1,8.7,13.6,8.7z"
		/>
		<line className="st0-DeviceIcon" x1="4.1" y1="7.6" x2="12.4" y2="7.6" />
		<path
			className="st0-DeviceIcon"
			d="M19.5,22.9H4.8c-0.6,0-1-0.5-1-1V2.3c0-0.6,0.5-1,1-1h5.3v0.8l9.4-0.8c0.6,0,1,0.5,1,1V22
	C20.5,22.5,20.1,22.9,19.5,22.9z"
		/>
	</SvgIcon>
);

export const StopShareIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<style type="text/css">{`
			.st0-StopShareIcon{fill:none;}
			.st1-StopShareIcon{fill:currentColor;}
		`}</style>
		<g>
			<path className="st0-StopShareIcon" d="M0,0h24v24H0V0z" />
		</g>
		<g>
			<path
				className="st1-StopShareIcon"
				d="M15.7,3H8.3L3,8.3v7.5L8.3,21h7.5l5.3-5.3V8.3L15.7,3z M19,14.9L14.9,19H9.1L5,14.9V9.1L9.1,5h5.8L19,9.1V14.9
				z M14.8,7.8L12,10.6L9.2,7.8L7.8,9.2l2.8,2.8l-2.8,2.8l1.4,1.4l2.8-2.8l2.8,2.8l1.4-1.4L13.4,12l2.8-2.8L14.8,7.8z"
			/>
		</g>
	</SvgIcon>
);

// export const FormIcon = (props: Omit<MdiIconProps, 'path'>) => (
// 	<MdiIcon
// 		path={mdiIcons.mdiFormatListBulletedSquare}
// 		{...props}
// 		className={clsx('mdi-svg-icon', props.className)}
// 	/>
// );
export const FormIcon = ListIcon;

export const NamingIcon = ListIcon;

export const NotificationsIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M17,11H15V9H17V11M13,11H11V9H13V11M9,11H7V9H9V11Z" />
	</SvgIcon>
);

export const WorkflowIcon = (props: Omit<MdiIconProps, 'path'>) => (
	<MdiIcon path={mdiIcons.mdiPlay} {...props} className={clsx('mdi-svg-icon', props.className)} />
);

export const PolicyIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			d="M23.4,14.4c-0.1,0-0.2,0-0.3-0.2c-1-1.9-2-3.9-3-5.8c0,0,0-0.1-0.1-0.1c0.4-0.1,0.8-0.2,1.2-0.4
	c0.5-0.2,0.7-0.8,0.5-1.3c-0.2-0.5-0.8-0.8-1.3-0.5c-0.9,0.4-1.8,0.4-2.6-0.1c-0.1,0-0.1-0.1-0.2-0.1c-1.3-0.7-2.7-1-4.2-1
	c-0.3,0-0.5,0-0.8,0c0.7-0.3,1.2-1,1.2-1.8c0-1.1-0.9-1.9-1.9-1.9S10.1,2,10.1,3c0,0.8,0.5,1.5,1.2,1.8c-0.2,0-0.4,0-0.7,0
	C9,4.9,7.4,5.3,6,6.1c-0.8,0.4-1.6,0.4-2.4,0C3,5.8,2.5,6,2.2,6.6C2,7.1,2.2,7.6,2.8,7.9C3.1,8.1,3.5,8.2,4,8.3
	C3.9,8.4,3.9,8.4,3.8,8.5c-1,1.9-1.9,3.7-2.9,5.6c-0.1,0.2-0.2,0.3-0.5,0.3c-0.2,0-0.4,0.1-0.5,0.2v0.2c0.4,1.4,1.4,2.1,2.7,2.5
	c1.7,0.5,3.4,0.5,5-0.3c0.6-0.3,1.1-0.7,1.5-1.2c0.2-0.3,0.3-0.6,0.4-0.9c0-0.3-0.1-0.5-0.3-0.4c-0.4,0-0.5-0.1-0.6-0.4
	c-0.9-1.8-1.9-3.6-2.8-5.4C5.6,8.3,5.6,8.3,6,8.2c0.7-0.1,1.4-0.3,2-0.6c0.7-0.3,1.3-0.5,2.1-0.6c0.3,0,0.3,0,0.3,0.3
	c0,3.9,0,7.7,0,11.6c0,0.2,0,0.3-0.2,0.3c-0.7,0.1-1.3,0.7-1.4,1.4c0,0.2-0.1,0.2-0.2,0.2c-0.5,0-0.9,0-1.3,0c-1,0-1.6,0.6-1.6,1.6
	h12.8c0-0.9-0.7-1.6-1.6-1.6c-0.5,0-0.9,0-1.4,0c-0.1,0-0.2,0-0.2-0.2c-0.1-0.7-0.7-1.3-1.4-1.4c-0.1,0-0.2,0-0.2-0.2
	c0-3.9,0-7.8,0-11.8C13.6,7,13.7,7,13.8,7c0.6,0.1,1.2,0.2,1.8,0.5c0.8,0.3,1.7,0.6,2.6,0.7c0.2,0,0.1,0.2,0.1,0.2
	c-0.7,1.3-1.4,2.6-2,3.9c-0.3,0.6-0.6,1.2-0.9,1.8c-0.1,0.1-0.1,0.2-0.3,0.2c-0.1,0-0.1,0-0.2,0c-0.3,0-0.4,0.2-0.3,0.4
	c0.1,0.7,0.6,1.2,1.1,1.7c0.8,0.6,1.6,0.9,2.6,1c1.3,0.2,2.7,0.1,3.9-0.5c0.7-0.3,1.2-0.8,1.6-1.4c0.1-0.2,0.2-0.5,0.3-0.8v-0.2
	C23.9,14.4,23.7,14.4,23.4,14.4L23.4,14.4z M7.2,14.4H2.4c0.8-1.5,1.6-3,2.4-4.5C5.6,11.4,6.4,12.9,7.2,14.4z M16.8,14.4
	c0.8-1.5,1.6-3,2.4-4.5c0.8,1.5,1.6,3,2.4,4.5H16.8z"
		/>
	</SvgIcon>
);

export const AssignPolicyIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M0 0h24v24H0z" fill="none" />
		<path d="M0 0h24v24H0z" fill="none" />
		<path d="M13.22 22.61c-.4.15-.8.29-1.22.39-5.16-1.26-9-6.45-9-12V5l9-4 9 4v6c0 .9-.11 1.78-.3 2.65-.81-.41-1.73-.65-2.7-.65-3.31 0-6 2.69-6 6 0 1.36.46 2.61 1.22 3.61zM19 20v2.99s-1.99.01-2 0V20h-3v-2h3v-3h2v3h3v2h-3z" />
	</SvgIcon>
);

export const ViewIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M0 0h24v24H0z" fill="none" />
		<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
	</SvgIcon>
);

export const GenerateIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" {...props}>
		<g id="Generate_icon" data-name="Generate icon" transform="translate(-17)">
			<path
				id="_Color"
				data-name=" â†³Color"
				d="M11,16a7.943,7.943,0,0,1-4.26-1.24L8.2,13.3A5.886,5.886,0,0,0,11,14a6.007,6.007,0,0,0,6-6H14l4-4,4,4H19A8.01,8.01,0,0,1,11,16ZM4,12H4L0,8H3A7.986,7.986,0,0,1,15.26,1.24L13.8,2.7A5.886,5.886,0,0,0,11,2,6.007,6.007,0,0,0,5,8H8L4,12Z"
				transform="translate(17 0)"
				fill="#603fa5"
			/>
		</g>
	</SvgIcon>
);

export const FolderClosedIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<rect id="Rectangle_3375" data-name="Rectangle 3375" width="24" height="24" fill="none" />
		<path
			id="folder_24dp_5F6368_FILL0_wght400_GRAD0_opsz24_1_"
			data-name="folder_24dp_5F6368_FILL0_wght400_GRAD0_opsz24 (1)"
			d="M81.9-784.8a1.829,1.829,0,0,1-1.342-.558A1.829,1.829,0,0,1,80-786.7v-11.4a1.83,1.83,0,0,1,.558-1.342A1.83,1.83,0,0,1,81.9-800h5.7l1.9,1.9h7.6a1.83,1.83,0,0,1,1.342.558A1.83,1.83,0,0,1,99-796.2v9.5a1.829,1.829,0,0,1-.558,1.342,1.829,1.829,0,0,1-1.342.558Zm0-1.9H97.1v-9.5H88.716l-1.9-1.9H81.9Zm0,0v0Z"
			transform="translate(-77.5 804.469)"
			fill={props.htmlColor ?? '#7d61bc'}
		/>
	</SvgIcon>
);

export const FolderOpenIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			id="folder_open_24dp_5F6368_FILL0_wght400_GRAD0_opsz24_1_"
			data-name="folder_open_24dp_5F6368_FILL0_wght400_GRAD0_opsz24 (1)"
			d="M81.767-785.86a1.7,1.7,0,0,1-1.248-.519A1.7,1.7,0,0,1,80-787.628v-10.6a1.7,1.7,0,0,1,.519-1.248A1.7,1.7,0,0,1,81.767-800h5.3l1.767,1.767h7.07a1.7,1.7,0,0,1,1.248.519,1.7,1.7,0,0,1,.519,1.248H88.108l-1.767-1.767H81.767v10.6l2.121-7.07H99l-2.276,7.578a1.723,1.723,0,0,1-.652.917,1.754,1.754,0,0,1-1.049.342Zm1.856-1.767h11.4l1.591-5.3h-11.4Zm0,0,1.591-5.3Zm-1.856-8.837v0Z"
			transform="translate(-77.5 804.93)"
			fill="#7d61bc"
		/>
		<rect id="Rectangle_3374" data-name="Rectangle 3374" width="24" height="24" fill="none" />
	</SvgIcon>
);

export const DocManagementIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Rectangle_3793" data-name="Rectangle 3793" width="24" height="24" fill="none" />
		<path
			id="_Color"
			data-name=" â†³Color"
			d="M5.26,0,2.98,2.272.7,0,0,.7,2.98,3.675,5.96.7Z"
			transform="translate(23.02 18)"
			fill="currentColor"
		/>
		<path
			id="home_storage_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
			d="M145.369-790.659l-1.909-11.434h17.491l-1.909,11.434Zm1.3-1.559h11.07l1.325-8.316H145.345Zm3.456-4.418h4.158a.754.754,0,0,0,.555-.224.755.755,0,0,0,.224-.556.753.753,0,0,0-.224-.555.754.754,0,0,0-.555-.224h-4.158a.754.754,0,0,0-.555.224.755.755,0,0,0-.224.556.754.754,0,0,0,.224.556A.755.755,0,0,0,150.127-796.636Zm-4.158-6.7a.754.754,0,0,1-.555-.224.755.755,0,0,1-.224-.556.753.753,0,0,1,.224-.555.754.754,0,0,1,.555-.224h12.474a.753.753,0,0,1,.555.224.754.754,0,0,1,.224.555.753.753,0,0,1-.224.555.754.754,0,0,1-.555.224Zm2.079-2.8a.754.754,0,0,1-.555-.224.754.754,0,0,1-.224-.556.753.753,0,0,1,.224-.555.754.754,0,0,1,.555-.224h8.316a.754.754,0,0,1,.555.224.755.755,0,0,1,.224.556.753.753,0,0,1-.224.555.754.754,0,0,1-.555.224Zm-1.377,13.913h0Z"
			transform="translate(-140.123 812.092)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const MyFilesIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="26"
		height="26"
		viewBox="0 0 26 26"
		overflow="visible"
	>
		<path
			id="Union_107"
			data-name="Union 107"
			d="M14019.9,1221.025a1.9,1.9,0,0,1-1.9-1.9v-11.4a1.9,1.9,0,0,1,1.9-1.9h.9v-2.582a1.247,1.247,0,0,1,1.25-1.244h11.5a1.245,1.245,0,0,1,1.251,1.244v4.481h.3a1.913,1.913,0,0,1,1.9,1.9v9.5a1.907,1.907,0,0,1-1.9,1.9Zm-.388-1.539h16.021l-.046-10.23h-8.817l-1.874-1.9h-5.3Zm0,0-.018-12.126Zm6.087-13.658,1.9,1.9h6.3v-4.481a.248.248,0,0,0-.25-.247h-11.5a.25.25,0,0,0-.25.247v2.582Zm1.9,1.173v-1h5.549v1Zm-5-2v-1h10.547v1Z"
			transform="translate(-14014 -1199.001)"
			fill="currentColor"
		/>
		<rect id="Rectangle_4227" data-name="Rectangle 4227" width="26" height="26" fill="none" />
	</SvgIcon>
);

export const ShareFileIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Boundary" width="24" height="24" fill="none" />
		<g id="Group_3177" data-name="Group 3177" transform="translate(1.787 6.172)">
			<path
				id="group_add_FILL1_wght400_GRAD0_opsz48"
				d="M4.3,20.6V18.838a2.163,2.163,0,0,1,1.276-1.989,14.853,14.853,0,0,1,2.412-.863,9.215,9.215,0,0,1,2.224-.263,9.1,9.1,0,0,1,2.215.263,14.994,14.994,0,0,1,2.4.863,2.191,2.191,0,0,1,.938.8,2.1,2.1,0,0,1,.357,1.192V20.6Zm5.912-6.024A2.7,2.7,0,0,1,7.4,11.763a2.7,2.7,0,0,1,2.815-2.815,2.7,2.7,0,0,1,2.815,2.815,2.7,2.7,0,0,1-2.815,2.815Zm2.984-.094a4.349,4.349,0,0,0,.723-1.239,4.288,4.288,0,0,0,.235-1.483,4.288,4.288,0,0,0-.235-1.483A4.349,4.349,0,0,0,13.2,9.042a3.04,3.04,0,0,1,2.505.432,2.6,2.6,0,0,1,1.079,2.29,2.6,2.6,0,0,1-1.079,2.29A3.04,3.04,0,0,1,13.2,14.484ZM17.25,20.6V18.838a3.444,3.444,0,0,0-.488-1.783,3.7,3.7,0,0,0-1.689-1.389,11.385,11.385,0,0,1,4.439,1.2A2.313,2.313,0,0,1,20.7,18.838V20.6Z"
				transform="translate(-0.277 -8.946)"
				fill="currentColor"
			/>
			<path
				id="group_add_FILL1_wght400_GRAD0_opsz48-2"
				data-name="group_add_FILL1_wght400_GRAD0_opsz48"
				d="M2.367,18.7V16.337H0v-1.42H2.367V12.55h1.42v2.367H6.154v1.42H3.787V18.7Z"
				transform="translate(0 -10.781)"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const PropertiesIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Rectangle_4222" data-name="Rectangle 4222" width="24" height="24" fill="none" />
		<path
			id="Union_104"
			data-name="Union 104"
			d="M11.011,19l-.2-1.192a3.764,3.764,0,0,1-.752-.3,2.991,2.991,0,0,1-.621-.458l-1.145.392-.771-1.258L8.44,15.4a3.339,3.339,0,0,1,0-1.685l-.921-.789.771-1.258,1.145.392a2.7,2.7,0,0,1,.621-.463,3.961,3.961,0,0,1,.752-.291l.2-1.192h1.5l.2,1.192a3.961,3.961,0,0,1,.752.291,2.7,2.7,0,0,1,.621.463l1.145-.392.771,1.258-.922.789a3.339,3.339,0,0,1,0,1.685l.922.788-.771,1.258-1.145-.392a2.991,2.991,0,0,1-.621.458,3.764,3.764,0,0,1-.752.3L12.515,19Zm-.717-5.907a2.075,2.075,0,1,0,2.938,2.931,2.075,2.075,0,1,0-2.938-2.931ZM1.812,19a1.751,1.751,0,0,1-1.286-.525A1.743,1.743,0,0,1,0,17.192V1.808A1.743,1.743,0,0,1,.526.525,1.752,1.752,0,0,1,1.812,0H9.774l5.263,5.25v4.807l-1.5-.6V6H9.022V1.5H1.812a.3.3,0,0,0-.212.1.293.293,0,0,0-.1.212V17.192a.293.293,0,0,0,.1.212.3.3,0,0,0,.212.1H6.524L7.416,19ZM1.5,17.5v0Z"
			transform="translate(3.996 2.5)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const RenameIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="22"
		viewBox="0 0 22 22"
		overflow="visible"
	>
		<g id="Icon_feather-edit-3" transform="translate(-3.25 -3.818)">
			<path
				id="Path_5658"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: '1.4932',
					strokeLinecap: 'round',
					strokeLinejoin: 'round',
				}}
				d="M4.2,23.3h20.2"
			/>
			<path
				id="Path_5659"
				style={{
					fill: 'currentColor',
					stroke: 'currentColor',
					strokeWidth: '1.4932',
					strokeLinecap: 'round',
					strokeLinejoin: 'round',
				}}
				d="M17.9,6.9c0.7-0.8,1.9-0.8,2.7-0.1c0,0,0.1,0.1,0.1,0.1c0.8,0.8,0.8,2.1,0,3L9,22.3l-3.7,1
		l0.9-4L17.9,6.9z"
			/>
		</g>
	</SvgIcon>
);

export const FavoriteIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Rectangle_4220" data-name="Rectangle 4220" width="24" height="24" rx="4" fill="#4b9c14" opacity="0" />
		<path
			id="favorite-dark-mode-icon"
			d="M87.227-864.359l3.324-2,3.323,2.031-.87-3.8,2.928-2.532-3.851-.343-1.53-3.587-1.53,3.561-3.851.343L88.1-868.13Zm-3.192,4.4,1.715-7.412L80-872.351l7.6-.659L90.551-880l2.954,6.99,7.6.659-5.75,4.985,1.714,7.412-6.515-3.93ZM90.551-869.185Z"
			transform="translate(-78.551 881.977)"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const FavoriteActiveIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect
			id="Rectangle_4220"
			data-name="Rectangle 4220"
			width="24"
			height="24"
			rx="4"
			fill="rgba(245,190,5,0.97)"
		/>
		<path
			id="favorite-dark-mode-icon"
			d="M87.227-864.359l3.324-2,3.323,2.031-.87-3.8,2.928-2.532-3.851-.343-1.53-3.587-1.53,3.561-3.851.343L88.1-868.13Zm-3.192,4.4,1.715-7.412L80-872.351l7.6-.659L90.551-880l2.954,6.99,7.6.659-5.75,4.985,1.714,7.412-6.515-3.93ZM90.551-869.185Z"
			transform="translate(-78.551 881.977)"
			fill="#fff"
		/>
	</SvgIcon>
);

export const ChangeOwnerIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Boundary" width="24" height="24" fill="none" />
		<g id="Group_7867" data-name="Group 7867" transform="translate(4.391 4.588)">
			<path
				id="supervisor_account_FILL0_wght400_GRAD0_opsz24"
				d="M484-556a1.932,1.932,0,0,1-1.42-.58A1.931,1.931,0,0,1,482-558a1.931,1.931,0,0,1,.58-1.42A1.931,1.931,0,0,1,484-560a1.931,1.931,0,0,1,1.42.58A1.931,1.931,0,0,1,486-558a1.931,1.931,0,0,1-.58,1.42A1.931,1.931,0,0,1,484-556Zm-4,4v-1.12a1.679,1.679,0,0,1,.25-.89,1.408,1.408,0,0,1,.71-.59,7.677,7.677,0,0,1,1.49-.45,8.085,8.085,0,0,1,1.55-.15,8.084,8.084,0,0,1,1.55.15,7.677,7.677,0,0,1,1.49.45,1.408,1.408,0,0,1,.71.59,1.678,1.678,0,0,1,.25.89V-552Z"
				transform="translate(-480 560)"
				fill="currentColor"
			/>
			<path
				id="supervisor_account_FILL0_wght400_GRAD0_opsz24-2"
				data-name="supervisor_account_FILL0_wght400_GRAD0_opsz24"
				d="M484-556a1.932,1.932,0,0,1-1.42-.58A1.932,1.932,0,0,1,482-558a1.931,1.931,0,0,1,.58-1.42A1.931,1.931,0,0,1,484-560a1.931,1.931,0,0,1,1.42.58A1.931,1.931,0,0,1,486-558a1.931,1.931,0,0,1-.58,1.42A1.931,1.931,0,0,1,484-556Zm-4,4v-1.12a1.679,1.679,0,0,1,.25-.89,1.408,1.408,0,0,1,.71-.59,7.672,7.672,0,0,1,1.49-.45,8.08,8.08,0,0,1,1.55-.15,8.079,8.079,0,0,1,1.55.15,7.671,7.671,0,0,1,1.49.45,1.408,1.408,0,0,1,.71.59,1.678,1.678,0,0,1,.25.89V-552Z"
				transform="translate(-472.187 566.823)"
				fill="currentColor"
			/>
			<path
				id="repeat_one_FILL0_wght400_GRAD0_opsz24"
				d="M1.618,4.446,0,2.828,1.618,1.211l.566.586-.627.627H4.319V0h.809V3.233H1.557l.627.627Z"
				transform="translate(6.223 9) rotate(90)"
				fill="currentColor"
			/>
			<path
				id="repeat_one_FILL0_wght400_GRAD0_opsz24-2"
				data-name="repeat_one_FILL0_wght400_GRAD0_opsz24"
				d="M1.618,4.447,0,2.829,1.618,1.211l.566.587-.627.627H4.319V0h.809V3.234H1.557l.627.627Z"
				transform="translate(9.59 6.128) rotate(-90)"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const MoveFileIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<path
			id="drive_file_move_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
			d="M109.185-771.748l-1.578,1.578.94.94,3.187-3.187-3.187-3.187-.94.94,1.578,1.578h-3.97v1.338Zm-7.573,5.13a1.557,1.557,0,0,1-1.144-.468,1.556,1.556,0,0,1-.468-1.144v-10.156a1.557,1.557,0,0,1,.468-1.144,1.557,1.557,0,0,1,1.144-.468h4.9l1.784,1.784h7.042a1.557,1.557,0,0,1,1.144.468,1.557,1.557,0,0,1,.468,1.144v8.372a1.557,1.557,0,0,1-.468,1.144,1.557,1.557,0,0,1-1.144.468Zm0-1.338h13.724a.267.267,0,0,0,.2-.077.267.267,0,0,0,.077-.2V-776.6a.267.267,0,0,0-.077-.2.267.267,0,0,0-.2-.077h-7.59l-1.784-1.784h-4.351a.267.267,0,0,0-.2.077.267.267,0,0,0-.077.2v10.156a.267.267,0,0,0,.077.2A.267.267,0,0,0,101.613-767.957Zm-.275,0v0Z"
			transform="translate(-96 785.618)"
			fill="currentColor"
		/>
		<rect id="Rectangle_3977" data-name="Rectangle 3977" width="24" height="24" fill="none" />
	</SvgIcon>
);

export const JpgFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<rect id="Rectangle_3862" data-name="Rectangle 3862" width="24" height="24" fill="none" />
		<g id="Group_9717" data-name="Group 9717" transform="translate(-306 -577)">
			<path
				id="Path_10092"
				data-name="Path 10092"
				d="M4.26,0H12a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4.2Z"
				transform="translate(311.25 580.199)"
				fill="#fff"
			/>
			<path
				id="Path_10087_-_Outline"
				data-name="Path 10087 - Outline"
				d="M4.531.45.492,4.292.45,16.5A1.552,1.552,0,0,0,2,18.05H12.5a1.552,1.552,0,0,0,1.55-1.55V2A1.552,1.552,0,0,0,12.5.45M4.461,0H12.5a2,2,0,0,1,2,2V16.5a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4.292Z"
				transform="translate(311 580)"
				fill="#707070"
			/>
			<path
				id="Path_10086_-_Outline"
				data-name="Path 10086 - Outline"
				d="M1.1,3.99H3.281a.793.793,0,0,0,.8-.783l.072-2.12M4.6.174,4.531,3.207A1.242,1.242,0,0,1,3.281,4.44H.1Z"
				transform="translate(310.949 579.9)"
				fill="#707070"
			/>
			<path
				id="Path_10086"
				data-name="Path 10086"
				d="M-17341.631-13639.286l3.9-3.431,1.473,1.449,2.553-2.584,3.406,4.48Z"
				transform="translate(17654.131 14230.818)"
				fill="#707070"
			/>
			<g id="Group_9716" data-name="Group 9716" transform="translate(0 -1)">
				<rect
					id="Rectangle_3861"
					data-name="Rectangle 3861"
					width="8"
					height="3.5"
					rx="1"
					transform="translate(314 594)"
					fill="#d7d7d7"
				/>
				<path
					id="Path_10087"
					data-name="Path 10087"
					d="M-.012-.345.216-.36A.248.248,0,0,0,.393-.428.263.263,0,0,0,.45-.612v-1.5H.921v1.5A.577.577,0,0,1,.294.015L.015.03Zm1.323-1.77h.972a.771.771,0,0,1,.537.174.622.622,0,0,1,.192.486.622.622,0,0,1-.192.486.771.771,0,0,1-.537.174h-.5V0H1.311Zm.912.966q.351,0,.351-.3a.289.289,0,0,0-.087-.231.4.4,0,0,0-.264-.075H1.779v.609ZM5.1-1.167V-.132a1.492,1.492,0,0,1-.36.117,2.137,2.137,0,0,1-.426.042A1.225,1.225,0,0,1,3.735-.1a.9.9,0,0,1-.378-.375,1.2,1.2,0,0,1-.132-.581,1.2,1.2,0,0,1,.13-.574.9.9,0,0,1,.374-.377A1.17,1.17,0,0,1,4.3-2.142a1.383,1.383,0,0,1,.424.063.926.926,0,0,1,.326.174L4.9-1.572a1.092,1.092,0,0,0-.286-.151.948.948,0,0,0-.3-.046q-.612,0-.612.711a.805.805,0,0,0,.159.546.607.607,0,0,0,.48.18,1.35,1.35,0,0,0,.345-.045V-.843H4.269v-.324Z"
					transform="translate(315.564 596.806)"
					fill="#707070"
				/>
			</g>
			<g
				id="Ellipse_90"
				data-name="Ellipse 90"
				transform="translate(314.5 585)"
				fill="#fff"
				stroke="#707070"
				strokeWidth="1"
			>
				<circle cx="1" cy="1" r="1" stroke="none" />
				<circle cx="1" cy="1" r="0.5" fill="none" />
			</g>
		</g>
	</SvgIcon>
);

export const PdfFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<rect id="Rectangle_3862" data-name="Rectangle 3862" width="24" height="24" fill="none" />
		<g id="Group_9736" data-name="Group 9736">
			<path
				id="Path_10093"
				data-name="Path 10093"
				d="M4.26,0H12a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4.2Z"
				transform="translate(5.25 3.199)"
				fill="#fff"
			/>
			<g id="Group_9735" data-name="Group 9735" transform="translate(-453 -166.301)">
				<g id="Group_9717" data-name="Group 9717" transform="translate(147 -410.699)">
					<path
						id="Path_10087_-_Outline"
						data-name="Path 10087 - Outline"
						d="M4.531.45.492,4.292.45,16.5A1.552,1.552,0,0,0,2,18.05H12.5a1.552,1.552,0,0,0,1.55-1.55V2A1.552,1.552,0,0,0,12.5.45M4.461,0H12.5a2,2,0,0,1,2,2V16.5a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4.292Z"
						transform="translate(311 580)"
						fill="#ec2d25"
					/>
					<path
						id="Path_10086_-_Outline"
						data-name="Path 10086 - Outline"
						d="M1.1,3.99H3.281a.793.793,0,0,0,.8-.783l.072-2.12M4.6.174,4.531,3.207A1.242,1.242,0,0,1,3.281,4.44H.1Z"
						transform="translate(310.949 579.9)"
						fill="#ec2d25"
					/>
					<g id="Group_9716" data-name="Group 9716" transform="translate(0 -1)">
						<rect
							id="Rectangle_3861"
							data-name="Rectangle 3861"
							width="8"
							height="3.5"
							rx="1"
							transform="translate(314 594)"
							fill="#d7d7d7"
						/>
					</g>
					<path
						id="Path_10096"
						data-name="Path 10096"
						d="M.724-1.134H.873a.5.5,0,0,0,.313-.083.29.29,0,0,0,.1-.241A.3.3,0,0,0,1.2-1.693.408.408,0,0,0,.93-1.77H.724Zm1.025-.34a.655.655,0,0,1-.216.529.924.924,0,0,1-.615.183H.724V0H.27V-2.142H.954a.91.91,0,0,1,.593.168A.612.612,0,0,1,1.749-1.474Zm2.235.382a1.055,1.055,0,0,1-.3.81A1.228,1.228,0,0,1,2.814,0H2.207V-2.142H2.88a1.132,1.132,0,0,1,.814.277A1.018,1.018,0,0,1,3.984-1.091Zm-.472.012q0-.69-.609-.69H2.661V-.375h.195Q3.512-.375,3.512-1.08ZM4.929,0H4.482V-2.142H5.71v.372H4.929v.552h.727v.371H4.929Z"
						transform="translate(314.951 595.82)"
						fill="#707070"
					/>
				</g>
				<path
					id="Union_53"
					data-name="Union 53"
					d="M24436.2,23075.633a.544.544,0,0,1-.2-.443,1.436,1.436,0,0,1,.729-1.006,6.241,6.241,0,0,1,1.527-.771c.066-.027.133-.053.2-.078a20.068,20.068,0,0,0,1.057-2.18c.158-.383.291-.75.4-1.094a6.2,6.2,0,0,1-.242-.686c-.141-.473-.424-1.621-.111-2.129a.518.518,0,0,1,.344-.234.958.958,0,0,1,.129-.012.777.777,0,0,1,.65.344c.381.539.3,1.613-.25,3.184a6.71,6.71,0,0,0,.5.693c.037.049.074.092.1.135a10.968,10.968,0,0,0,.828.963c.307-.055.627-.1.957-.141a3.5,3.5,0,0,1,.564-.043,2.027,2.027,0,0,1,1.521.5.573.573,0,0,1,.154.465c-.049.344-.4.547-.957.547a3.1,3.1,0,0,1-1.141-.24,3.814,3.814,0,0,1-1.178-.82c-.687.121-1.16.238-1.461.318-.27.074-.8.275-1.111.4-1.115,2.049-2,2.479-2.545,2.479A.715.715,0,0,1,24436.2,23075.633Zm.865-.467a.975.975,0,1,0-.2-.779c-.387.27-.615.564-.621.811a.339.339,0,0,0,.027.135C24436.336,23075.447,24436.516,23075.594,24437.066,23075.166Zm5.785-2.742c-.258.031-.516.074-.76.109a3.377,3.377,0,0,0,.963.639,3.05,3.05,0,0,0,.912.217.482.482,0,0,0,.438-.455.473.473,0,0,0-.34-.475,2.946,2.946,0,0,0-.68-.072A3.888,3.888,0,0,0,24442.852,23072.424Zm-2.945-.564c-.172.393-.344.766-.514,1.1.3-.115.656-.244.871-.3.275-.072.7-.184,1.307-.293a10.545,10.545,0,0,1-.73-.859c-.031-.043-.068-.086-.105-.129-.135-.178-.275-.35-.41-.553C24440.207,23071.146,24440.066,23071.5,24439.906,23071.859Zm.043-4.6a.232.232,0,0,0-.172.123,2.988,2.988,0,0,0,.137,1.92c.037.131.078.254.119.371a5.86,5.86,0,0,0,.322-2.113.444.444,0,0,0-.262-.3.316.316,0,0,0-.059,0A.405.405,0,0,0,24439.949,23067.258Z"
					transform="translate(-23975.285 -22894.5)"
					fill="#eb3123"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const TxtFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<rect id="Rectangle_3862" data-name="Rectangle 3862" width="24" height="24" fill="none" />
		<g id="Group_9717" data-name="Group 9717" transform="translate(-306 -577)">
			<path
				id="Path_10092"
				data-name="Path 10092"
				d="M4.26,0H12a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4.2Z"
				transform="translate(311.25 580.199)"
				fill="#fff"
			/>
			<path
				id="Path_10087_-_Outline"
				data-name="Path 10087 - Outline"
				d="M4.531.45.492,4.292.45,16.5A1.552,1.552,0,0,0,2,18.05H12.5a1.552,1.552,0,0,0,1.55-1.55V2A1.552,1.552,0,0,0,12.5.45M4.461,0H12.5a2,2,0,0,1,2,2V16.5a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4.292Z"
				transform="translate(311 580)"
				fill="#707070"
			/>
			<path
				id="Path_10086_-_Outline"
				data-name="Path 10086 - Outline"
				d="M1.1,3.99H3.281a.793.793,0,0,0,.8-.783l.072-2.12M4.6.174,4.531,3.207A1.242,1.242,0,0,1,3.281,4.44H.1Z"
				transform="translate(310.949 579.9)"
				fill="#707070"
			/>
		</g>
		<g id="Group_10191" data-name="Group 10191" transform="translate(-553 -214.125)">
			<path
				id="Line_559"
				data-name="Line 559"
				d="M11,.375H0v-.75H11Z"
				transform="translate(559.75 223.5)"
				fill="#707070"
			/>
			<path
				id="Line_559-2"
				data-name="Line 559"
				d="M11,.375H0v-.75H11Z"
				transform="translate(559.75 225.5)"
				fill="#707070"
			/>
			<path
				id="Line_559-3"
				data-name="Line 559"
				d="M5.5.375H0v-.75H5.5Z"
				transform="translate(559.75 227.5)"
				fill="#707070"
			/>
		</g>
		<g id="Group_10192" data-name="Group 10192" transform="translate(-552.75 -214)">
			<g id="Group_9716" data-name="Group 9716" transform="translate(247 -364)">
				<rect
					id="Rectangle_3861"
					data-name="Rectangle 3861"
					width="8"
					height="3.5"
					rx="1"
					transform="translate(314 594)"
					fill="#d7d7d7"
				/>
			</g>
			<path
				id="Path_10098"
				data-name="Path 10098"
				d="M1.1,0H.642V-1.764H.06v-.378H1.677v.378H1.1ZM3.738,0H3.22l-.5-.81-.5.81H1.737l.71-1.1L1.783-2.142h.5l.461.771L3.2-2.142h.489L3.015-1.08Zm1.1,0H4.38V-1.764H3.8v-.378H5.416v.378H4.834Z"
				transform="translate(562.262 232.799)"
				fill="#707070"
				stroke="rgba(0,0,0,0)"
				strokeWidth="1"
			/>
		</g>
	</SvgIcon>
);

export const DownloadReportAndAttachmentsIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<g id="download-report-and-files-icon">
			<rect id="Rectangle_3961" data-name="Rectangle 3961" width="24" height="24" fill="none" />
		</g>
		<g id="Group_10120" data-name="Group 10120" transform="translate(-670.62 -168.545)">
			<path
				id="box_add_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
				d="M150.369-816.2h0Zm-9.073,0h0Zm.337-1.3h11.414l-.942-1.122a.336.336,0,0,0-.1-.066.265.265,0,0,0-.112-.025h-9.114a.266.266,0,0,0-.112.025.336.336,0,0,0-.1.066Zm3.983,5.575h3.456V-816.2h-3.456Zm3.707,6.6h-7.761a1.5,1.5,0,0,1-1.1-.459,1.5,1.5,0,0,1-.459-1.1v-10.1a1.581,1.581,0,0,1,.089-.527,1.49,1.49,0,0,1,.267-.466l1.213-1.467a1.407,1.407,0,0,1,.532-.421,1.6,1.6,0,0,1,.676-.147h9.12a1.615,1.615,0,0,1,.679.147,1.419,1.419,0,0,1,.537.421l1.221,1.484a1.529,1.529,0,0,1,.267.471c.059.17.081.115.081,4.042h-1.3l.008-2.761h-3.024v5.628H144.32V-816.2H141.3v9.322a.259.259,0,0,0,.075.191.259.259,0,0,0,.191.075h7.024a3.746,3.746,0,0,0,.313.691A4.413,4.413,0,0,0,149.323-805.311Z"
				transform="translate(533.971 991.73)"
				fill={props.htmlColor ?? '#7d61bc'}
			/>
			<g id="Group_10119" data-name="Group 10119" transform="translate(684.756 180.528)">
				<path
					id="file_save_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
					d="M181.2-854.84,184.367-858l-.907-.907-1.607,1.607v-3.935h-1.3v3.935l-1.607-1.607-.907.907Zm-3.257,2.7v-1.3h6.513v1.3Z"
					transform="translate(-177.946 861.24)"
					fill={props.htmlColor ?? '#7d61bc'}
				/>
			</g>
		</g>
	</SvgIcon>
);

export const GetReportOnlyIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3961" data-name="Rectangle 3961" width="24" height="24" fill="none" />
		<g id="Group_10116" data-name="Group 10116" transform="translate(-1.328 -0.402)">
			<g id="Group_10117" data-name="Group 10117" transform="translate(6.047 3.457)">
				<g id="Group_10121" data-name="Group 10121" transform="translate(0 0)">
					<path
						id="Union_54"
						data-name="Union 54"
						d="M0,7.538V4.5H4.889V7.538ZM0,3.759V3H7.211v.76Zm0-1.5V1.5H7.211v.76ZM0,.76V0H3.339V.76Z"
						transform="translate(1.973 4.604)"
						fill={props.htmlColor ?? '#7d61bc'}
					/>
					<path
						id="file_save_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
						d="M181.441-854.694l3.032-3.032-.869-.869-1.539,1.539v-3.77h-1.248v3.77l-1.539-1.539-.869.869Zm-3.12,2.584v-1.248h6.241v1.248Zm-6.817-3.328a1.446,1.446,0,0,1-1.059-.445,1.447,1.447,0,0,1-.445-1.059V-868.5a1.446,1.446,0,0,1,.445-1.059A1.446,1.446,0,0,1,171.5-870h5.777l4.785,4.785v2.565h-1.248v-1.941h-4.16v-4.16H171.5a.244.244,0,0,0-.176.08.245.245,0,0,0-.08.176v11.553a.244.244,0,0,0,.08.176.244.244,0,0,0,.176.08H176.5v1.248Zm-.256-1.248v0Z"
						transform="translate(-170 870)"
						fill={props.htmlColor ?? '#7d61bc'}
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const CloneIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
		/>
	</SvgIcon>
);

export const CloseIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M 0 0 h 24 v 24 H 0 z" fill="none" />
		<path d="M 21 6 a 1 1 1 0 0 -3 -3 L 18 3 L 12 9 L 6 3 a 1 1 1 0 0 -3 3 L 3 6 L 9 12 L 3 18 a 1 1 1 0 0 3 3 L 6 21 L 12 15 L 18 21 a 1 1 1 0 0 3 -3 L 21 18 L 15 12 z" />
	</SvgIcon>
);

export const FileCopyIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z"
		/>
	</SvgIcon>
);

export const NotSecureIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5M11,7H13V13H11M11,15H13V17H11"
		/>
	</SvgIcon>
);

export const OfflineStatusIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M19.43,19L21.5,21.11L20.12,22.5L18.03,20.41L15.91,22.53L14.5,21.11L16.61,19L14.5,16.86L15.88,15.47L18,17.59L20.12,15.47L21.55,16.9L19.43,19M21,11C21,11.9 20.9,12.78 20.71,13.65C20.13,13.35 19.5,13.15 18.81,13.05C18.93,12.45 19,11.83 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21L12.31,20.91C12.5,21.53 12.83,22.11 13.22,22.62L12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11Z"
		/>
	</SvgIcon>
);

export const PendingStatusIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M18 12A6.41 6.41 0 0 1 20.87 12.67A11.63 11.63 0 0 0 21 11V5L12 1L3 5V11C3 16.55 6.84 21.74 12 23C12.35 22.91 12.7 22.8 13 22.68A6.42 6.42 0 0 1 11.5 18.5A6.5 6.5 0 0 1 18 12M18 14.5V13L15.75 15.25L18 17.5V16A2.5 2.5 0 0 1 20.24 19.62L21.33 20.71A4 4 0 0 0 18 14.5M18 21A2.5 2.5 0 0 1 15.76 17.38L14.67 16.29A4 4 0 0 0 18 22.5V24L20.25 21.75L18 19.5Z"
		/>
	</SvgIcon>
);

export const NoPolicyStatusIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M1,4.27L3,6.27V11C3,16.55 6.84,21.74 12,23C13.87,22.54 15.57,21.56 16.97,20.24L19.23,22.5L20.5,21.22L2.28,3L1,4.27M12,21C8.25,20 5,15.54 5,11.22V8.27L15.59,18.86C14.53,19.89 13.3,20.65 12,21M21,5V11C21,13.28 20.35,15.5 19.23,17.4L17.77,15.95C18.54,14.5 19,12.84 19,11.22V6.3L12,3.18L7.16,5.34L5.65,3.82L12,1L21,5Z"
		/>
	</SvgIcon>
);

export const NotAssessedStatusIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18V21Z"
		/>
	</SvgIcon>
);

export const HandleBarIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 31 611" {...props}>
		<defs>
			<filter id="Rectangle_1538" x="0" y="0" width="31" height="611" filterUnits="userSpaceOnUse">
				<feOffset dy="6" />
				<feGaussianBlur stdDeviation="4.5" result="blur" />
				<feFlood floodColor="#7d61bc" floodOpacity="0.341" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="Group_2852" data-name="Group 2852" transform="translate(-981.5 -133.499)">
			<g transform="matrix(1, 0, 0, 1, 981.5, 133.5)" filter="url(#Rectangle_1538)">
				<rect
					id="Rectangle_1538-2"
					data-name="Rectangle 1538"
					width="4"
					height="584"
					rx="2"
					transform="translate(13.5 7.5)"
					fill="#7d61bc"
				/>
			</g>
			<g id="Group_2839" data-name="Group 2839" transform="translate(1370 -96) rotate(90)">
				<rect
					id="Rectangle_1273"
					data-name="Rectangle 1273"
					width="20"
					height="8"
					rx="3"
					transform="translate(519 369)"
					fill="#7d61bc"
				/>
				<g id="Group_1799" data-name="Group 1799" transform="translate(0 -0.5)">
					<rect
						id="Rectangle_1274"
						data-name="Rectangle 1274"
						width="14"
						height="1"
						rx="0.5"
						transform="translate(522 371)"
						fill="#fff"
					/>
					<rect
						id="Rectangle_1275"
						data-name="Rectangle 1275"
						width="14"
						height="1"
						rx="0.5"
						transform="translate(522 373)"
						fill="#fff"
					/>
					<rect
						id="Rectangle_1276"
						data-name="Rectangle 1276"
						width="14"
						height="1"
						rx="0.5"
						transform="translate(522 375)"
						fill="#fff"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const HideWorkflowActivityIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24.706 21.92" {...props}>
		<path
			id="Union_3"
			data-name="Union 3"
			d="M-1117.47-2942.056a9.188,9.188,0,0,0-1.132.343,10.667,10.667,0,0,0-2.88,1.633h0a10.686,10.686,0,0,0-2.881-1.633,9.108,9.108,0,0,0-3.213-.583,8.752,8.752,0,0,0-2.286.305,10.088,10.088,0,0,0-2.147.86,1.18,1.18,0,0,1-.546.145,1.089,1.089,0,0,1-.576-.173,1.076,1.076,0,0,1-.54-.97v-13.351a1.2,1.2,0,0,1,.152-.582.964.964,0,0,1,.457-.416q.4-.194.806-.363l-1.744-1.744,1.414-1.414,20.507,20.507-1.414,1.414Zm-2.9-1.293q.565-.269,1.135-.476l-1.135-1.135Zm9.507,2.259-3.365-3.364c.279.028.547.065.8.109a12.438,12.438,0,0,1,1.925.5v-10.971a9.714,9.714,0,0,0-1.9-.582,10.281,10.281,0,0,0-1.981-.193,10.212,10.212,0,0,0-2.577.332,9.561,9.561,0,0,0-2.41,1v3.667l-7.212-7.212h.01a12.029,12.029,0,0,1,3.144.416,12,12,0,0,1,2.95,1.246,12.027,12.027,0,0,1,2.95-1.246,12.035,12.035,0,0,1,3.145-.416,11.537,11.537,0,0,1,2.812.345,13.893,13.893,0,0,1,2.673.984.964.964,0,0,1,.457.416,1.2,1.2,0,0,1,.152.582v13.351a1.076,1.076,0,0,1-.54.97,1.089,1.089,0,0,1-.575.173A1.119,1.119,0,0,1-1110.868-2941.09Zm-1.75-4.585a7.874,7.874,0,0,0-1.343-.374,7.9,7.9,0,0,0-1.427-.124c-.186,0-.371.006-.547.017l-1.481-1.481.019,0a10.138,10.138,0,0,1,2.009-.193,9.054,9.054,0,0,1,1.413.11c.457.074.914.167,1.357.278v1.773Zm-5.785-2.95-.862-.862v-.619a9.76,9.76,0,0,1,1.869-.581,10.059,10.059,0,0,1,2.009-.194,9.054,9.054,0,0,1,1.413.11c.458.074.914.167,1.357.278v1.773a7.866,7.866,0,0,0-1.344-.374,7.794,7.794,0,0,0-1.427-.125,7.656,7.656,0,0,0-2.022.264,8.886,8.886,0,0,0-.993.332Zm-.862-2.647v-1.883a9.83,9.83,0,0,1,1.869-.58,10.08,10.08,0,0,1,2.009-.195,8.97,8.97,0,0,1,1.413.112c.462.074.918.167,1.357.276v1.773a7.838,7.838,0,0,0-1.344-.373,7.909,7.909,0,0,0-1.427-.126,7.706,7.706,0,0,0-2.022.265,8.86,8.86,0,0,0-1.854.733h0Z"
			transform="translate(1134 2960)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const ShowWorkflowActivityIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24.378 17.729" {...props}>
		<path
			id="menu_book_FILL1_wght400_GRAD0_opsz24"
			d="M54.405,262.538v-1.884a9.738,9.738,0,0,1,1.87-.582,10.085,10.085,0,0,1,2.008-.194,8.927,8.927,0,0,1,1.413.111q.693.111,1.357.277v1.773a7.678,7.678,0,0,0-2.77-.5,7.686,7.686,0,0,0-2.022.263A8.929,8.929,0,0,0,54.405,262.538Zm0,6.094v-1.884a9.729,9.729,0,0,1,1.87-.582,10.083,10.083,0,0,1,2.008-.194,8.931,8.931,0,0,1,1.413.111q.693.111,1.357.277v1.773a7.678,7.678,0,0,0-2.77-.5,8.089,8.089,0,0,0-2.022.249A7.665,7.665,0,0,0,54.405,268.632Zm0-3.047V263.7a9.733,9.733,0,0,1,1.87-.582,10.08,10.08,0,0,1,2.008-.194,8.927,8.927,0,0,1,1.413.111q.693.111,1.357.277v1.773a7.678,7.678,0,0,0-2.77-.5,7.686,7.686,0,0,0-2.022.263A8.932,8.932,0,0,0,54.405,265.585ZM53.3,270.46a12.18,12.18,0,0,1,2.452-.873,11,11,0,0,1,2.535-.291,11.378,11.378,0,0,1,1.953.166,12.58,12.58,0,0,1,1.925.5v-10.97a9.6,9.6,0,0,0-1.9-.582,10.176,10.176,0,0,0-4.557.138,9.491,9.491,0,0,0-2.41,1Zm-1.108,3.269a10.636,10.636,0,0,0-2.881-1.634,9.079,9.079,0,0,0-3.213-.582,8.68,8.68,0,0,0-2.285.3,10.025,10.025,0,0,0-2.147.859,1.125,1.125,0,0,1-1.662-1V258.327a1.191,1.191,0,0,1,.152-.582.956.956,0,0,1,.457-.416,13.7,13.7,0,0,1,2.673-.983A11.44,11.44,0,0,1,46.094,256a11.911,11.911,0,0,1,6.094,1.662A11.911,11.911,0,0,1,58.283,256a11.44,11.44,0,0,1,2.812.346,13.7,13.7,0,0,1,2.673.983.956.956,0,0,1,.457.416,1.19,1.19,0,0,1,.152.582v13.352a1.125,1.125,0,0,1-1.662,1,10.025,10.025,0,0,0-2.147-.859,8.68,8.68,0,0,0-2.285-.3,9.079,9.079,0,0,0-3.213.582A10.636,10.636,0,0,0,52.189,273.729Z"
			transform="translate(-40 -256)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const HideWorkflowPreviewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 23.446 23.466" {...props}>
		<path
			id="Union_5"
			data-name="Union 5"
			d="M-1120.587-2937.536a5.633,5.633,0,0,1-2.077-2.567,5.64,5.64,0,0,1,2.077-2.566,5.778,5.778,0,0,1,1.713-.791l-3.777-3.777a1.52,1.52,0,0,1-1,.382,1.526,1.526,0,0,1-1.426-.993h-1.62a1.519,1.519,0,0,0-1.518,1.517,1.521,1.521,0,0,0,1.518,1.519h3.037v-1.519l2.025,2.026-2.023,2.021,0,0v-1.517h-3.037a2.534,2.534,0,0,1-2.53-2.532,2.533,2.533,0,0,1,2.53-2.531h1.615a1.508,1.508,0,0,1,.306-.5l-1.913-1.914a1.517,1.517,0,0,1-1.019.394,1.535,1.535,0,0,1-.257-.021,1.515,1.515,0,0,1-1.261-1.5,1.514,1.514,0,0,1,.392-1.02l-1.678-1.678h-.148v14h7.2v2h-7.2a2,2,0,0,1-2-2v-14a2,2,0,0,1,.662-1.485l-2-2,1.414-1.415,22.032,22.032-1.415,1.414-1.457-1.458a5.8,5.8,0,0,1-3.887,1.477A5.8,5.8,0,0,1-1120.587-2937.536Zm-.6-2.567a4.416,4.416,0,0,0,3.871,2.231,4.482,4.482,0,0,0,2.94-1.087l-1.746-1.746a1.327,1.327,0,0,1,.144.6,1.339,1.339,0,0,1-1.337,1.338,1.339,1.339,0,0,1-1.337-1.338,1.338,1.338,0,0,1,1.337-1.335,1.332,1.332,0,0,1,.6.144l-1.019-1.019A4.4,4.4,0,0,0-1121.184-2940.1Zm6.518-4.748-2-2v-8.253h-8.252l-2-2h10.252a2,2,0,0,1,2,2v10.253Zm-3.969-3.969-.724-.725a1.508,1.508,0,0,0,.25-.835,1.52,1.52,0,0,0-1.519-1.518h-1.084l-1.013-1.012h2.1a2.534,2.534,0,0,1,2.532,2.531,2.507,2.507,0,0,1-.537,1.56h0Z"
			transform="translate(1134 2960)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const ShowWorkflowPreviewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 20.703 20.567" {...props}>
		<g id="Group_2833" data-name="Group 2833" transform="translate(-1751 -3933)">
			<g id="Group_2831" data-name="Group 2831" transform="translate(1753.432 3935.179)">
				<path
					id="Path_6638"
					data-name="Path 6638"
					d="M9.6,2.012H3.951a1.519,1.519,0,1,0,0,1.012H9.6a1.519,1.519,0,1,1,0,3.037H8a1.519,1.519,0,0,0-2.855,0H3.531a2.531,2.531,0,1,0,0,5.062H6.568v1.519l2.025-2.025L6.568,8.592v1.519H3.531a1.519,1.519,0,1,1,0-3.037h1.62a1.519,1.519,0,0,0,2.85,0H9.6a2.531,2.531,0,1,0,0-5.062Z"
					transform="translate(0 0)"
					fill="currentColor"
				/>
			</g>
			<path
				id="Subtraction_1"
				data-name="Subtraction 1"
				d="M9.2,18H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H16a2,2,0,0,1,2,2V12.75H16V2H2V16H9.2v2Z"
				transform="translate(1751 3933)"
				fill="currentColor"
			/>
			<g id="Group_2832" data-name="Group 2832" transform="translate(-43.707 14.854)">
				<path
					id="Path_6637"
					data-name="Path 6637"
					d="M11.351,10.338a4.394,4.394,0,0,1,3.871,2.23,4.475,4.475,0,0,1-7.742,0,4.394,4.394,0,0,1,3.871-2.23m0-1.338A5.748,5.748,0,0,0,6,12.568a5.8,5.8,0,0,0,10.7,0A5.748,5.748,0,0,0,11.351,9Zm0,4.905a1.338,1.338,0,1,1,1.338-1.338A1.336,1.336,0,0,1,11.351,13.905Z"
					transform="translate(1798.707 3922.578)"
					fill="currentColor"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const DraftIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<style type="text/css">
			{`
	.draft-icon-st0{fill:currentColor;}
	.draft-icon-st1{fill:none;stroke:currentColor;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_1_00000005265729232914183250000018352830802228111789_">
			<g>
				<path
					className="draft-icon-st0"
					d="M11,7.6l1.8-1.9c0.7,0.2,1.4,0,2-0.6s0.8-1.5,0.6-2.3L14,4.1c0,0-0.6,0.3-1.2-0.3s-0.3-1.2-0.3-1.2l1.3-1.3
			C13,1,12.1,1.2,11.5,1.9c-0.5,0.5-0.8,1.3-0.6,2L9.2,5.7L11,7.6z"
				/>
				<path
					className="draft-icon-st0"
					d="M3.8,10.9C3.7,11,3.7,11,3.6,11.1c-0.7-0.2-1.4,0.1-2,0.6c-0.5,0.7-0.8,1.5-0.5,2.3l1.4-1.3
			c0,0,0.6-0.3,1.2,0.3S4,14.2,4,14.2l-1.3,1.3c0.7,0.3,1.5,0,2.1-0.6s0.8-1.4,0.6-2c0.1,0,0.1-0.1,0.2-0.2l1.5-1.5L5.3,9.4
			L3.8,10.9z"
				/>
				<path
					className="draft-icon-st0"
					d="M11.2,9.4L9.6,7.8L7.9,6.1l0,0L6.5,4.6l1.4-1.4C8,3.1,8,2.7,7.8,2.5L6.1,0.7c-0.2-0.2-0.6-0.2-0.8,0L0.8,5.2
			C0.6,5.4,0.6,5.8,0.8,6l1.8,1.8C2.8,8,3.2,8,3.4,7.8l1.2-1.2L6,8l0,0l3.1,3.1L11.2,9.4z"
				/>
			</g>
		</g>
		<g id="Layer_2_00000054949564155520815650000012624840614540392345_">
			<path
				className="draft-icon-st1"
				d="M20.8,17.7c0-0.1,0-0.1,0-0.1c0-2.8-1.8-5.3-4.2-6.3V17h-1.1v-6.8c0,0-0.5-0.5-1.7-0.5s-1.7,0.5-1.7,0.5V17H11
		v-5.8c-2.3,0.9-4,3.2-4,6c0,0.1,0,0.4,0,0.5c-0.4,0.4-0.6,0.7-0.6,1.1c0,1.4,3.3,2.6,7.5,2.6s7.5-1.2,7.5-2.6
		C21.4,18.4,21.2,18.1,20.8,17.7z"
			/>
		</g>
	</SvgIcon>
);

export const FilterIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path d="M0,0h24 M24,24H0" fill="none" />
			<path d="M7,6h10l-5.01,6.3L7,6z M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6 c0,0,3.72-4.8,5.74-7.39C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z" />
			<path d="M0,0h24v24H0V0z" fill="none" />
		</g>
	</SvgIcon>
);

export const LogsIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		// version="1.1"
		// xmlns="http://www.w3.org/2000/svg"
		// x="0px"
		// y="0px"
		viewBox="0 0 16 16"
		// className="icon"
		// htmlColor="hotpink"
		// style={{
		// 	fill: 'rebeccapurple',
		// 	stroke: 'rebeccapurple'
		// }}
		// style={{
		// 	enableBackground: 'new 0 0 16 16'
		// }}
	>
		<g id="Layer_2">
			<polygon
				// fill="currentColor"
				// className={`fill-${props.color}`}
				// style={{
				// 	fill: '#a48adb'
				// 	// stroke: 'rebeccapurple'
				// }}
				points="2.8,1.8 2.5,12 7.9,13.4 13.1,11.9 13.1,1.7 7.9,2.9"
			/>
		</g>
		<g id="Layer_1" className="">
			<polyline
				// className={`stroke-${props.color}`}
				// stroke="currentColor"
				style={{
					// fill: 'rebeccapurple',
					stroke: 'black',
				}}
				points={`
                        13.4,3.3
                        15.1,3.3
                        15.1,13.5
                        0.7,13.5
                        0.7,3.3
                        2.4,3.3
                    `}
			/>
			<g>
				<path
					// className={`stroke-${props.color}`}
					// stroke="currentColor"
					style={{
						// fill: 'rebeccapurple',
						stroke: 'black',
					}}
					d={`
                            M 7.9,3.3
                            c 0,0,1.3-0.8,2.6-1.1
                            c 1.4-0.3,2.7-0.2,2.7-0.2
                            v 10.2
                            v 0
                            c 0,0-1.4-0.1-2.7,0.2
                            c -1.3,0.3-2.6,1.1-2.6,1.1
                            V 3.3
                            z
                        `}
				/>
				<path
					// className={`stroke-${props.color}`}
					// stroke="currentColor"
					style={{
						// fill: 'rebeccapurple',
						stroke: 'black',
					}}
					d={`
                            M 7.9,13.5
                            V 3.3
                            c 0,0-1.3-0.8-2.6-1.1
                            C 3.9,1.8,2.6,1.9,2.6,1.9
                            v 10.2
                            v 0
                            c 0,0,1.4-0.1,2.7,0.2
                            C 6.6,12.7,7.9,13.5,7.9,13.5
                            L 7.9,13.5
                            z
                        `}
				/>
			</g>
		</g>
	</SvgIcon>
);

export const UserIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<g id="Layer_2" />
		<g id="Layer_1">
			<g>
				<path
					// className="st0"
					d="M3.2,21.1c-0.8,0-1.2-0.6-1.2-1.2c0-0.2,0-0.8,0.3-1.7c0.3-1.2,4.1-2.3,5.6-2.8l0.4-0.1l0,0
			C9,15,9.2,13.4,9.2,13l0-0.3L9,12.6c-0.2-0.1-0.4-0.4-0.6-0.8l0-0.1l0,0c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.6-1.1L7.4,10
			L7.2,10C7.1,9.9,7,9.7,6.8,9.6C6.4,8.8,6.2,7.8,6.3,7.4c0.1-0.1,0.2-0.2,0.2-0.2L6.8,7V6.7c0-2.2,0.8-3.2,1.2-3.5L8.1,3V2.7
			c0.2-0.4,0.7-0.6,1-0.6L9.5,2V1.6c0-0.1,0-0.1,0-0.2C9.6,1.2,9.7,1.1,9.8,1l0,0c0.2,0.3,0.6,0.4,0.9,0.5c0.6,0.1,1.1,0.3,1.4,0.5
			C12.3,2,12.5,2,12.5,2.1c1.6,0.6,2.6,2.4,2.6,4.6v0.4l0.3,0.1c0.1,0,0.1,0.1,0.2,0.2c0.1,0.2-0.1,1.3-0.5,2.3
			c0,0.1-0.2,0.2-0.3,0.3L14.7,10l-0.1,0.2c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.1-0.2,0.3-0.3,0.6
			c-0.2,0.3-0.4,0.5-0.6,0.7L13,12.8V13c0,0.9,0.3,2.1,0.8,2.3c0.6,0.2,1.2,0.4,1.9,0.6c1.4,0.4,3.8,1.1,4.1,2.2
			c0.3,1.1,0.3,1.3,0.3,1.7c0,0.6-0.4,1.2-1.2,1.2H3.2z"
				/>
				<path
					// className="st0"
					d="M10,1.7c0.3,0.1,0.5,0.2,0.7,0.2c0.5,0.1,1,0.3,1.4,0.5c0.1,0.1,0.3,0.1,0.3,0.1c1.4,0.6,2.3,2.1,2.3,4.2v0.7
			l0.6,0.2c0,0.3-0.1,1.1-0.5,1.8c0,0,0,0-0.1,0.1l-0.3,0.2L14.2,10c-0.1,0.2-0.2,0.5-0.4,0.7c-0.1,0.1-0.2,0.3-0.2,0.4
			c-0.1,0.1-0.3,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.5l-0.3,0.3V13c0,0.2,0,2.3,1.1,2.8l0,0l0,0c0.5,0.2,1.2,0.4,1.9,0.6
			c1.1,0.3,3.5,1.1,3.7,1.9c0.3,1,0.3,1.2,0.3,1.5c0,0.3-0.2,0.7-0.7,0.7H3.2c-0.5,0-0.7-0.4-0.7-0.7c0-0.2,0-0.7,0.3-1.5l0,0l0,0
			c0.1-0.3,0.7-1,5.2-2.4l0.4-0.1l0.1,0l0.1,0c0.8-0.4,1.1-1.9,1.1-2.7l0.1-0.6l-0.5-0.3c-0.1-0.1-0.3-0.3-0.5-0.7l-0.1-0.1l0,0
			c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.5-1L7.8,9.7L7.5,9.5c0,0-0.1-0.1-0.2-0.2C6.9,8.7,6.8,8,6.8,7.6l0.5-0.3V6.7
			c0-2,0.7-2.9,1-3.2l0.3-0.3V2.8C8.7,2.7,9,2.6,9.2,2.6L10,2.4L10,1.7 M9.8,0.4C9.5,0.5,9.2,0.9,9.1,1.2C9,1.4,9,1.5,9,1.6
			C8.4,1.7,7.8,2,7.6,2.6c0,0.1,0,0.1,0,0.2c-0.7,0.7-1.3,2-1.3,3.9C6.1,6.8,5.9,7,5.8,7.2C5.7,7.7,5.9,9,6.4,9.9
			c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.5,0.4,0.9,0.7,1.3c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.5,0.5,0.8,0.8,1c-0.1,1.1-0.4,1.8-0.6,1.9
			L7.7,15c-2.7,0.8-5.6,1.8-5.9,3.1c-0.3,1-0.3,1.7-0.3,1.8c0,0.9,0.7,1.7,1.7,1.7h15.6c1,0,1.7-0.8,1.7-1.7c0-0.4,0-0.7-0.3-1.8
			c-0.3-1.3-2.4-2-4.4-2.6c-0.7-0.2-1.3-0.4-1.8-0.6c-0.2-0.1-0.5-0.9-0.5-1.9c0.2-0.2,0.5-0.5,0.7-0.9c0-0.2,0.1-0.3,0.2-0.4
			c0.2-0.4,0.5-0.8,0.7-1.3c0.2-0.1,0.4-0.3,0.5-0.5C16,9,16.3,7.7,16.1,7.2C16,7,15.9,6.8,15.6,6.7c0-2.5-1.1-4.4-2.9-5.1
			c-0.3-0.1-1-0.4-1.8-0.6c-0.4-0.1-0.6-0.2-0.6-0.3c-0.1-0.1-0.1-0.1-0.2-0.2C10,0.4,9.9,0.4,9.8,0.4L9.8,0.4z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ReportsIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 1000 1000">
		<path d="M451.2 137.9c-214.6 0-388.7 173.99999999999997-388.7 388.70000000000005s174 388.79999999999995 388.7 388.79999999999995 388.7-174 388.7-388.79999999999995h-388.7v-388.70000000000005z m486.3 344.20000000000005c0-107.30000000000001-43.5-204.5-113.79999999999995-274.8l-274.9000000000001 274.8h388.70000000000005z m-437.1-397.70000000000005v388.6l274.80000000000007-274.8c-75.90000000000009-75.89999999999999-175.4000000000001-113.79999999999998-274.80000000000007-113.79999999999998z" />
	</SvgIcon>
);

export const ReportsExpandIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 27.965 26">
		<g transform="translate(2.994 4)">
			<path
				d="M114.561,134.185l4.72-4.72v-6.683a6.789,6.789,0,0,0-4.062,2.036,7.17,7.17,0,0,0-.658,9.368m-.049,1.463a8.159,8.159,0,0,1,0-11.538,7.861,7.861,0,0,1,5.769-2.39v8.159Z"
				transform="translate(-112.122 -121.721)"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth={0.5}
			/>
			<path
				d="M172.946,263.881l-4.726,4.726a6.789,6.789,0,0,0,4.312,1.433,7.17,7.17,0,0,0,7.089-6.159h-6.675m-.414-1h8.159a8.159,8.159,0,0,1-8.159,8.159,7.861,7.861,0,0,1-5.769-2.39Z"
				transform="translate(-163.194 -253.04)"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth={0.5}
			/>
			<path
				d="M270.05,119.36a7.174,7.174,0,0,0-6.089-6.089v6.089h6.089m1.07,1h-8.159V112.2A8.159,8.159,0,0,1,271.12,120.36Z"
				transform="translate(-253.109 -112.201)"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth={0.5}
			/>
		</g>

		<rect width="26" height="26" fill="none" />

		<path
			d="M5.26,0,2.98,2.272.7,0,0,.7,2.98,3.675,5.96.7Z"
			transform="translate(22.005 18.325)"
			fill="currentColor"
		/>
	</SvgIcon>
);

// export const ReportsExpandIcon = (props: SvgIconProps) => (
// 	<SvgIcon {...props} viewBox="0 0 1000 1000">
// 		<g id="reports-icon-light-mode">
// 			<g id="icon_dashboard_side_menu" data-name="icon dashboard side menu" transform="translate(2.994 4)">
// 				<g id="Group_3247" data-name="Group 3247" transform="translate(0)">
// 					<g id="Group_3245" data-name="Group 3245" transform="translate(0)">
// 						<g id="Group_3240" data-name="Group 3240" transform="translate(0 0.622)">
// 							<g id="Group_3239" data-name="Group 3239">
// 								<path
// 									id="Path_6676"
// 									data-name="Path 6676"
// 									d="M114.561,134.185l4.72-4.72v-6.683a6.789,6.789,0,0,0-4.062,2.036,7.17,7.17,0,0,0-.658,9.368m-.049,1.463a8.159,8.159,0,0,1,0-11.538,7.861,7.861,0,0,1,5.769-2.39v8.159Z"
// 									transform="translate(-112.122 -121.721)"
// 									fill="#323232"
// 									stroke="#323232"
// 									stroke-width="0.5"
// 								/>
// 							</g>
// 						</g>
// 						<g id="Group_3242" data-name="Group 3242" transform="translate(3.569 9.841)">
// 							<g id="Group_3241" data-name="Group 3241">
// 								<path
// 									id="Path_6677"
// 									data-name="Path 6677"
// 									d="M172.946,263.881l-4.726,4.726a6.789,6.789,0,0,0,4.312,1.433,7.17,7.17,0,0,0,7.089-6.159h-6.675m-.414-1h8.159a8.159,8.159,0,0,1-8.159,8.159,7.861,7.861,0,0,1-5.769-2.39Z"
// 									transform="translate(-166.763 -262.881)"
// 									fill="#323232"
// 									stroke="#323232"
// 									stroke-width="0.5"
// 								/>
// 							</g>
// 						</g>
// 						<g id="Group_3244" data-name="Group 3244" transform="translate(9.852)">
// 							<g id="Group_3243" data-name="Group 3243">
// 								<path
// 									id="Path_6678"
// 									data-name="Path 6678"
// 									d="M270.05,119.36a7.174,7.174,0,0,0-6.089-6.089v6.089h6.089m1.07,1h-8.159V112.2A8.159,8.159,0,0,1,271.12,120.36Z"
// 									transform="translate(-262.961 -112.201)"
// 									fill="#323232"
// 									stroke="#323232"
// 									stroke-width="0.5"
// 								/>
// 							</g>
// 						</g>
// 					</g>
// 				</g>
// 			</g>
// 			<rect id="Rectangle_2025" data-name="Rectangle 2025" width="26" height="26" fill="none" />
// 			<path
// 				id="_Color"
// 				data-name=" ↳Color"
// 				d="M5.26,0,2.98,2.272.7,0,0,.7,2.98,3.675,5.96.7Z"
// 				transform="translate(22.005 18.325)"
// 				fill="#323232"
// 			/>
// 		</g>
// 	</SvgIcon>
// );

export const ReportsPageIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="reports-page-clip-path">
				<path fill="currentColor" d="M0 0H9.754V9.722H0z" data-name="Rectangle 1952" />
			</clipPath>
		</defs>
		<g data-name="Component 413 – 394" transform="translate(5 3)">
			<g data-name="Group 3958">
				<path
					fill="currentColor"
					d="M2 1.5a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h13a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5H2M2 0h13a2 2 0 012 2v17a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"
					data-name="Rectangle 1944"
				/>
				<path fill="currentColor" d="M0 0H11V2H0z" data-name="Rectangle 1950" transform="translate(3 13.301)" />
				<path fill="currentColor" d="M0 0H11V2H0z" data-name="Rectangle 1951" transform="translate(3 16.301)" />
				<g data-name="Group 3568" transform="translate(3.623 2.139)">
					<g clipPath="url(#reports-page-clip-path)" data-name="Group 3566">
						<path
							fill="currentColor"
							fillRule="evenodd"
							d="M6.546 9.38a4.342 4.342 0 01-1.759.342 4.69 4.69 0 01-1.612-.293A5.975 5.975 0 011.759 8.6c-.049-.049-.049-.1 0-.1l3.126-3.126.049-.049h4.4c.049 0 .049.049.049.1a6.465 6.465 0 01-.391 1.612A6.151 6.151 0 018.061 8.4l-.049-.049.049.049a5.38 5.38 0 01-1.514.977M9.722 4.4H5.374a.171.171 0 01-.1-.049V.049A.048.048 0 015.325 0a5.571 5.571 0 011.612.391 4.4 4.4 0 011.368.977l-.049.049.049-.049a5.383 5.383 0 01.977 1.368A3.778 3.778 0 019.673 4.4c.1-.049.1 0 .049 0m-8.6 3.566a5.145 5.145 0 01-.829-1.42A4.49 4.49 0 010 4.934a4.187 4.187 0 01.342-1.759 5.19 5.19 0 011.026-1.514A4.958 4.958 0 012.687.733 4.346 4.346 0 014.3.342a.171.171 0 01.1.049v4.4a.048.048 0 01-.049.049l-3.13 3.074c0 .049-.049.049-.1.049"
							data-name="Path 6688"
						/>
					</g>
				</g>
			</g>
		</g>
		<path fill="none" d="M0 0H26V26H0z" data-name="Rectangle 2019" />
	</SvgIcon>
);

export const CreateUserGroupIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} style={{ transform: 'rotateY(180deg)', ...props.style }} viewBox="0 0 24 24">
		<path d="M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z" />
	</SvgIcon>
);

export const AddShareIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path d="M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z" />
	</SvgIcon>
);

export const SelectTenantGroupIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 17.684 21">
		<g id="Group_4075" data-name="Group 4075" transform="translate(-3356 -10720)">
			<path
				id="Union_34"
				data-name="Union 34"
				d="M8.842,19.113l1.518-2.429h5.324a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2A1,1,0,0,0,1,2V15.684a1,1,0,0,0,1,1H7.324l1.519,2.429m0,1.887L6.77,17.684H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H15.684a2,2,0,0,1,2,2V15.684a2,2,0,0,1-2,2h-4.77Z"
				transform="translate(3356 10720)"
				fill="currentColor"
			/>
			<g id="Group_4074" data-name="Group 4074" transform="translate(3359.342 1.667)">
				<g id="Group_4073" data-name="Group 4073" transform="translate(-3357 8)">
					<rect
						id="Rectangle_1997"
						data-name="Rectangle 1997"
						width="7"
						height="2"
						transform="translate(3361 10722)"
						fill="currentColor"
					/>
					<circle
						id="Ellipse_37"
						data-name="Ellipse 37"
						cx="1"
						cy="1"
						r="1"
						transform="translate(3357 10722)"
						fill="currentColor"
					/>
				</g>
				<g id="Group_4072" data-name="Group 4072" transform="translate(-3357 4)">
					<rect
						id="Rectangle_1997-2"
						data-name="Rectangle 1997"
						width="7"
						height="2"
						transform="translate(3361 10722)"
						fill="currentColor"
					/>
					<circle
						id="Ellipse_37-2"
						data-name="Ellipse 37"
						cx="1"
						cy="1"
						r="1"
						transform="translate(3357 10722)"
						fill="currentColor"
					/>
				</g>
				<g id="Group_4071" data-name="Group 4071" transform="translate(-3357)">
					<rect
						id="Rectangle_1997-3"
						data-name="Rectangle 1997"
						width="7"
						height="2"
						transform="translate(3361 10722)"
						fill="currentColor"
					/>
					<circle
						id="Ellipse_37-3"
						data-name="Ellipse 37"
						cx="1"
						cy="1"
						r="1"
						transform="translate(3357 10722)"
						fill="currentColor"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const TenantKeysIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 13.988 17.688">
		<g id="tenant-keys" transform="translate(-2.306 -0.206)">
			<path
				id="Path_6924"
				data-name="Path 6924"
				d="M10.8,10.9v5l1.5,1.5,1.5-1.5-1.2-1.2,1.2-1.2-1.2-1.2,1.2-1.2v-1a3.468,3.468,0,0,0,1.9-3,3.653,3.653,0,0,0-1.4-2.8"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.988"
			/>
			<path
				id="Path_6925"
				data-name="Path 6925"
				d="M10.3,2.8A3.393,3.393,0,0,0,7,7.3L2.8,11.5v2.2H5.3V11.8H7.2V10H8.7l.5-.5a3.52,3.52,0,0,0,3.5-.8,3.441,3.441,0,0,0,0-4.8,2.589,2.589,0,0,0-1.1-.7"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.988"
			/>
			<path
				id="Path_6926"
				data-name="Path 6926"
				d="M15.8,3.7V3.5A2.8,2.8,0,0,0,13,.7a2.734,2.734,0,0,0-2.8,2.8,2.906,2.906,0,0,0,1.4,2.4"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.988"
			/>
			<circle
				id="Ellipse_36"
				data-name="Ellipse 36"
				cx="0.9"
				cy="0.9"
				r="0.9"
				transform="translate(9.8 4.9)"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.988"
			/>
		</g>
	</SvgIcon>
);

export const TenantIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.tenant-line-st0{display:none;}
	.tenant-line-st1{display:inline;fill:#6D0E5E;}
	.tenant-line-st2{fill:transparent;stroke:currentColor;stroke-linejoin:round;stroke-miterlimit:10;}
	.tenant-line-st3{fill:transparent;stroke:currentColor;stroke-width:0.5;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2" className="tenant-line-st0">
			<rect x="3.8" y="2.7" className="tenant-line-st1" width="1.6" height="12.1" />
			<rect x="1.5" y="10.8" className="tenant-line-st1" width="1.6" height="3.8" />
			<rect x="13" y="11" className="tenant-line-st1" width="1.6" height="3.8" />
			<rect x="5.2" y="9.4" className="tenant-line-st1" width="7.2" height="3.4" />
			<rect x="4.6" y="11" className="tenant-line-st1" width="1.6" height="3.8" />
			<rect x="9.5" y="10.8" className="tenant-line-st1" width="2.9" height="3.8" />
			<rect x="4.5" y="1.2" className="tenant-line-st1" width="7" height="3.2" />
			<rect x="10.8" y="2.7" className="tenant-line-st1" width="1.6" height="7.1" />
			<rect x="7.1" y="4.2" className="tenant-line-st1" width="2" height="5.4" />
			<rect x="4.2" y="5.9" className="tenant-line-st1" width="7" height="2" />
		</g>
		<g id="Layer_1">
			<path className="tenant-line-st2" d="M3.4,10.6c-0.6,0.1-1.5,0.2-2.2,0.4v4" />
			<path
				className="tenant-line-st2"
				d="M12.8,15l0-12.5c-0.6-0.1-0.7-0.2-1.3-0.3v-1C10.2,1.1,9.2,1,8.1,1C7,1,6,1.1,4.7,1.4v1C4.2,2.4,4,2.5,3.4,2.6
		l0,12.5"
			/>
			<rect x="5.4" y="7.9" className="tenant-line-st3" width="1.6" height="1.6" />
			<rect x="5.4" y="4.3" className="tenant-line-st3" width="1.6" height="1.6" />
			<rect x="9.2" y="7.9" className="tenant-line-st3" width="1.6" height="1.6" />
			<rect x="9.2" y="4.3" className="tenant-line-st3" width="1.6" height="1.6" />
			<path className="tenant-line-st2" d="M12.8,10.6c0.6,0.1,1.5,0.2,2.2,0.4v4" />
			<path className="tenant-line-st3" d="M9.6,15v-2.2c-0.7-0.2-1.3-0.2-1.7-0.2c-0.5,0-1.2,0.1-1.7,0.2V15" />
			<line className="tenant-line-st3" x1="8" y1="15" x2="8" y2="12.6" />
			<line className="tenant-line-st2" x1="0.5" y1="15" x2="15.7" y2="15" />
		</g>
	</SvgIcon>
);

export const TenantIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.tenant-fill-st0{fill:currentColor;}
	.tenant-fill-st1{fill:transparent;stroke:currentColor;stroke-linejoin:round;stroke-miterlimit:10;}
	.tenant-fill-st2{fill:transparent;stroke:currentColor;stroke-width:0.5;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2">
			<rect x="3.8" y="2.7" className="tenant-fill-st0" width="1.6" height="12.1" />
			<rect x="1.5" y="10.8" className="tenant-fill-st0" width="1.6" height="3.8" />
			<rect x="13" y="11" className="tenant-fill-st0" width="1.6" height="3.8" />
			<rect x="5.2" y="9.4" className="tenant-fill-st0" width="7.2" height="3.4" />
			<rect x="4.6" y="11" className="tenant-fill-st0" width="1.6" height="3.8" />
			<rect x="9.5" y="10.8" className="tenant-fill-st0" width="2.9" height="3.8" />
			<rect x="4.5" y="1.2" className="tenant-fill-st0" width="7" height="3.2" />
			<rect x="10.8" y="2.7" className="tenant-fill-st0" width="1.6" height="7.1" />
			<rect x="7.1" y="4.2" className="tenant-fill-st0" width="2" height="5.4" />
			<rect x="4.2" y="5.9" className="tenant-fill-st0" width="7" height="2" />
		</g>
		<g id="Layer_1">
			<path className="tenant-fill-st1" d="M3.4,10.6c-0.6,0.1-1.5,0.2-2.2,0.4v4" />
			<path
				className="tenant-fill-st1"
				d="M12.8,15l0-12.5c-0.6-0.1-0.7-0.2-1.3-0.3v-1C10.2,1.1,9.2,1,8.1,1C7,1,6,1.1,4.7,1.4v1C4.2,2.4,4,2.5,3.4,2.6
		l0,12.5"
			/>
			<rect x="5.4" y="7.9" className="tenant-fill-st2" width="1.6" height="1.6" />
			<rect x="5.4" y="4.3" className="tenant-fill-st2" width="1.6" height="1.6" />
			<rect x="9.2" y="7.9" className="tenant-fill-st2" width="1.6" height="1.6" />
			<rect x="9.2" y="4.3" className="tenant-fill-st2" width="1.6" height="1.6" />
			<path className="tenant-fill-st1" d="M12.8,10.6c0.6,0.1,1.5,0.2,2.2,0.4v4" />
			<path className="tenant-fill-st2" d="M9.6,15v-2.2c-0.7-0.2-1.3-0.2-1.7-0.2c-0.5,0-1.2,0.1-1.7,0.2V15" />
			<line className="tenant-fill-st2" x1="8" y1="15" x2="8" y2="12.6" />
			<line className="tenant-fill-st1" x1="0.5" y1="15" x2="15.7" y2="15" />
		</g>
	</SvgIcon>
);

export const WorkflowIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">
			{`
	.workflow-line-st0{fill:currentColor;}
	.workflow-line-st1{fill:transparent;stroke:currentColor;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_1_00000143595855252159953840000010189435056039044006_">
			<path className="workflow-line-st0" d="M1.8,21.4V0.6L19.7,11L1.8,21.4z M2.9,2.5v17L17.5,11L2.9,2.5z" />
		</g>
		<g id="Layer_2_00000140714031565642397520000008672307113262246329_">
			<polygon className="workflow-line-st1" points="2.3,1.6 18.5,11 2.3,20.5 	" />
		</g>
	</SvgIcon>
);

export const WorkflowIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">
			{`
	.workflow-fill-st0{display:none;}
	.workflow-fill-st1{display:inline;fill:currentColor;}
	.workflow-fill-st2{fill:currentColor;stroke:currentColor;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_1" className="workflow-fill-st0">
			<path className="workflow-fill-st1" d="M1.8,21.4V0.6L19.7,11L1.8,21.4z M2.9,2.5v17L17.5,11L2.9,2.5z" />
		</g>
		<g id="Layer_2">
			<polygon className="workflow-fill-st2" points="2.3,1.6 18.5,11 2.3,20.5 	" />
		</g>
	</SvgIcon>
);

export const DashboardIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">
			{`
	.dashboard-line-st0{display:none;}
	.dashboard-line-st1{display:inline;fill:currentColor;}
	.dashboard-line-st2{fill:currentColor;}
	.dashboard-line-st3{display:inline;fill:none;stroke:currentColor;stroke-miterlimit:10;}
	.dashboard-line-st4{display:inline;fill:currentColor;}
	.dashboard-line-st5{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}
	.dashboard-line-st6{fill:currentColor;}`}
		</style>
		<g id="Layer_1" className="dashboard-line-st0">
			<path
				className="dashboard-line-st1"
				d="M18.5,18c1.8-1.9,2.9-4.4,2.9-7.2c0-0.9-0.1-1.9-0.4-2.7C21,8,21,8,21,7.9s0-0.1-0.1-0.1
		c-1.3-4.3-5.3-7.4-10-7.4C5.2,0.3,0.5,5,0.5,10.8S5.2,21.3,11,21.3C13.9,21.3,16.6,20,18.5,18C18.5,18.1,18.5,18,18.5,18L18.5,18z
		 M18.2,17.3L11.6,11l8.8-2.5c0.2,0.8,0.3,1.5,0.3,2.3C20.7,13.3,19.8,15.6,18.2,17.3z M20.2,7.8l-8.9,2.6V1.1
		C15.5,1.2,19,4,20.2,7.8z M1.2,10.8c0-5.3,4.2-9.6,9.4-9.8v10l7.2,6.8c-1.8,1.7-4.2,2.8-6.8,2.8C5.5,20.6,1.2,16.2,1.2,10.8z"
			/>
		</g>
		<g id="Layer_2" className="dashboard-line-st0">
			<circle className="dashboard-line-st2" cx="11.1" cy="11" r="10.2" />
			<circle className="dashboard-line-st3" cx="11.1" cy="11" r="10.2" />
			<line className="dashboard-line-st3" x1="11.1" y1="11" x2="18.2" y2="17.9" />
			<line className="dashboard-line-st3" x1="11" y1="1" x2="11.2" y2="11.4" />
			<line className="dashboard-line-st3" x1="20.7" y1="8.1" x2="11.4" y2="10.9" />
		</g>
		<g id="Layer_2_copy" className="dashboard-line-st0">
			<circle className="dashboard-line-st4" cx="11" cy="11" r="10.2" />
			<circle className="dashboard-line-st3" cx="11" cy="11" r="10.2" />
			<line className="dashboard-line-st3" x1="11" y1="11" x2="18.3" y2="18.1" />
			<line className="dashboard-line-st3" x1="11" y1="0.8" x2="11.2" y2="11.4" />
			<line className="dashboard-line-st3" x1="20.8" y1="8.1" x2="11.1" y2="11.1" />
		</g>
		<g id="Layer_4" className="dashboard-line-st0">
			<path
				className="dashboard-line-st5"
				d="M14.4,20.5c-1.1,0.5-2.4,0.7-3.6,0.7h0v0c-1.1,0-2.2-0.2-3.3-0.6c-1-0.4-2-1-2.9-1.7c0,0,0,0,0,0
		c-0.1-0.1-0.1-0.2,0-0.2l0,0l6.4-6.4c0,0,0.1-0.1,0.1-0.1v0l9,0c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.2h0c-0.1,1.1-0.4,2.2-0.8,3.3
		c-0.5,1-1.1,1.9-1.9,2.8l0,0l-0.1-0.1l0.1,0.1C16.6,19.3,15.6,20,14.4,20.5L14.4,20.5z M20.9,10.3L20.9,10.3H12
		c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0,0,0l0-8.8h0c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0c1.2,0.1,2.3,0.4,3.3,0.8c1,0.5,2,1.1,2.8,2
		l-0.1,0.1l0.1-0.1c0.8,0.8,1.5,1.8,2,2.8c0.5,1,0.8,2.2,0.8,3.4h0C21,10.2,21,10.3,20.9,10.3L20.9,10.3L20.9,10.3z M3.3,17.6
		c-0.7-0.9-1.3-1.8-1.7-2.9c-0.4-1-0.6-2.2-0.6-3.3h0c0-1.3,0.2-2.5,0.7-3.6c0.5-1.1,1.2-2.2,2.1-3.1l0,0l0,0l0,0l0,0
		c0.8-0.8,1.7-1.4,2.7-1.9c1-0.5,2.1-0.7,3.3-0.8v0c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0l0,9h0c0,0,0,0.1-0.1,0.1l-6.4,6.3l0,0
		C3.5,17.6,3.4,17.6,3.3,17.6C3.3,17.6,3.3,17.6,3.3,17.6L3.3,17.6z"
			/>
		</g>
		<g id="Layer_4_copy">
			<g>
				<path
					className="dashboard-line-st6"
					d="M12.9,2.3c0.7,0.1,1.4,0.3,2.1,0.6c0.8,0.4,1.5,0.8,2.2,1.4c0,0.2,0.1,0.3,0.3,0.5C17.6,4.9,17.7,5,17.9,5
			c0.6,0.6,1,1.4,1.4,2.2c0.3,0.7,0.5,1.4,0.6,2.1h-7L12.9,2.3 M8.9,3.1l0,7.7l-5.4,5.4c-0.4-0.6-0.7-1.2-1-1.9
			C2.2,13.4,2,12.4,2,11.4c0-1.1,0.2-2.2,0.6-3.2c0.4-1,1-1.9,1.8-2.7c0,0,0,0,0,0C5.2,4.7,6,4.1,6.9,3.7C7.6,3.4,8.2,3.2,8.9,3.1
			 M11.8,12.9L11.8,12.9L11.8,12.9 M11.5,13.2l7.7,0c-0.1,0.7-0.3,1.4-0.6,2c-0.3,0.8-0.8,1.5-1.4,2.1c-0.2,0-0.3,0.1-0.4,0.3
			c-0.1,0.1-0.2,0.3-0.3,0.5c-0.7,0.6-1.5,1.1-2.4,1.5c-1,0.4-2.1,0.6-3.2,0.6c0,0,0,0,0,0c-1,0-2-0.2-2.9-0.5
			c-0.7-0.2-1.3-0.6-1.9-1L11.5,13.2 M12,1.2c-0.1,0-0.1,0.1-0.1,0.1h0l0,8.8c0,0,0,0,0,0c0,0.1,0.1,0.1,0.2,0.1h8.8h0l0,0
			c0.1,0,0.1-0.1,0.1-0.2h0c-0.1-1.2-0.4-2.3-0.8-3.4c-0.5-1-1.1-2-2-2.8l-0.1,0.1l0.1-0.1c-0.8-0.8-1.8-1.5-2.8-2
			C14.4,1.5,13.2,1.2,12,1.2C12,1.2,12,1.2,12,1.2L12,1.2z M9.8,1.9C9.8,1.9,9.8,1.9,9.8,1.9L9.8,1.9C8.6,2,7.5,2.3,6.5,2.8
			c-1,0.5-1.9,1.1-2.7,1.9l0,0l0,0l0,0C2.9,5.6,2.2,6.6,1.7,7.8C1.2,8.9,1,10.1,1,11.4h0c0,1.1,0.2,2.2,0.6,3.3c0.4,1,1,2,1.7,2.9
			c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l0,0l6.4-6.3c0,0,0.1-0.1,0.1-0.1h0l0-9c0,0,0,0,0,0C9.9,2,9.9,1.9,9.8,1.9L9.8,1.9z
			 M9.9,11.1L9.9,11.1L9.9,11.1z M11.1,12.2c0,0-0.1,0-0.1,0.1l-6.4,6.4l0,0c-0.1,0.1-0.1,0.2,0,0.2c0,0,0,0,0,0
			c0.9,0.7,1.8,1.3,2.9,1.7c1,0.4,2.2,0.6,3.3,0.6c0,0,0,0,0,0v0h0c1.3,0,2.5-0.2,3.6-0.7c1.1-0.5,2.2-1.2,3.1-2.1l-0.1-0.1l0.1,0.1
			l0,0c0.8-0.8,1.4-1.7,1.9-2.8c0.5-1,0.7-2.1,0.8-3.3h0c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0,0c0,0,0,0,0,0L11.1,12.2L11.1,12.2
			C11.1,12.2,11.1,12.2,11.1,12.2L11.1,12.2z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ActivityDashboardIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<svg id="activity-dashboard-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
			<rect id="Rectangle_4216" data-name="Rectangle 4216" width="24" height="24" fill="none" />
			<g id="Union_102" data-name="Union 102" transform="translate(-14016.75 -1200.5)" fill="none">
				<path d="M14034,1223v-9h5.5v9Zm-8,0v-21h5.5v21Zm-8,0v-15h5.5v15Z" stroke="none" />
				<path
					d="M 14037.9990234375 1221.500366210938 L 14037.9990234375 1215.50146484375 L 14035.4990234375 1215.50146484375 L 14035.4990234375 1221.500366210938 L 14037.9990234375 1221.500366210938 M 14030.0009765625 1221.500366210938 L 14030.0009765625 1203.50048828125 L 14027.5009765625 1203.50048828125 L 14027.5009765625 1221.500366210938 L 14030.0009765625 1221.500366210938 M 14021.9990234375 1221.500366210938 L 14021.9990234375 1209.5009765625 L 14019.4990234375 1209.5009765625 L 14019.4990234375 1221.500366210938 L 14021.9990234375 1221.500366210938 M 14039.4990234375 1223.000366210938 L 14033.9990234375 1223.000366210938 L 14033.9990234375 1214.00146484375 L 14039.4990234375 1214.00146484375 L 14039.4990234375 1223.000366210938 Z M 14031.5009765625 1223.000366210938 L 14026.0009765625 1223.000366210938 L 14026.0009765625 1202.00048828125 L 14031.5009765625 1202.00048828125 L 14031.5009765625 1223.000366210938 Z M 14023.4990234375 1223.000366210938 L 14017.9990234375 1223.000366210938 L 14017.9990234375 1208.0009765625 L 14023.4990234375 1208.0009765625 L 14023.4990234375 1223.000366210938 Z"
					stroke="none"
					fill="#323232"
				/>
			</g>
		</svg>
	</SvgIcon>
);

export const DashboardIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">
			{`
	.dashboard-fill-st0{display:none;}
	.dashboard-fill-st1{display:inline;fill:currentColor;}
	.dashboard-fill-st2{fill:currentColor;}
	.dashboard-fill-st3{display:inline;fill:none;stroke:currentColor;stroke-miterlimit:10;}
	.dashboard-fill-st4{display:inline;fill:currentColor;}
	.dashboard-fill-st5{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}
	.dashboard-fill-st6{display:inline;}
	.dashboard-fill-st7{fill:currentColor;}`}
		</style>
		<g id="Layer_1" className="dashboard-fill-st0">
			<path
				className="dashboard-fill-st1"
				d="M18.5,18c1.8-1.9,2.9-4.4,2.9-7.2c0-0.9-0.1-1.9-0.4-2.7C21,8,21,8,21,7.9s0-0.1-0.1-0.1
		c-1.3-4.3-5.3-7.4-10-7.4C5.2,0.3,0.5,5,0.5,10.8S5.2,21.3,11,21.3C13.9,21.3,16.6,20,18.5,18C18.5,18.1,18.5,18,18.5,18L18.5,18z
		 M18.2,17.3L11.6,11l8.8-2.5c0.2,0.8,0.3,1.5,0.3,2.3C20.7,13.3,19.8,15.6,18.2,17.3z M20.2,7.8l-8.9,2.6V1.1
		C15.5,1.2,19,4,20.2,7.8z M1.2,10.8c0-5.3,4.2-9.6,9.4-9.8v10l7.2,6.8c-1.8,1.7-4.2,2.8-6.8,2.8C5.5,20.6,1.2,16.2,1.2,10.8z"
			/>
		</g>
		<g id="Layer_2" className="dashboard-fill-st0">
			<circle className="dashboard-fill-st2" cx="11.1" cy="11" r="10.2" />
			<circle className="dashboard-fill-st3" cx="11.1" cy="11" r="10.2" />
			<line className="dashboard-fill-st3" x1="11.1" y1="11" x2="18.2" y2="17.9" />
			<line className="dashboard-fill-st3" x1="11" y1="1" x2="11.2" y2="11.4" />
			<line className="dashboard-fill-st3" x1="20.7" y1="8.1" x2="11.4" y2="10.9" />
		</g>
		<g id="Layer_2_copy" className="dashboard-fill-st0">
			<circle className="dashboard-fill-st4" cx="11" cy="11" r="10.2" />
			<circle className="dashboard-fill-st3" cx="11" cy="11" r="10.2" />
			<line className="dashboard-fill-st3" x1="11" y1="11" x2="18.3" y2="18.1" />
			<line className="dashboard-fill-st3" x1="11" y1="0.8" x2="11.2" y2="11.4" />
			<line className="dashboard-fill-st3" x1="20.8" y1="8.1" x2="11.1" y2="11.1" />
		</g>
		<g id="Layer_4">
			<path
				className="dashboard-fill-st5"
				d="M14.4,20.5c-1.1,0.5-2.4,0.7-3.6,0.7h0v0c-1.1,0-2.2-0.2-3.3-0.6c-1-0.4-2-1-2.9-1.7c0,0,0,0,0,0
		c-0.1-0.1-0.1-0.2,0-0.2l0,0l6.4-6.4c0,0,0.1-0.1,0.1-0.1v0l9,0c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.2h0c-0.1,1.1-0.4,2.2-0.8,3.3
		c-0.5,1-1.1,1.9-1.9,2.8l0,0l-0.1-0.1l0.1,0.1C16.6,19.3,15.6,20,14.4,20.5L14.4,20.5z M20.9,10.3L20.9,10.3H12
		c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0,0,0l0-8.8h0c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0c1.2,0.1,2.3,0.4,3.3,0.8c1,0.5,2,1.1,2.8,2
		l-0.1,0.1l0.1-0.1c0.8,0.8,1.5,1.8,2,2.8c0.5,1,0.8,2.2,0.8,3.4h0C21,10.2,21,10.3,20.9,10.3L20.9,10.3L20.9,10.3z M3.3,17.6
		c-0.7-0.9-1.3-1.8-1.7-2.9c-0.4-1-0.6-2.2-0.6-3.3h0c0-1.3,0.2-2.5,0.7-3.6c0.5-1.1,1.2-2.2,2.1-3.1l0,0l0,0l0,0l0,0
		c0.8-0.8,1.7-1.4,2.7-1.9c1-0.5,2.1-0.7,3.3-0.8v0c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0l0,9h0c0,0,0,0.1-0.1,0.1l-6.4,6.3l0,0
		C3.5,17.6,3.4,17.6,3.3,17.6C3.3,17.6,3.3,17.6,3.3,17.6L3.3,17.6z"
			/>
		</g>
		<g id="Layer_4_copy" className="dashboard-fill-st0">
			<g className="dashboard-fill-st6">
				<path
					className="dashboard-fill-st7"
					d="M12.9,2.3c0.7,0.1,1.4,0.3,2.1,0.6c0.8,0.4,1.5,0.8,2.2,1.4c0,0.2,0.1,0.3,0.3,0.5C17.6,4.9,17.7,5,17.9,5
			c0.6,0.6,1,1.4,1.4,2.2c0.3,0.7,0.5,1.4,0.6,2.1h-7L12.9,2.3 M8.9,3.1l0,7.7l-5.4,5.4c-0.4-0.6-0.7-1.2-1-1.9
			C2.2,13.4,2,12.4,2,11.4c0-1.1,0.2-2.2,0.6-3.2c0.4-1,1-1.9,1.8-2.7c0,0,0,0,0,0C5.2,4.7,6,4.1,6.9,3.7C7.6,3.4,8.2,3.2,8.9,3.1
			 M11.8,12.9L11.8,12.9L11.8,12.9 M11.5,13.2l7.7,0c-0.1,0.7-0.3,1.4-0.6,2c-0.3,0.8-0.8,1.5-1.4,2.1c-0.2,0-0.3,0.1-0.4,0.3
			c-0.1,0.1-0.2,0.3-0.3,0.5c-0.7,0.6-1.5,1.1-2.4,1.5c-1,0.4-2.1,0.6-3.2,0.6c0,0,0,0,0,0c-1,0-2-0.2-2.9-0.5
			c-0.7-0.2-1.3-0.6-1.9-1L11.5,13.2 M12,1.2c-0.1,0-0.1,0.1-0.1,0.1h0l0,8.8c0,0,0,0,0,0c0,0.1,0.1,0.1,0.2,0.1h8.8h0l0,0
			c0.1,0,0.1-0.1,0.1-0.2h0c-0.1-1.2-0.4-2.3-0.8-3.4c-0.5-1-1.1-2-2-2.8l-0.1,0.1l0.1-0.1c-0.8-0.8-1.8-1.5-2.8-2
			C14.4,1.5,13.2,1.2,12,1.2C12,1.2,12,1.2,12,1.2L12,1.2z M9.8,1.9C9.8,1.9,9.8,1.9,9.8,1.9L9.8,1.9C8.6,2,7.5,2.3,6.5,2.8
			c-1,0.5-1.9,1.1-2.7,1.9l0,0l0,0l0,0C2.9,5.6,2.2,6.6,1.7,7.8C1.2,8.9,1,10.1,1,11.4h0c0,1.1,0.2,2.2,0.6,3.3c0.4,1,1,2,1.7,2.9
			c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l0,0l6.4-6.3c0,0,0.1-0.1,0.1-0.1h0l0-9c0,0,0,0,0,0C9.9,2,9.9,1.9,9.8,1.9L9.8,1.9z
			 M9.9,11.1L9.9,11.1L9.9,11.1z M11.1,12.2c0,0-0.1,0-0.1,0.1l-6.4,6.4l0,0c-0.1,0.1-0.1,0.2,0,0.2c0,0,0,0,0,0
			c0.9,0.7,1.8,1.3,2.9,1.7c1,0.4,2.2,0.6,3.3,0.6c0,0,0,0,0,0v0h0c1.3,0,2.5-0.2,3.6-0.7c1.1-0.5,2.2-1.2,3.1-2.1l-0.1-0.1l0.1,0.1
			l0,0c0.8-0.8,1.4-1.7,1.9-2.8c0.5-1,0.7-2.1,0.8-3.3h0c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0,0c0,0,0,0,0,0L11.1,12.2L11.1,12.2
			C11.1,12.2,11.1,12.2,11.1,12.2L11.1,12.2z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ReportsIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 23.8 28">
		<path
			id="Subtraction_9"
			data-name="Subtraction 9"
			d="M23.8,28H0V0H23.8V28ZM3.966,22.909v2.545H19.833V22.909Zm0-5.091v2.545H19.833V17.818Zm8.013-8.7-.068.068L7.533,13.561h0a.045.045,0,0,0-.045.024c-.012.028.007.071.048.113a8.367,8.367,0,0,0,1.983,1.162,6.6,6.6,0,0,0,2.258.411,6.1,6.1,0,0,0,2.462-.479,7.506,7.506,0,0,0,2.12-1.368,8.591,8.591,0,0,0,1.3-1.914A8.928,8.928,0,0,0,18.2,9.252c0-.067,0-.136-.068-.136ZM11.09,2.138a6.026,6.026,0,0,0-2.258.547,6.881,6.881,0,0,0-1.846,1.3A7.24,7.24,0,0,0,5.55,6.105a5.854,5.854,0,0,0-.479,2.462,6.323,6.323,0,0,0,.411,2.258,7.338,7.338,0,0,0,1.162,1.983h.016c.064,0,.122-.005.122-.068l4.378-4.31a.067.067,0,0,0,.068-.068V2.206h0A.239.239,0,0,0,11.09,2.138Zm1.367,5.609a.244.244,0,0,0,.137.068h6.02a5.321,5.321,0,0,0-.548-2.322A7.566,7.566,0,0,0,16.7,3.575a6.166,6.166,0,0,0-1.915-1.368,7.732,7.732,0,0,0-2.257-.547.068.068,0,0,0-.069.068v6.02Z"
			transform="translate(0 0)"
			fill="transparent"
			stroke="currentColor"
		/>
	</SvgIcon>
);

export const ReportsIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 23.8 28">
		<path
			id="Subtraction_9"
			data-name="Subtraction 9"
			d="M23.8,28H0V0H23.8V28ZM3.966,22.909v2.545H19.833V22.909Zm0-5.091v2.545H19.833V17.818Zm8.013-8.7-.068.068L7.533,13.561h0a.045.045,0,0,0-.045.024c-.012.028.007.071.048.113a8.367,8.367,0,0,0,1.983,1.162,6.6,6.6,0,0,0,2.258.411,6.1,6.1,0,0,0,2.462-.479,7.506,7.506,0,0,0,2.12-1.368,8.591,8.591,0,0,0,1.3-1.914A8.928,8.928,0,0,0,18.2,9.252c0-.067,0-.136-.068-.136ZM11.09,2.138a6.026,6.026,0,0,0-2.258.547,6.881,6.881,0,0,0-1.846,1.3A7.24,7.24,0,0,0,5.55,6.105a5.854,5.854,0,0,0-.479,2.462,6.323,6.323,0,0,0,.411,2.258,7.338,7.338,0,0,0,1.162,1.983h.016c.064,0,.122-.005.122-.068l4.378-4.31a.067.067,0,0,0,.068-.068V2.206h0A.239.239,0,0,0,11.09,2.138Zm1.367,5.609a.244.244,0,0,0,.137.068h6.02a5.321,5.321,0,0,0-.548-2.322A7.566,7.566,0,0,0,16.7,3.575a6.166,6.166,0,0,0-1.915-1.368,7.732,7.732,0,0,0-2.257-.547.068.068,0,0,0-.069.068v6.02Z"
			transform="translate(0 0)"
			fill="currentColor"
			strokeWidth="20"
		/>
	</SvgIcon>
);

export const BsnIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<svg id="bsn-dashboard-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
			<defs>
				<clipPath id="clip-path">
					<rect
						id="Rectangle_3484"
						data-name="Rectangle 3484"
						width="20"
						height="19.9"
						transform="translate(0 0)"
						fill="currentColor"
					/>
				</clipPath>
			</defs>
			<g id="Group_8911" data-name="Group 8911" transform="translate(3 3.05)">
				<g id="Group_8910" data-name="Group 8910" clipPath="url(#clip-path)">
					<path
						id="Path_8236"
						data-name="Path 8236"
						d="M2.25,16.25A9.71,9.71,0,0,1,0,10.95H2.05a8.651,8.651,0,0,0,.55,2.063A7.9,7.9,0,0,0,3.65,14.85ZM0,8.95A11.554,11.554,0,0,1,.75,6.125,9.2,9.2,0,0,1,2.25,3.65l1.4,1.4A7.906,7.906,0,0,0,2.6,6.888,8.644,8.644,0,0,0,2.05,8.95ZM8.95,19.9a9.768,9.768,0,0,1-2.813-.712A10.369,10.369,0,0,1,3.65,17.7l1.4-1.45A9.323,9.323,0,0,0,6.9,17.325a7.775,7.775,0,0,0,2.05.575ZM5.1,3.65,3.65,2.2A10.768,10.768,0,0,1,6.175.713,9.915,9.915,0,0,1,9,0V2a8,8,0,0,0-2.063.575A8.683,8.683,0,0,0,5.1,3.65M10.95,19.9v-2a8.156,8.156,0,0,0,3.95-1.65l1.45,1.45a9.882,9.882,0,0,1-2.538,1.5,10.342,10.342,0,0,1-2.862.7m4-16.25a9.136,9.136,0,0,0-1.875-1.075A8.182,8.182,0,0,0,11,2V0a10.062,10.062,0,0,1,2.837.713A10.213,10.213,0,0,1,16.35,2.2Zm2.8,12.6-1.4-1.4a7.9,7.9,0,0,0,1.05-1.837,8.651,8.651,0,0,0,.55-2.063H20a11.542,11.542,0,0,1-.75,2.825,9.2,9.2,0,0,1-1.5,2.475m.2-7.3a8.644,8.644,0,0,0-.55-2.062A7.906,7.906,0,0,0,16.35,5.05l1.4-1.4A9.71,9.71,0,0,1,20,8.95Zm-13.6,2.843A5.765,5.765,0,0,1,4.235,8.37l1.138.438a5.147,5.147,0,0,0-.135,1.262,4.7,4.7,0,0,0,.191,1.244ZM4.661,7.26a6.888,6.888,0,0,1,1.02-1.409A5.475,5.475,0,0,1,7.042,4.8L7.52,5.873a4.734,4.734,0,0,0-.975.8A5.145,5.145,0,0,0,5.8,7.7Zm2.633,7.989a5.8,5.8,0,0,1-1.41-1A6.15,6.15,0,0,1,4.821,12.9l1.086-.506a5.632,5.632,0,0,0,.8.992,4.631,4.631,0,0,0,1.016.756Zm1.33-9.843-.5-1.115A6.4,6.4,0,0,1,9.847,4a5.912,5.912,0,0,1,1.721.207l-.427,1.111A4.718,4.718,0,0,0,9.873,5.2a5.119,5.119,0,0,0-1.249.2M8.4,15.676l.427-1.111a4.862,4.862,0,0,0,2.545-.073l.5,1.114a5.9,5.9,0,0,1-1.729.292A6.187,6.187,0,0,1,8.4,15.676m5.688-8.169a5.442,5.442,0,0,0-.811-1,4.9,4.9,0,0,0-1.03-.762l.427-1.11a5.987,5.987,0,0,1,1.424,1A6.068,6.068,0,0,1,15.179,7ZM12.958,15.1l-.478-1.076a4.7,4.7,0,0,0,.975-.8A5.152,5.152,0,0,0,14.2,12.2l1.138.438a6.839,6.839,0,0,1-1.019,1.408A5.428,5.428,0,0,1,12.958,15.1m1.669-4.01a5.2,5.2,0,0,0,.135-1.262,4.7,4.7,0,0,0-.191-1.245L15.647,8.1a5.782,5.782,0,0,1,.118,3.422Z"
						fill="currentColor"
					/>
				</g>
			</g>
			<rect id="Rectangle_3485" data-name="Rectangle 3485" width="26" height="26" fill="none" />
		</svg>
	</SvgIcon>
);

export const BsnIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<svg id="bsn-dashboard-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
			<defs>
				<clipPath id="clip-path">
					<rect
						id="Rectangle_3484"
						data-name="Rectangle 3484"
						width="20"
						height="19.9"
						transform="translate(0 0)"
						fill="currentColor"
					/>
				</clipPath>
			</defs>
			<g id="Group_8911" data-name="Group 8911" transform="translate(3 3.05)">
				<g id="Group_8910" data-name="Group 8910" clipPath="url(#clip-path)">
					<path
						id="Path_8236"
						data-name="Path 8236"
						d="M2.25,16.25A9.71,9.71,0,0,1,0,10.95H2.05a8.651,8.651,0,0,0,.55,2.063A7.9,7.9,0,0,0,3.65,14.85ZM0,8.95A11.554,11.554,0,0,1,.75,6.125,9.2,9.2,0,0,1,2.25,3.65l1.4,1.4A7.906,7.906,0,0,0,2.6,6.888,8.644,8.644,0,0,0,2.05,8.95ZM8.95,19.9a9.768,9.768,0,0,1-2.813-.712A10.369,10.369,0,0,1,3.65,17.7l1.4-1.45A9.323,9.323,0,0,0,6.9,17.325a7.775,7.775,0,0,0,2.05.575ZM5.1,3.65,3.65,2.2A10.768,10.768,0,0,1,6.175.713,9.915,9.915,0,0,1,9,0V2a8,8,0,0,0-2.063.575A8.683,8.683,0,0,0,5.1,3.65M10.95,19.9v-2a8.156,8.156,0,0,0,3.95-1.65l1.45,1.45a9.882,9.882,0,0,1-2.538,1.5,10.342,10.342,0,0,1-2.862.7m4-16.25a9.136,9.136,0,0,0-1.875-1.075A8.182,8.182,0,0,0,11,2V0a10.062,10.062,0,0,1,2.837.713A10.213,10.213,0,0,1,16.35,2.2Zm2.8,12.6-1.4-1.4a7.9,7.9,0,0,0,1.05-1.837,8.651,8.651,0,0,0,.55-2.063H20a11.542,11.542,0,0,1-.75,2.825,9.2,9.2,0,0,1-1.5,2.475m.2-7.3a8.644,8.644,0,0,0-.55-2.062A7.906,7.906,0,0,0,16.35,5.05l1.4-1.4A9.71,9.71,0,0,1,20,8.95Zm-13.6,2.843A5.765,5.765,0,0,1,4.235,8.37l1.138.438a5.147,5.147,0,0,0-.135,1.262,4.7,4.7,0,0,0,.191,1.244ZM4.661,7.26a6.888,6.888,0,0,1,1.02-1.409A5.475,5.475,0,0,1,7.042,4.8L7.52,5.873a4.734,4.734,0,0,0-.975.8A5.145,5.145,0,0,0,5.8,7.7Zm2.633,7.989a5.8,5.8,0,0,1-1.41-1A6.15,6.15,0,0,1,4.821,12.9l1.086-.506a5.632,5.632,0,0,0,.8.992,4.631,4.631,0,0,0,1.016.756Zm1.33-9.843-.5-1.115A6.4,6.4,0,0,1,9.847,4a5.912,5.912,0,0,1,1.721.207l-.427,1.111A4.718,4.718,0,0,0,9.873,5.2a5.119,5.119,0,0,0-1.249.2M8.4,15.676l.427-1.111a4.862,4.862,0,0,0,2.545-.073l.5,1.114a5.9,5.9,0,0,1-1.729.292A6.187,6.187,0,0,1,8.4,15.676m5.688-8.169a5.442,5.442,0,0,0-.811-1,4.9,4.9,0,0,0-1.03-.762l.427-1.11a5.987,5.987,0,0,1,1.424,1A6.068,6.068,0,0,1,15.179,7ZM12.958,15.1l-.478-1.076a4.7,4.7,0,0,0,.975-.8A5.152,5.152,0,0,0,14.2,12.2l1.138.438a6.839,6.839,0,0,1-1.019,1.408A5.428,5.428,0,0,1,12.958,15.1m1.669-4.01a5.2,5.2,0,0,0,.135-1.262,4.7,4.7,0,0,0-.191-1.245L15.647,8.1a5.782,5.782,0,0,1,.118,3.422Z"
						fill="currentColor"
					/>
				</g>
			</g>
			<rect id="Rectangle_3485" data-name="Rectangle 3485" width="26" height="26" fill="none" />
		</svg>
	</SvgIcon>
);

export const MonitorIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<svg id="bsn-monitor-devices" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
			<path
				id="Path_10055"
				data-name="Path 10055"
				d="M4,0H20a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z"
				fill="#4b9c14"
				opacity="0"
			/>
			<path
				id="Union_62"
				data-name="Union 62"
				d="M7.169,19.632l-.394-3.124a5.584,5.584,0,0,1-.519-.262c-.175-.1-.342-.205-.5-.315L2.832,17.158,0,12.29l2.536-1.9q0-.045-.007-.089-.015-.238-.015-.474t.016-.461q0-.058.009-.119L0,7.341,2.832,2.494,5.754,3.713c.164-.113.333-.221.508-.321s.337-.184.5-.26L7.171,0h5.66l.394,3.139a4.95,4.95,0,0,1,.52.267c.155.092.312.195.469.307L17.169,2.5,20,7.341,17.437,9.263q0,.065.006.129c0,.141,0,.282,0,.424s0,.284-.01.43q0,.071-.011.145l2.539,1.9-2.832,4.87L14.21,15.921c-.161.114-.325.22-.49.316a5.247,5.247,0,0,1-.494.255l-.394,3.139Zm-.887-4.97a4.537,4.537,0,0,0,.639.435,3.83,3.83,0,0,0,.68.309l.4.132.349,2.769h3.3L12,15.538l.388-.137a3.806,3.806,0,0,0,.654-.305,5.708,5.708,0,0,0,.659-.452l.312-.247,2.557,1.083,1.65-2.838L15.96,10.953l.092-.415a2.131,2.131,0,0,0,.052-.352c.006-.126.009-.249.009-.37s0-.263,0-.394a1.61,1.61,0,0,0-.041-.308L15.974,8.7l2.278-1.708L16.6,4.165,14.008,5.232,13.7,4.988a5.882,5.882,0,0,0-.641-.445,3.945,3.945,0,0,0-.676-.314L12,4.091l-.347-2.766H8.346L7.99,4.082l-.382.138a4.324,4.324,0,0,0-.678.319,5.6,5.6,0,0,0-.67.451l-.31.243L3.4,4.167,1.748,6.991,3.957,8.647l-.051.383q-.03.229-.043.421t-.013.374q0,.194.013.389t.041.373l.061.391L1.747,12.641,3.4,15.482,5.97,14.4Zm2.676-1.994a1.022,1.022,0,0,1,1.963-.39H14.8v.811H10.907a1.022,1.022,0,0,1-1.949-.421Zm.5,0a.518.518,0,1,0,.518-.515A.517.517,0,0,0,9.461,12.668Zm-4.252.406v-.811h3.01v.811ZM6.89,10.218H5.208V9.407H6.9a1.014,1.014,0,1,1-.014.811Zm.425-.39a.519.519,0,1,0,.519-.515A.518.518,0,0,0,7.315,9.828Zm2.281.406V9.372h5.2v.862Zm1.556-3.246A1.023,1.023,0,0,1,13.1,6.567h1.7v.811H13.117a1.023,1.023,0,0,1-1.966-.39Zm.5,0a.519.519,0,1,0,.519-.515A.517.517,0,0,0,11.655,6.988Zm-6.447.355V6.557h5.2v.786Z"
				transform="translate(2 2.184)"
				fill="currentColor"
			/>
		</svg>
	</SvgIcon>
);

export const DeviceIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.device-line-st0{display:none;}
	.device-line-st1{display:inline;fill:currentColor;}
	.device-line-st2{fill:none;stroke:currentColor;stroke-width:0.9452;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2" className="device-line-st0">
			<rect x="3.1" y="1.1" className="device-line-st1" width="2.9" height="13.1" />
			<rect x="5.8" y="6.4" className="device-line-st1" width="7" height="7.7" />
			<rect x="12" y="3.3" className="device-line-st1" width="0.8" height="3.4" />
			<rect x="5.7" y="1.9" className="device-line-st1" width="0.6" height="1.6" />
			<rect x="5.2" y="3.1" className="device-line-st1" width="7.2" height="0.6" />
			<rect x="5.9" y="3.5" className="device-line-st1" width="1.9" height="3.2" />
		</g>
		<g id="Layer_1">
			<g>
				<polygon className="device-line-st2" points="2.8,0.9 6.1,0.9 6.6,3.1 13,3.1 13,14.3 2.8,14.3 		" />
				<line className="device-line-st2" x1="9.4" y1="11.8" x2="4.1" y2="11.8" />
				<line className="device-line-st2" x1="9.4" y1="8.6" x2="4.1" y2="8.6" />
				<line className="device-line-st2" x1="6.4" y1="2.2" x2="12.5" y2="0.9" />
				<line className="device-line-st2" x1="12.5" y1="15.4" x2="10.9" y2="15.4" />
				<line className="device-line-st2" x1="3.4" y1="15.4" x2="5" y2="15.4" />
				<rect x="7.4" y="4.2" className="device-line-st2" width="4.4" height="2.2" />
			</g>
		</g>
	</SvgIcon>
);

export const DeviceIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.device-fill-st0{fill:currentColor;}
	.device-fill-st1{fill:none;stroke:currentColor;stroke-width:0.9452;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2">
			<rect x="3.1" y="1.1" className="device-fill-st0" width="2.9" height="13.1" />
			<rect x="5.8" y="6.4" className="device-fill-st0" width="7" height="7.7" />
			<rect x="12" y="3.3" className="device-fill-st0" width="0.8" height="3.4" />
			<rect x="5.7" y="1.9" className="device-fill-st0" width="0.6" height="1.6" />
			<rect x="5.2" y="3.1" className="device-fill-st0" width="7.2" height="0.6" />
			<rect x="5.9" y="3.5" className="device-fill-st0" width="1.9" height="3.2" />
		</g>
		<g id="Layer_1">
			<g>
				<polygon className="device-fill-st1" points="2.8,0.9 6.1,0.9 6.6,3.1 13,3.1 13,14.3 2.8,14.3 		" />
				<line className="device-fill-st1" x1="9.4" y1="11.8" x2="4.1" y2="11.8" />
				<line className="device-fill-st1" x1="9.4" y1="8.6" x2="4.1" y2="8.6" />
				<line className="device-fill-st1" x1="6.4" y1="2.2" x2="12.5" y2="0.9" />
				<line className="device-fill-st1" x1="12.5" y1="15.4" x2="10.9" y2="15.4" />
				<line className="device-fill-st1" x1="3.4" y1="15.4" x2="5" y2="15.4" />
				<rect x="7.4" y="4.2" className="device-fill-st1" width="4.4" height="2.2" />
			</g>
		</g>
	</SvgIcon>
);

export const NamingIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<g id="Group_6882" data-name="Group 6882" transform="translate(14123 9434.5)" opacity="0.971">
			<g id="Group_6880" data-name="Group 6880" transform="translate(-413 -767)">
				<g id="Group_6879" data-name="Group 6879" transform="translate(1)">
					<path
						id="Subtraction_16"
						data-name="Subtraction 16"
						d="M6.771,20.173H1.921A1.924,1.924,0,0,1,0,18.251V1.921A1.924,1.924,0,0,1,1.921,0H14.409A1.924,1.924,0,0,1,16.33,1.921V9.094a7.652,7.652,0,0,0-1.441-.442V1.921a.481.481,0,0,0-.481-.481H1.921a.481.481,0,0,0-.481.481v16.33a.481.481,0,0,0,.481.481H6.092a7.684,7.684,0,0,0,.678,1.439ZM13.583,5.194H2.747V3.362H13.583v1.83Z"
						transform="translate(-13706.165 -8665.5)"
						fill="currentColor"
					/>
					<g id="Group_6878" data-name="Group 6878" transform="translate(-59.25 110.404)">
						<path
							id="Subtraction_15"
							data-name="Subtraction 15"
							d="M6.2,12.4A6.2,6.2,0,1,1,10.121,1.394l-.946.949A4.822,4.822,0,0,0,6.2,1.329a4.87,4.87,0,1,0,4.762,3.837l1.072-1.074A6.207,6.207,0,0,1,6.2,12.4Z"
							transform="translate(-13640 -8766.047)"
							fill="currentColor"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24"
							d="M78.168-877.937l-2.921-2.921,1.051-1.055,1.87,1.87,6.768-6.784,1.055,1.055Z"
							transform="translate(-13713.141 -7878.95)"
							fill="none"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24_-_Outline"
							data-name="add_task_FILL1_wght500_GRAD0_opsz24 - Outline"
							d="M78.087-877.391l-3.547-3.547,1.676-1.683,1.87,1.87,6.768-6.784,1.682,1.682Zm-2.3-3.549,2.3,2.3,7.2-7.209-.428-.428L78.088-879.5l-1.87-1.87Z"
							transform="translate(-13713.06 -7878.869)"
							fill="none"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24-2"
							data-name="add_task_FILL1_wght500_GRAD0_opsz24"
							d="M78.168-877.937l-2.921-2.921,1.051-1.055,1.87,1.87,6.768-6.784,1.055,1.055Z"
							transform="translate(-13713.141 -7878.323)"
							fill="currentColor"
						/>
					</g>
				</g>
				<rect
					id="Rectangle_3067"
					data-name="Rectangle 3067"
					width="26"
					height="26"
					transform="translate(-13710 -8667.5)"
					fill="none"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const NamingIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<g id="Group_6882" data-name="Group 6882" transform="translate(14123 9434.5)" opacity="0.971">
			<g id="Group_6880" data-name="Group 6880" transform="translate(-413 -767)">
				<g id="Group_6879" data-name="Group 6879" transform="translate(1)">
					<path
						id="Subtraction_16"
						data-name="Subtraction 16"
						d="M6.771,20.173H1.921A1.924,1.924,0,0,1,0,18.251V1.921A1.924,1.924,0,0,1,1.921,0H14.409A1.924,1.924,0,0,1,16.33,1.921V9.094a7.652,7.652,0,0,0-1.441-.442V1.921a.481.481,0,0,0-.481-.481H1.921a.481.481,0,0,0-.481.481v16.33a.481.481,0,0,0,.481.481H6.092a7.684,7.684,0,0,0,.678,1.439ZM13.583,5.194H2.747V3.362H13.583v1.83Z"
						transform="translate(-13706.165 -8665.5)"
						fill="currentColor"
					/>
					<g id="Group_6878" data-name="Group 6878" transform="translate(-59.25 110.404)">
						<path
							id="Subtraction_15"
							data-name="Subtraction 15"
							d="M6.2,12.4A6.2,6.2,0,1,1,10.121,1.394l-.946.949A4.822,4.822,0,0,0,6.2,1.329a4.87,4.87,0,1,0,4.762,3.837l1.072-1.074A6.207,6.207,0,0,1,6.2,12.4Z"
							transform="translate(-13640 -8766.047)"
							fill="currentColor"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24"
							d="M78.168-877.937l-2.921-2.921,1.051-1.055,1.87,1.87,6.768-6.784,1.055,1.055Z"
							transform="translate(-13713.141 -7878.95)"
							fill="none"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24_-_Outline"
							data-name="add_task_FILL1_wght500_GRAD0_opsz24 - Outline"
							d="M78.087-877.391l-3.547-3.547,1.676-1.683,1.87,1.87,6.768-6.784,1.682,1.682Zm-2.3-3.549,2.3,2.3,7.2-7.209-.428-.428L78.088-879.5l-1.87-1.87Z"
							transform="translate(-13713.06 -7878.869)"
							fill="none"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24-2"
							data-name="add_task_FILL1_wght500_GRAD0_opsz24"
							d="M78.168-877.937l-2.921-2.921,1.051-1.055,1.87,1.87,6.768-6.784,1.055,1.055Z"
							transform="translate(-13713.141 -7878.323)"
							fill="currentColor"
						/>
					</g>
				</g>
				<rect
					id="Rectangle_3067"
					data-name="Rectangle 3067"
					width="26"
					height="26"
					transform="translate(-13710 -8667.5)"
					fill="none"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const LicenseIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<rect id="Rectangle_3023" data-name="Rectangle 3023" width="26" height="26" fill="none" />
		<g id="devices_black_24dp" transform="translate(1 1)">
			<path id="Path_6934" data-name="Path 6934" d="M0,0H24V24H0Z" fill="none" />
			<path
				id="Path_6935"
				data-name="Path 6935"
				d="M4,6H22V4H4A2.006,2.006,0,0,0,2,6V17H0v3H14V17H4ZM23,8H17a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V9A1,1,0,0,0,23,8Zm-1,9H18V10h4Z"
				// fill="#323232"
			/>
		</g>
	</SvgIcon>
);

export const LicenseIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<rect id="Rectangle_3023" data-name="Rectangle 3023" width="26" height="26" fill="none" />
		<g id="devices_black_24dp" transform="translate(1 1)">
			<path id="Path_6934" data-name="Path 6934" d="M0,0H24V24H0Z" fill="none" />
			<path
				id="Path_6935"
				data-name="Path 6935"
				d="M4,6H22V4H4A2.006,2.006,0,0,0,2,6V17H0v3H14V17H4ZM23,8H17a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V9A1,1,0,0,0,23,8Zm-1,9H18V10h4Z"
				// fill="#323232"
			/>
		</g>
	</SvgIcon>
);

export const TransferIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" height="24" width="24" {...props}>
		<path d="m480-320 160-160-160-160-56 56 64 64H320v80h168l-64 64 56 56Zm0 240q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
	</SvgIcon>
);

export const RolesIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.127 26.43" {...props}>
		<g transform="translate(.125)">
			<path fill="none" d="M0 0H26.001V26.43H0z" data-name="Rectangle 2207" transform="translate(.001)" />
			<g fill="currentColor" data-name="Group 4722" transform="translate(-59.501 -973.001)">
				<path
					stroke="currentColor"
					strokeWidth="0.25"
					d="M78.621 997.431H61.378a1.857 1.857 0 01-1.877-1.877 7.225 7.225 0 01.329-1.99c.325-1.41 3.327-2.479 6.522-3.426l.442-.11c.2-.1.545-.824.664-2.1a3.152 3.152 0 01-.884-1.106.562.562 0 01-.114-.169.567.567 0 00-.108-.164 5.985 5.985 0 01-.774-1.435 2.968 2.968 0 01-.658-.549 5.62 5.62 0 01-.667-2.99 1.33 1.33 0 01.551-.552 6.125 6.125 0 011.439-4.31v-.223a1.817 1.817 0 011.549-1.1.858.858 0 01.105-.442 1.534 1.534 0 01.778-.884h.007a.4.4 0 01.321.11l.223.219c0 .113.217.222.661.332a15.4 15.4 0 011.653.541h.01l.027.01c.12.045.223.084.3.11 2.008.777 3.206 2.884 3.206 5.635a.9.9 0 01.55.548 5.42 5.42 0 01-.55 2.991 1.356 1.356 0 01-.551.552 6.461 6.461 0 01-.468.892l-.008.013c-.118.2-.215.362-.3.53a.568.568 0 00-.223.442 3.951 3.951 0 01-.755.978l-.02.02a3.188 3.188 0 00.552 2.1c.417.165.9.331 1.422.493l-.287.979c-.674-.2-1.127-.344-1.468-.479-1.154-.525-1.213-2.669-1.213-3.094v-.445l.333-.329.018-.018a2.477 2.477 0 00.424-.537 1.251 1.251 0 01.333-.771.8.8 0 01.219-.442 2.011 2.011 0 00.361-.6l.01-.022.071-.151.223-.332.328-.223.11-.11a4.457 4.457 0 00.555-1.99l-.665-.219v-.774a5.948 5.948 0 00-.69-2.941 3.881 3.881 0 00-1.852-1.7h0a.539.539 0 01-.327-.109 6.549 6.549 0 00-1.549-.555 1.614 1.614 0 01-.529-.133l-.02-.007a8.103 8.103 0 00-.226-.079v.774l-.884.219a1.216 1.216 0 00-.665.223v.442l-.328.333a4.807 4.807 0 00-1.106 3.535v.665l-.552.329a3.57 3.57 0 00.552 1.881l.219.219.332.223.223.442a3.445 3.445 0 00.539 1.087l.013.019.013.013c.1.1.21.21.21.316l.11.113a2.792 2.792 0 00.551.771l.556.333-.113.665c0 .987-.377 2.565-1.217 2.984h-.219l-.442.109c-3.6 1.122-5.536 2.014-5.748 2.652a4.473 4.473 0 00-.332 1.658.752.752 0 00.773.774h17.353a.752.752 0 00.774-.774c0-.091 0-.178-.008-.276h1c.009.137.009.259.009.389a1.859 1.859 0 01-1.883 1.874z"
					data-name="Subtraction 10"
				/>
				<path
					d="M-1270.261 2083.955l-.438-1.085h-.093a3.506 3.506 0 01-.915-.123 5.034 5.034 0 01-1.111-.405l-.976.735-1.138-1.061.769-.927a3.312 3.312 0 01-.49-1.027 3.177 3.177 0 01-.081-.831v-.223l-1.113-.362.344-1.613 1.206.158a2.507 2.507 0 01.583-.818 2.788 2.788 0 01.868-.633l-.142-1.2 1.589-.355.438 1.086h.168a3.128 3.128 0 01.916.119 3.227 3.227 0 01.788.293c.077.037.158.076.248.117l.972-.834 1.038 1.064-.765 1.028a3.305 3.305 0 01.474 1.036c.079.349.129.636.182.94l.018.1 1.113.362-.344 1.613-1.206-.158-.078.127a3.474 3.474 0 01-.533.723 2.633 2.633 0 01-.84.6l.142 1.2-1.588.355zm-.634-7.635a2.754 2.754 0 00-2.75 2.75 2.753 2.753 0 002.75 2.75 2.753 2.753 0 002.75-2.75 2.753 2.753 0 00-2.75-2.75z"
					data-name="Subtraction 11"
					transform="translate(1350.316 -1089.749)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const RolesIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26.278 26.43">
		<style type="text/css">{`.role-line-st0{fill:currentColor;}`}</style>
		<g id="user-roles-icon-outline" transform="translate(0.125)">
			<rect
				id="Rectangle_2207"
				data-name="Rectangle 2207"
				width="26.002"
				height="26.43"
				transform="translate(0.001)"
				fill="none"
			/>
			<g id="Group_4722" data-name="Group 4722" transform="translate(-59.501 -973.001)">
				<path
					className="role-line-st0"
					id="Subtraction_10"
					data-name="Subtraction 10"
					d="M14085.121-6126.569h-17.243a1.857,1.857,0,0,1-1.877-1.877,7.225,7.225,0,0,1,.329-1.99c.325-1.41,3.327-2.479,6.522-3.426l.442-.11c.2-.1.545-.824.664-2.1a3.152,3.152,0,0,1-.884-1.106.562.562,0,0,1-.114-.169.567.567,0,0,0-.108-.164,5.985,5.985,0,0,1-.774-1.435,2.968,2.968,0,0,1-.658-.549,5.62,5.62,0,0,1-.667-2.99,1.33,1.33,0,0,1,.551-.552,6.125,6.125,0,0,1,1.439-4.31v-.223a1.817,1.817,0,0,1,1.549-1.1.858.858,0,0,1,.105-.442,1.534,1.534,0,0,1,.778-.884h.007a.4.4,0,0,1,.321.11l.223.219c0,.113.217.222.661.332a15.4,15.4,0,0,1,1.653.541l.01,0,.027.01c.12.045.223.084.3.11,2.008.777,3.206,2.884,3.206,5.635a.9.9,0,0,1,.55.548,5.42,5.42,0,0,1-.55,2.991,1.356,1.356,0,0,1-.551.552,6.461,6.461,0,0,1-.468.892l-.008.013c-.118.2-.215.362-.3.53a.568.568,0,0,0-.223.442,3.951,3.951,0,0,1-.755.978l-.02.02a3.188,3.188,0,0,0,.552,2.1c.417.165.9.331,1.422.493l-.287.979c-.674-.2-1.127-.344-1.468-.479-1.154-.525-1.213-2.669-1.213-3.094v-.445l.333-.329.018-.018a2.477,2.477,0,0,0,.424-.537,1.251,1.251,0,0,1,.333-.771.8.8,0,0,1,.219-.442,2.011,2.011,0,0,0,.361-.6l.01-.022c.025-.054.048-.1.071-.151l.223-.332.328-.223.11-.11a4.457,4.457,0,0,0,.555-1.99l-.665-.219v-.774a5.948,5.948,0,0,0-.69-2.941,3.881,3.881,0,0,0-1.852-1.7h0a.539.539,0,0,1-.327-.109,6.549,6.549,0,0,0-1.549-.555,1.614,1.614,0,0,1-.529-.133l-.02-.007c-.071-.026-.145-.052-.226-.079v.774l-.884.219a1.216,1.216,0,0,0-.665.223v.442l-.328.333a4.807,4.807,0,0,0-1.106,3.535v.665l-.552.329a3.57,3.57,0,0,0,.552,1.881l.219.219.332.223.223.442a3.445,3.445,0,0,0,.539,1.087l.013.019.013.013c.1.1.21.21.21.316l.11.113a2.792,2.792,0,0,0,.551.771l.556.333-.113.665c0,.987-.377,2.565-1.217,2.984h-.219l-.442.109c-3.6,1.122-5.536,2.014-5.748,2.652a4.473,4.473,0,0,0-.332,1.658.752.752,0,0,0,.773.774h17.353a.752.752,0,0,0,.774-.774c0-.091,0-.178-.008-.276h1c.009.137.009.259.009.389A1.859,1.859,0,0,1,14085.121-6126.569Z"
					transform="translate(-14006.5 7124)"
					stroke="currentColor"
					strokeWidth="0.25"
				/>
				<path
					className="role-line-st0"
					id="Subtraction_11"
					data-name="Subtraction 11"
					d="M-1270.261,2083.955h0l-.438-1.085h-.093a3.506,3.506,0,0,1-.915-.123,5.034,5.034,0,0,1-1.111-.405l-.976.735-1.138-1.061.769-.927a3.312,3.312,0,0,1-.49-1.027,3.177,3.177,0,0,1-.081-.831c0-.077,0-.15,0-.223l-1.113-.362.344-1.613,1.206.158a2.507,2.507,0,0,1,.583-.818,2.788,2.788,0,0,1,.868-.633l-.142-1.2,1.589-.355.438,1.086c.053,0,.109,0,.168,0a3.128,3.128,0,0,1,.916.119,3.227,3.227,0,0,1,.788.293c.077.037.158.076.248.117l.972-.834,1.038,1.064-.765,1.028a3.305,3.305,0,0,1,.474,1.036c.079.349.129.636.182.94l.018.1,1.113.362-.344,1.613-1.206-.158-.078.127a3.474,3.474,0,0,1-.533.723,2.633,2.633,0,0,1-.84.6l.142,1.2-1.588.355Zm-.634-7.635a2.754,2.754,0,0,0-2.75,2.75,2.753,2.753,0,0,0,2.75,2.75,2.753,2.753,0,0,0,2.75-2.75A2.753,2.753,0,0,0-1270.895,2076.32Z"
					transform="translate(1350.317 -1089.749)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const RolesIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26.278 26.43">
		<style type="text/css">{`.role-fill-st0{fill:currentColor;}`}</style>
		<g id="user-roles-icon-filled" transform="translate(0.125)">
			<g id="user-roles-icon-light-mode">
				<rect
					id="Rectangle_2207"
					data-name="Rectangle 2207"
					width="26.002"
					height="26.43"
					transform="translate(0.001)"
					fill="none"
				/>
				<g id="Group_4722" data-name="Group 4722" transform="translate(-59.501 -973.001)">
					<path
						className="role-fill-st0"
						id="Subtraction_10"
						data-name="Subtraction 10"
						d="M14085.121-6126.569h-17.243a1.857,1.857,0,0,1-1.877-1.877,7.225,7.225,0,0,1,.329-1.99c.325-1.41,3.327-2.479,6.522-3.426l.442-.11c.2-.1.545-.824.664-2.1a3.152,3.152,0,0,1-.884-1.106.562.562,0,0,1-.114-.169.567.567,0,0,0-.108-.164,5.985,5.985,0,0,1-.774-1.435,2.968,2.968,0,0,1-.658-.549,5.62,5.62,0,0,1-.667-2.99,1.33,1.33,0,0,1,.551-.552,6.125,6.125,0,0,1,1.439-4.31v-.223a1.817,1.817,0,0,1,1.549-1.1.858.858,0,0,1,.105-.442,1.534,1.534,0,0,1,.778-.884h.007a.4.4,0,0,1,.321.11l.223.219c0,.113.217.222.661.332a15.4,15.4,0,0,1,1.653.541l.01,0,.027.01c.12.045.223.084.3.11,2.008.777,3.206,2.884,3.206,5.635a.9.9,0,0,1,.55.548,5.42,5.42,0,0,1-.55,2.991,1.356,1.356,0,0,1-.551.552,6.461,6.461,0,0,1-.468.892l-.008.013c-.118.2-.215.362-.3.53a.568.568,0,0,0-.223.442,3.951,3.951,0,0,1-.755.978l-.02.02a3.188,3.188,0,0,0,.552,2.1c.417.165.9.331,1.422.493l-.287.979c-.674-.2-1.127-.344-1.468-.479-1.154-.525-1.213-2.669-1.213-3.094v-.445l.333-.329.018-.018a2.477,2.477,0,0,0,.424-.537,1.251,1.251,0,0,1,.333-.771.8.8,0,0,1,.219-.442,2.011,2.011,0,0,0,.361-.6l.01-.022c.025-.054.048-.1.071-.151l.223-.332.328-.223.11-.11a4.457,4.457,0,0,0,.555-1.99l-.665-.219v-.774a5.948,5.948,0,0,0-.69-2.941,3.881,3.881,0,0,0-1.852-1.7h0a.539.539,0,0,1-.327-.109,6.549,6.549,0,0,0-1.549-.555,1.614,1.614,0,0,1-.529-.133l-.02-.007c-.071-.026-.145-.052-.226-.079v.774l-.884.219a1.216,1.216,0,0,0-.665.223v.442l-.328.333a4.807,4.807,0,0,0-1.106,3.535v.665l-.552.329a3.57,3.57,0,0,0,.552,1.881l.219.219.332.223.223.442a3.445,3.445,0,0,0,.539,1.087l.013.019.013.013c.1.1.21.21.21.316l.11.113a2.792,2.792,0,0,0,.551.771l.556.333-.113.665c0,.987-.377,2.565-1.217,2.984h-.219l-.442.109c-3.6,1.122-5.536,2.014-5.748,2.652a4.473,4.473,0,0,0-.332,1.658.752.752,0,0,0,.773.774h17.353a.752.752,0,0,0,.774-.774c0-.091,0-.178-.008-.276h1c.009.137.009.259.009.389A1.859,1.859,0,0,1,14085.121-6126.569Z"
						transform="translate(-14006.5 7124)"
						stroke="currentColor"
						strokeWidth="0.25"
					/>
					<path
						className="role-fill-st0"
						id="Subtraction_11"
						data-name="Subtraction 11"
						d="M-1270.261,2083.955h0l-.438-1.085h-.093a3.506,3.506,0,0,1-.915-.123,5.034,5.034,0,0,1-1.111-.405l-.976.735-1.138-1.061.769-.927a3.312,3.312,0,0,1-.49-1.027,3.177,3.177,0,0,1-.081-.831c0-.077,0-.15,0-.223l-1.113-.362.344-1.613,1.206.158a2.507,2.507,0,0,1,.583-.818,2.788,2.788,0,0,1,.868-.633l-.142-1.2,1.589-.355.438,1.086c.053,0,.109,0,.168,0a3.128,3.128,0,0,1,.916.119,3.227,3.227,0,0,1,.788.293c.077.037.158.076.248.117l.972-.834,1.038,1.064-.765,1.028a3.305,3.305,0,0,1,.474,1.036c.079.349.129.636.182.94l.018.1,1.113.362-.344,1.613-1.206-.158-.078.127a3.474,3.474,0,0,1-.533.723,2.633,2.633,0,0,1-.84.6l.142,1.2-1.588.355Zm-.634-7.635a2.754,2.754,0,0,0-2.75,2.75,2.753,2.753,0,0,0,2.75,2.75,2.753,2.753,0,0,0,2.75-2.75A2.753,2.753,0,0,0-1270.895,2076.32Z"
						transform="translate(1350.317 -1089.749)"
					/>
				</g>
			</g>
			<path
				className="role-fill-st0"
				id="Path_6929"
				data-name="Path 6929"
				d="M2123.375-1671.262l1.449.526,1.814.833,1.108.838.545.883.591,1.373.36,1.406-.36.955.922.685-.264,1.422-.658,1.11-.791,1-.346,1.014-.847,1.073v1.285l.59,1.085,1.007.543.873-.3a3.3,3.3,0,0,0,.437,3.162c1.166,1.38,4.106,1.409,4.106,1.409l.73.393-.187.783-.684.684h-1.9l-16.511.028s-.839-.374-.867-1.1a3.61,3.61,0,0,1,.343-1.942,3.366,3.366,0,0,1,1.868-1.776c.815-.173,2.464-.887,3.471-1.251s1.929-.47,2.115-1.325a4.455,4.455,0,0,0,.177-1.808,26.856,26.856,0,0,1-1.854-2.6c-.305-.749-1.065-1.356-1.121-2.013s-.332-1.344-.179-1.634a3.34,3.34,0,0,0,.6-1.369,4.855,4.855,0,0,1,.7-2.4c.513-.69.47-1.413.971-1.621s1.333-.571,1.333-.571Z"
				transform="translate(-2113.999 1673)"
			/>
		</g>
	</SvgIcon>
);

export const UserIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">{`.user-line-st0{fill:currentColor;}`}</style>
		<g id="Layer_2" />
		<g id="Layer_1">
			<g>
				<path
					className="user-line-st0"
					d="M10,1.7c0.3,0.1,0.5,0.2,0.7,0.2c0.5,0.1,1,0.3,1.4,0.5c0.1,0.1,0.3,0.1,0.3,0.1c1.4,0.6,2.3,2.1,2.3,4.2v0.7
			l0.6,0.2c0,0.3-0.1,1.1-0.5,1.8c0,0,0,0-0.1,0.1l-0.3,0.2L14.2,10c-0.1,0.2-0.2,0.5-0.4,0.7c-0.1,0.1-0.2,0.3-0.2,0.4
			c-0.1,0.1-0.3,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.5l-0.3,0.3V13c0,0.2,0,2.3,1.1,2.8l0,0l0,0c0.5,0.2,1.2,0.4,1.9,0.6
			c1.1,0.3,3.5,1.1,3.7,1.9c0.3,1,0.3,1.2,0.3,1.5c0,0.3-0.2,0.7-0.7,0.7H3.2c-0.5,0-0.7-0.4-0.7-0.7c0-0.2,0-0.7,0.3-1.5l0,0l0,0
			c0.1-0.3,0.7-1,5.2-2.4l0.4-0.1l0.1,0l0.1,0c0.8-0.4,1.1-1.9,1.1-2.7l0.1-0.6l-0.5-0.3c-0.1-0.1-0.3-0.3-0.5-0.7l-0.1-0.1l0,0
			c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.5-1L7.8,9.7L7.5,9.5c0,0-0.1-0.1-0.2-0.2C6.9,8.7,6.8,8,6.8,7.6l0.5-0.3V6.7
			c0-2,0.7-2.9,1-3.2l0.3-0.3V2.8C8.7,2.7,9,2.6,9.2,2.6L10,2.4L10,1.7 M9.8,0.4C9.5,0.5,9.2,0.9,9.1,1.2C9,1.4,9,1.5,9,1.6
			C8.4,1.7,7.8,2,7.6,2.6c0,0.1,0,0.1,0,0.2c-0.7,0.7-1.3,2-1.3,3.9C6.1,6.8,5.9,7,5.8,7.2C5.7,7.7,5.9,9,6.4,9.9
			c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.5,0.4,0.9,0.7,1.3c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.5,0.5,0.8,0.8,1c-0.1,1.1-0.4,1.8-0.6,1.9
			L7.7,15c-2.7,0.8-5.6,1.8-5.9,3.1c-0.3,1-0.3,1.7-0.3,1.8c0,0.9,0.7,1.7,1.7,1.7h15.6c1,0,1.7-0.8,1.7-1.7c0-0.4,0-0.7-0.3-1.8
			c-0.3-1.3-2.4-2-4.4-2.6c-0.7-0.2-1.3-0.4-1.8-0.6c-0.2-0.1-0.5-0.9-0.5-1.9c0.2-0.2,0.5-0.5,0.7-0.9c0-0.2,0.1-0.3,0.2-0.4
			c0.2-0.4,0.5-0.8,0.7-1.3c0.2-0.1,0.4-0.3,0.5-0.5C16,9,16.3,7.7,16.1,7.2C16,7,15.9,6.8,15.6,6.7c0-2.5-1.1-4.4-2.9-5.1
			c-0.3-0.1-1-0.4-1.8-0.6c-0.4-0.1-0.6-0.2-0.6-0.3c-0.1-0.1-0.1-0.1-0.2-0.2C10,0.4,9.9,0.4,9.8,0.4L9.8,0.4z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const UserIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">{`.user-fill-st0{fill:currentColor;}`}</style>
		<g id="Layer_2" />
		<g id="Layer_1">
			<g>
				<path
					className="user-fill-st0"
					d="M3.2,21.1c-0.8,0-1.2-0.6-1.2-1.2c0-0.2,0-0.8,0.3-1.7c0.3-1.2,4.1-2.3,5.6-2.8l0.4-0.1l0,0
			C9,15,9.2,13.4,9.2,13l0-0.3L9,12.6c-0.2-0.1-0.4-0.4-0.6-0.8l0-0.1l0,0c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.6-1.1L7.4,10
			L7.2,10C7.1,9.9,7,9.7,6.8,9.6C6.4,8.8,6.2,7.8,6.3,7.4c0.1-0.1,0.2-0.2,0.2-0.2L6.8,7V6.7c0-2.2,0.8-3.2,1.2-3.5L8.1,3V2.7
			c0.2-0.4,0.7-0.6,1-0.6L9.5,2V1.6c0-0.1,0-0.1,0-0.2C9.6,1.2,9.7,1.1,9.8,1l0,0c0.2,0.3,0.6,0.4,0.9,0.5c0.6,0.1,1.1,0.3,1.4,0.5
			C12.3,2,12.5,2,12.5,2.1c1.6,0.6,2.6,2.4,2.6,4.6v0.4l0.3,0.1c0.1,0,0.1,0.1,0.2,0.2c0.1,0.2-0.1,1.3-0.5,2.3
			c0,0.1-0.2,0.2-0.3,0.3L14.7,10l-0.1,0.2c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.1-0.2,0.3-0.3,0.6
			c-0.2,0.3-0.4,0.5-0.6,0.7L13,12.8V13c0,0.9,0.3,2.1,0.8,2.3c0.6,0.2,1.2,0.4,1.9,0.6c1.4,0.4,3.8,1.1,4.1,2.2
			c0.3,1.1,0.3,1.3,0.3,1.7c0,0.6-0.4,1.2-1.2,1.2H3.2z"
				/>
				<path
					className="user-fill-st0"
					d="M10,1.7c0.3,0.1,0.5,0.2,0.7,0.2c0.5,0.1,1,0.3,1.4,0.5c0.1,0.1,0.3,0.1,0.3,0.1c1.4,0.6,2.3,2.1,2.3,4.2v0.7
			l0.6,0.2c0,0.3-0.1,1.1-0.5,1.8c0,0,0,0-0.1,0.1l-0.3,0.2L14.2,10c-0.1,0.2-0.2,0.5-0.4,0.7c-0.1,0.1-0.2,0.3-0.2,0.4
			c-0.1,0.1-0.3,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.5l-0.3,0.3V13c0,0.2,0,2.3,1.1,2.8l0,0l0,0c0.5,0.2,1.2,0.4,1.9,0.6
			c1.1,0.3,3.5,1.1,3.7,1.9c0.3,1,0.3,1.2,0.3,1.5c0,0.3-0.2,0.7-0.7,0.7H3.2c-0.5,0-0.7-0.4-0.7-0.7c0-0.2,0-0.7,0.3-1.5l0,0l0,0
			c0.1-0.3,0.7-1,5.2-2.4l0.4-0.1l0.1,0l0.1,0c0.8-0.4,1.1-1.9,1.1-2.7l0.1-0.6l-0.5-0.3c-0.1-0.1-0.3-0.3-0.5-0.7l-0.1-0.1l0,0
			c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.5-1L7.8,9.7L7.5,9.5c0,0-0.1-0.1-0.2-0.2C6.9,8.7,6.8,8,6.8,7.6l0.5-0.3V6.7
			c0-2,0.7-2.9,1-3.2l0.3-0.3V2.8C8.7,2.7,9,2.6,9.2,2.6L10,2.4L10,1.7 M9.8,0.4C9.5,0.5,9.2,0.9,9.1,1.2C9,1.4,9,1.5,9,1.6
			C8.4,1.7,7.8,2,7.6,2.6c0,0.1,0,0.1,0,0.2c-0.7,0.7-1.3,2-1.3,3.9C6.1,6.8,5.9,7,5.8,7.2C5.7,7.7,5.9,9,6.4,9.9
			c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.5,0.4,0.9,0.7,1.3c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.5,0.5,0.8,0.8,1c-0.1,1.1-0.4,1.8-0.6,1.9
			L7.7,15c-2.7,0.8-5.6,1.8-5.9,3.1c-0.3,1-0.3,1.7-0.3,1.8c0,0.9,0.7,1.7,1.7,1.7h15.6c1,0,1.7-0.8,1.7-1.7c0-0.4,0-0.7-0.3-1.8
			c-0.3-1.3-2.4-2-4.4-2.6c-0.7-0.2-1.3-0.4-1.8-0.6c-0.2-0.1-0.5-0.9-0.5-1.9c0.2-0.2,0.5-0.5,0.7-0.9c0-0.2,0.1-0.3,0.2-0.4
			c0.2-0.4,0.5-0.8,0.7-1.3c0.2-0.1,0.4-0.3,0.5-0.5C16,9,16.3,7.7,16.1,7.2C16,7,15.9,6.8,15.6,6.7c0-2.5-1.1-4.4-2.9-5.1
			c-0.3-0.1-1-0.4-1.8-0.6c-0.4-0.1-0.6-0.2-0.6-0.3c-0.1-0.1-0.1-0.1-0.2-0.2C10,0.4,9.9,0.4,9.8,0.4L9.8,0.4z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const FormIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<style type="text/css">
			{`.form-line-st0{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-miterlimit:10;}
	.form-line-st1{fill:currentColor;}`}
		</style>
		<rect x="3.7" y="3.7" className="form-line-st0" width="16.6" height="16.7" />
		<rect x="7" y="7" className="form-line-st1" width="2" height="1.9" />
		<rect x="11" y="7" className="form-line-st1" width="6" height="1.9" />
		<rect x="7" y="11" className="form-line-st1" width="2" height="1.9" />
		<rect x="11" y="11" className="form-line-st1" width="6" height="1.9" />
		<rect x="7" y="15" className="form-line-st1" width="2" height="1.9" />
		<rect x="11" y="15" className="form-line-st1" width="6" height="1.9" />
	</SvgIcon>
);

export const FormIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<style type="text/css">
			{`.form-fill-st0{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-miterlimit:10;}
	.st1{fill:currentColor;}`}
		</style>
		<rect x="3.7" y="3.7" className="form-fill-st0" width="16.6" height="16.7" />
		<path
			className="form-fill-st1"
			d="M20,20.1H4V3.9h16V20.1z M9,7H7V9h2V7z M17,7h-6V9h6V7z M9,11H7v1.9h2V11z M17,11h-6v1.9h6V11z M9,15H7v1.9h2
	V15z M17,15h-6v1.9h6V15z"
		/>
	</SvgIcon>
);

export const LogIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.log-line-st0{display:none;}
	.log-line-st1{display:inline;fill:currentColor;}
	.log-line-st2{fill:none;stroke:currentColor;stroke-width:0.9615;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2" className="log-line-st0">
			<polygon className="log-line-st1" points="2.8,1.8 2.5,12 7.9,13.4 13.1,11.9 13.1,1.7 7.9,2.9 	" />
		</g>
		<g id="Layer_1">
			<polyline className="log-line-st2" points="13.4,3.3 15.1,3.3 15.1,13.5 0.7,13.5 0.7,3.3 2.4,3.3 	" />
			<g>
				<path
					className="log-line-st2"
					d="M7.9,3.3c0,0,1.3-0.8,2.6-1.1c1.4-0.3,2.7-0.2,2.7-0.2v10.2v0c0,0-1.4-0.1-2.7,0.2c-1.3,0.3-2.6,1.1-2.6,1.1
			V3.3z"
				/>
				<path
					className="log-line-st2"
					d="M7.9,13.5V3.3c0,0-1.3-0.8-2.6-1.1C3.9,1.8,2.6,1.9,2.6,1.9v10.2v0c0,0,1.4-0.1,2.7,0.2
			C6.6,12.7,7.9,13.5,7.9,13.5L7.9,13.5z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const LogIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.log-fill-st0{fill:currentColor;}
	.log-fill-st1{fill:none;stroke:currentColor;stroke-width:0.9615;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2">
			<polygon className="log-fill-st0" points="2.8,1.8 2.5,12 7.9,13.4 13.1,11.9 13.1,1.7 7.9,2.9 	" />
		</g>
		<g id="Layer_1">
			<polyline className="log-fill-st1" points="13.4,3.3 15.1,3.3 15.1,13.5 0.7,13.5 0.7,3.3 2.4,3.3 	" />
			<g>
				<path
					className="log-fill-st1"
					d="M7.9,3.3c0,0,1.3-0.8,2.6-1.1c1.4-0.3,2.7-0.2,2.7-0.2v10.2v0c0,0-1.4-0.1-2.7,0.2c-1.3,0.3-2.6,1.1-2.6,1.1
			V3.3z"
				/>
				<path
					className="log-fill-st1"
					d="M7.9,13.5V3.3c0,0-1.3-0.8-2.6-1.1C3.9,1.8,2.6,1.9,2.6,1.9v10.2v0c0,0,1.4-0.1,2.7,0.2
			C6.6,12.7,7.9,13.5,7.9,13.5L7.9,13.5z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const BellIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			transform="rotate(20 12 12)"
			fill="currentColor"
			d="M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21"
		/>
	</SvgIcon>
);

export const AddToGroupIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M2,16H10V14H2M18,14V10H16V14H12V16H16V20H18V16H22V14M14,6H2V8H14M14,10H2V12H14V10Z"
		/>
	</SvgIcon>
);

export const AddToDeviceGroupIcon = AddToGroupIcon;

export const AddToFormGroupIcon = AddToDeviceGroupIcon;

export const AddToWorkflowGroupIcon = AddToDeviceGroupIcon;

export const AddToUserGroupIcon = AddToDeviceGroupIcon;

export const LicenseGroupIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
		<g id="Layer_2">
			<rect
				x="3.8"
				y="2.7"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="1.6"
				height="12.1"
			/>
			<rect
				x="1.5"
				y="10.8"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="1.6"
				height="3.8"
			/>
			<rect
				x="13"
				y="11"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="1.6"
				height="3.8"
			/>
			<rect
				x="5.2"
				y="9.4"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="7.2"
				height="3.4"
			/>
			<rect
				x="4.6"
				y="11"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="1.6"
				height="3.8"
			/>
			<rect
				x="9.5"
				y="10.8"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="2.9"
				height="3.8"
			/>
			<rect
				x="4.5"
				y="1.2"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="7"
				height="3.2"
			/>
			<rect
				x="10.8"
				y="2.7"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="1.6"
				height="7.1"
			/>
			<rect
				x="7.1"
				y="4.2"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="2"
				height="5.4"
			/>
			<rect
				x="4.2"
				y="5.9"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="7"
				height="2"
			/>
		</g>
		<g id="Layer_1">
			<path
				style={{ fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				className="st1-LicenseGroupIcon"
				d="M3.4,10.6c-0.6,0.1-1.5,0.2-2.2,0.4v4"
			/>
			<path
				style={{ fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				className="st1-LicenseGroupIcon"
				d="M12.8,15l0-12.5c-0.6-0.1-0.7-0.2-1.3-0.3v-1C10.2,1.1,9.2,1,8.1,1C7,1,6,1.1,4.7,1.4v1C4.2,2.4,4,2.5,3.4,2.6   l0,12.5"
			/>
			<rect
				x="5.4"
				y="7.9"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				width="1.6"
				height="1.6"
			/>
			<rect
				x="5.4"
				y="4.3"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				width="1.6"
				height="1.6"
			/>
			<rect
				x="9.2"
				y="7.9"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				width="1.6"
				height="1.6"
			/>
			<rect
				x="9.2"
				y="4.3"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				width="1.6"
				height="1.6"
			/>
			<path
				style={{ fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				className="st1-LicenseGroupIcon"
				d="M12.8,10.6c0.6,0.1,1.5,0.2,2.2,0.4v4"
			/>
			<path
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				d="M9.6,15v-2.2c-0.7-0.2-1.3-0.2-1.7-0.2c-0.5,0-1.2,0.1-1.7,0.2V15"
			/>
			<line
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				x1="8"
				y1="15"
				x2="8"
				y2="12.6"
			/>
			<line
				style={{ fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				className="st1-LicenseGroupIcon"
				x1="0.5"
				y1="15"
				x2="15.7"
				y2="15"
			/>
		</g>
	</SvgIcon>
);

export const ClearSelectedIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M4 20H18V22H4C2.9 22 2 21.11 2 20V6H4V20M20.22 2H7.78C6.8 2 6 2.8 6 3.78V16.22C6 17.2 6.8 18 7.78 18H20.22C21.2 18 22 17.2 22 16.22V3.78C22 2.8 21.2 2 20.22 2M19 13.6L17.6 15L14 11.4L10.4 15L9 13.6L12.6 10L9 6.4L10.4 5L14 8.6L17.6 5L19 6.4L15.4 10L19 13.6Z"
		/>
	</SvgIcon>
);

export const ExpiredIcon = (props: Omit<MdiIconProps, 'path'>) => (
	<MdiIcon className={clsx('mdi-svg-icon', props.className)} path={mdiIcons.mdiClockAlert} {...props} />
);

export const LogoutIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 48 48">
		<g>
			<path
				d="M28.9,28.5c-0.5,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.1v7h-17V11h17v7c0,0.5,0.1,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.1,0.4
                  c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.1v-7c0-0.8-0.3-1.5-0.9-2.1C28.9,8.3,28.2,8,27.4,8h-17C9.6,8,8.9,8.3,8.3,8.9
                  C7.7,9.5,7.4,10.2,7.4,11v26c0,0.8,0.3,1.5,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9h17c0.8,0,1.5-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1v-7
                  c0-0.5-0.1-0.8-0.4-1.1C29.7,28.6,29.3,28.5,28.9,28.5z"
			/>
			<path
				d="M42.2,24c0-0.4-0.2-0.7-0.4-1c0,0,0-0.1-0.1-0.1L35,16.3c-0.3-0.3-0.7-0.5-1.1-0.5c-0.4,0-0.8,0.2-1.1,0.5
                c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.4,0.1,0.7,0.4,1l4.1,4.1H16.4c-0.5,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.6-0.4,1.1s0.1,0.8,0.4,1.1
                c0.3,0.3,0.7,0.4,1.1,0.4h20.5l-4.1,4.1c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.4,0.1,0.8,0.4,1.1c0.3,0.2,0.6,0.4,1.1,0.4
                c0.4,0,0.7-0.1,1-0.4l6.8-6.8C42,24.7,42.2,24.4,42.2,24z"
			/>
		</g>
	</SvgIcon>
);

export const BlockUserIcon = (props: Omit<MdiIconProps, 'path'>) => (
	<MdiIcon className="mdi-svg-icon" path={mdiIcons.mdiAccountCancelOutline} {...props} />
);

export const BulkActionCloseIcon = () => (
	// {/* <ClearSelectedIcon /> */}
	<LibraryAddCheckOutlined />
);

export const SortLabelIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 320 512">
		<path d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z" />
	</SvgIcon>
);

export const GroupIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M0 0h24v24H0V0z" fill="none" />
		<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
		<circle cx="8" cy="14" r="2" />
		<circle cx="12" cy="8" r="2" />
		<circle cx="16" cy="14" r="2" />
	</SvgIcon>
);

export const TrayArrowDownIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z" />
	</SvgIcon>
);

export const TrayArrowUpIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="m 2 12 H 4 V 17 H 20 V 12 H 22 V 17 C 22 18.11 21.11 19 20 19 H 4 C 2.9 19 2 18.11 2 17 V 12 M 12 2 L 17.55 7.45 L 16.13 8.87 L 13 5.75 V 15 H 11 V 5.75 L 8 8.87 L 6.46 7.45 L 12 2 Z" />
	</SvgIcon>
);

export const CopyIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M0 0h24v24H0z" fill="none" />
		<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
	</SvgIcon>
);

export const DesignIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M20.97 7.27c.39-.39.39-1.02 0-1.41l-2.83-2.83a.9959.9959 0 0 0-1.41 0l-4.49 4.49-3.89-3.89c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l3.89 3.89L3 16.76V21h4.24l4.52-4.52 3.89 3.89c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-3.89-3.89 4.48-4.48zM5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.2 1.2-1.9 1.9-3.88-3.88zm11.23 7.44-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9-3.89-3.89 1.9-1.9 1.21 1.21zM6.41 19H5v-1.41l9.61-9.61 1.3 1.3.11.11L6.41 19zm9.61-12.44 1.41-1.41 1.41 1.41-1.41 1.41-1.41-1.41z" />
	</SvgIcon>
);

export const PreviewAppIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<rect id="Rectangle_574" data-name="Rectangle 574" width="24" height="24" fill="none" />
		<path
			id="Path_6040"
			data-name="Path 6040"
			d="M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V7H19Zm-7-8.5A4.927,4.927,0,0,1,16.34,13a5.017,5.017,0,0,1-8.68,0A4.927,4.927,0,0,1,12,10.5M12,9a6.445,6.445,0,0,0-6,4,6.5,6.5,0,0,0,12,0,6.445,6.445,0,0,0-6-4Zm0,5.5A1.5,1.5,0,1,1,13.5,13,1.5,1.5,0,0,1,12,14.5Z"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const WorkflowPreviewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 96.8 88.595" {...props}>
		<g id="wfx-empty" transform="translate(-1.9 -5.902)" opacity="0.4">
			<g id="Group_1096" data-name="Group 1096">
				<path
					id="Path_6404"
					data-name="Path 6404"
					d="M39.8,47.9,55,32.7a2.587,2.587,0,0,1,1.8-.7h9a28.6,28.6,0,0,1-1.9,6.6c-1.7,3.8.8,6.7,4.3,5S98.7,25,98.7,25,71.7,8,68.2,6.4c-3.4-1.7-5.9,1.2-4.3,5a27.818,27.818,0,0,1,1.8,6.5H56.8a16.176,16.176,0,0,0-11.7,4.9L27.6,40.2C32.9,41.1,36.5,44.6,39.8,47.9Z"
					fill="currentColor"
				/>
			</g>
			<path
				id="Path_6405"
				data-name="Path 6405"
				d="M68.2,56.7c-3.4-1.7-5.9,1.2-4.3,5a34.6,34.6,0,0,1,1.9,6.6h-9a2.748,2.748,0,0,1-1.8-.7L39.4,51.9c-4.2-4.2-8-8.8-14.5-8.8H1.9V57.2H20c5.5,0,8,3.3,9.4,4.7L45.1,77.6a16.585,16.585,0,0,0,11.7,4.9h8.9A35.893,35.893,0,0,1,63.9,89c-1.7,3.8.8,6.7,4.3,5S98.7,75.4,98.7,75.4,71.7,58.3,68.2,56.7Z"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const WorkflowActivityLogIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 99 99" {...props}>
		<g id="menu_book_black_24dp" opacity="0.41">
			<g id="Group_1092" data-name="Group 1092">
				<rect id="Rectangle_910" data-name="Rectangle 910" width="99" height="99" fill="none" />
			</g>
			<g id="Group_1095" data-name="Group 1095" transform="translate(4.125 18.563)">
				<g id="Group_1094" data-name="Group 1094">
					<path
						id="Path_6400"
						data-name="Path 6400"
						d="M83.5,6.563A48.694,48.694,0,0,0,69.063,4.5c-8.044,0-16.706,1.65-22.687,6.188C40.394,6.15,31.731,4.5,23.688,4.5S6.981,6.15,1,10.688V71.119a2.218,2.218,0,0,0,2.063,2.063c.412,0,.619-.206,1.031-.206a50.348,50.348,0,0,1,19.594-4.537c8.044,0,16.706,1.65,22.688,6.188,5.569-3.506,15.675-6.187,22.688-6.187,6.806,0,13.819,1.237,19.594,4.331a1.859,1.859,0,0,0,1.031.206,2.218,2.218,0,0,0,2.063-2.062V10.688A28.135,28.135,0,0,0,83.5,6.563Zm0,55.688a47.934,47.934,0,0,0-14.437-2.062c-7.012,0-17.119,2.681-22.687,6.188V18.938c5.569-3.506,15.675-6.187,22.688-6.187A47.934,47.934,0,0,1,83.5,14.813Z"
						transform="translate(-1 -4.5)"
						fill="currentColor"
					/>
					<g id="Group_1093" data-name="Group 1093" transform="translate(49.5 18.563)">
						<path
							id="Path_6401"
							data-name="Path 6401"
							d="M31.563,15.188A48.238,48.238,0,0,1,41.875,16.26V9.99A55.7,55.7,0,0,0,31.563,9,47.466,47.466,0,0,0,13,12.424v6.847C17.661,16.631,24.137,15.188,31.563,15.188Z"
							transform="translate(-13 -9)"
							fill="currentColor"
						/>
						<path
							id="Path_6402"
							data-name="Path 6402"
							d="M13,15.084v6.847c4.661-2.64,11.137-4.084,18.563-4.084A48.238,48.238,0,0,1,41.875,18.92V12.65a55.7,55.7,0,0,0-10.312-.99A48.226,48.226,0,0,0,13,15.084Z"
							transform="translate(-13 -0.688)"
							fill="currentColor"
						/>
						<path
							id="Path_6403"
							data-name="Path 6403"
							d="M31.563,14.33A47.466,47.466,0,0,0,13,17.754V24.6c4.661-2.64,11.137-4.084,18.563-4.084A48.238,48.238,0,0,1,41.875,21.59V15.32A52.375,52.375,0,0,0,31.563,14.33Z"
							transform="translate(-13 7.656)"
							fill="currentColor"
						/>
					</g>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const LicenseIcon = (props: SvgIconProps) => {
	const style = `
		.st0-LicenseIcon{fill:none;}
		.st1-LicenseIcon{display:none;}
	`;
	return (
		<SvgIcon x="0px" y="0px" viewBox="0 0 20 20" {...props}>
			<style type="text/css">{style}</style>
			<g id="Layer_1">
				<g>
					<g>
						<path
							d="M18.7,8.2l-1.9-2.1l0.3-2.8l-2.8-0.6l-1.4-2.4l-2.6,1.1L7.7,0.2L6.2,2.6L3.5,3.2l0.3,2.8L1.9,8.2l1.9,2.1l-0.3,2.8
							l2.8,0.6l1.4,2.4l2.6-1.1l2.6,1.1l1.4-2.4l2.8-0.6l-0.3-2.8L18.7,8.2z M15.7,9.3l-0.4,0.5l0.1,0.7l0.1,1.5L14,12.3l-0.6,0.1
							L13,13l-0.8,1.3l-1.4-0.6l-0.6-0.3l-0.6,0.3l-1.4,0.6L7.6,13l-0.3-0.6l-0.6-0.1L5.1,12l0.1-1.5l0.1-0.7L4.9,9.3l-1-1.1l1-1.1
							l0.4-0.5L5.3,5.9L5.1,4.4l1.5-0.3L7.2,4l0.3-0.6l0.8-1.3l1.4,0.6L10.3,3l0.6-0.3l1.4-0.6L13,3.4L13.3,4L14,4.1l1.5,0.3l-0.1,1.5
							l-0.1,0.7l0.4,0.5l1,1.1L15.7,9.3z"
						/>
						<polygon
							className="st1-LicenseIcon"
							points="8.8,9.5 7.1,7.8 5.9,8.9 8.8,11.8 14.4,6.2 13.3,5"
						/>
					</g>
				</g>
			</g>
			<g id="Layer_2">
				<polygon points="3.3,11.6 0,15.7 3.4,15.9 4,19.8 7.2,16.1 6.5,14.8 4.5,17.1 4.2,14.9 2.5,14.8 3.6,13.5 3.2,13.4" />
				<polygon points="17.2,11.6 20,15.3 17.1,15.9 16.7,19.7 13.3,16 14,14.8 16,17 16.3,14.9 17.9,14.6 16.9,13.5 17.3,13.3" />
			</g>
		</SvgIcon>
	);
};

export const SettingsIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 24 24">
			<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2236" />
			<g transform="translate(1 1)">
				<path
					d="M13.307 25.25v-6.914h1.886v2.514H25.25v1.886H15.193v2.514zM3.25 22.736V20.85h6.914v1.886zm5.029-5.029v-2.514H3.25v-1.886h5.029v-2.514h1.886v6.914zm5.029-2.514v-1.886H25.25v1.886zm5.029-5.029V3.25h1.886v2.514h5.027V7.65h-5.029v2.514zM3.25 7.65V5.764h11.943V7.65z"
					transform="translate(-3.25 -3.25)"
				/>
			</g>
		</SvgIcon>
	);
};

export const RunningIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<path id="Path_6010" d="M6.3,6.5l7,4.5l-7,4.5V6.5 M3.6,1.7v18.6L18.3,11L3.6,1.7z" />
	</SvgIcon>
);

export const StoppedIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="Layer_8">
			<path id="Path_6012" d="M17.1,4.7V17H4.8V4.7H17.1 M20.2,1.7H1.8v18.4h18.4C20.2,20.1,20.2,1.7,20.2,1.7z" />
		</g>
	</SvgIcon>
);

export const ShareIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<path
			id="Path_6008"
			d="M14.9,10c1.6,0,3-1.3,3-3s-1.3-3-3-3c-1.6,0-3,1.3-3,3S13.2,10,14.9,10L14.9,10z M7,10
	c1.6,0,3-1.3,3-3S8.7,4,7,4S4,5.4,4,7C4,8.7,5.3,10,7,10L7,10z M7,12c-2.3,0-6.9,1.2-6.9,3.5V18h13.8v-2.5C13.9,13.1,9.3,12,7,12z
	 M14.9,12c-0.3,0-0.6,0-1,0c1.2,0.7,1.9,2,1.9,3.4v2.5h5.9v-2.5C21.8,13.1,17.2,12,14.9,12z"
		/>
	</SvgIcon>
);

export const AddIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="add">
			<path
				id="Path_6014"
				fill="currentColor"
				d="M20.4,12.3h-8.1v8.1H9.6v-8.1h-8V9.6h8.1V1.5h2.7v8.1h8.1v2.7H20.4z"
			/>
		</g>
	</SvgIcon>
);

export const PausedIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="pause">
			<path id="Path_6006" fill="currentColor" d="M2.9,20.3h5.4V1.5H2.9V20.3z M13.7,1.5v18.8H19V1.5H13.7z" />
		</g>
	</SvgIcon>
);

export const CopyAltIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="copy">
			<path
				fill="currentColor"
				d="M15,1.3H4.4c-1,0-1.8,0.8-1.8,1.8v12.3h1.8V3.1H15V1.3z M14.1,4.8H7.9c-1,0-1.8,0.8-1.8,1.8v12.3
		c0,1,0.8,1.8,1.8,1.8h9.7c1,0,1.8-0.8,1.8-1.8v-8.8L14.1,4.8z M7.9,18.9V6.6h5.3V11h4.4v7.9H7.9z"
			/>
		</g>
	</SvgIcon>
);

export const PasteIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="copy_2">
			<path
				fill="currentColor"
				d="M15.9,7.2H11c-0.8,0-1.4,0.6-1.4,1.4v9.7c0,0.8,0.6,1.4,1.4,1.4h7.6c0.8,0,1.4-0.6,1.4-1.4v-6.9L15.9,7.2z
		 M11,18.2V8.6h4.1V12h3.4v6.2H11z"
			/>
		</g>
		<g id="Layer_13">
			<path
				fill="currentColor"
				d="M4.3,4.1h1.6v2.4h7.9V4.1h1.6v2.3H17V4.1c0-0.9-0.7-1.6-1.6-1.6H12C11.7,1.6,10.8,1,9.8,1S7.9,1.7,7.6,2.6H4.3
		c-0.9,0-1.6,0.7-1.6,1.6v12.6c0,0.9,0.7,1.6,1.6,1.6H9c0-0.6,0-1.1,0-1.6H4.3V4.1z M9.8,2.6c0.4,0,0.8,0.4,0.8,0.8
		s-0.4,0.8-0.8,0.8C9.4,4.1,9,3.8,9,3.3C9,2.9,9.4,2.6,9.8,2.6z"
			/>
		</g>
	</SvgIcon>
);

export const ScheduleIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="Layer_7">
			<path
				id="Path_6031"
				fill="currentColor"
				d="M11,0.7c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S16.5,0.7,11,0.7L11,0.7z M11,18.7
		c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S15.4,18.7,11,18.7z"
			/>
			<path id="Path_6032" fill="currentColor" d="M11.5,5.7H10v6l5.2,3.1l0.8-1.2L11.5,11V5.7z" />
		</g>
	</SvgIcon>
);

export const PublicSamplesIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="Layer_6">
			<path
				id="Path_6042"
				fill="currentColor"
				d="M11.1,0.7C5.5,0.7,1,5.2,1,10.8S5.5,21,11.1,21s10.1-4.5,10.1-10.1S16.7,0.7,11.1,0.7z M3,10.8
		C3,10.2,3.1,9.6,3.2,9l4.9,4.9v1c0,1.1,0.9,2,2,2v2C6,18.4,3,14.9,3,10.8z M17.1,16.3c-0.3-0.8-1-1.4-1.9-1.4h-1v-3
		c0-0.6-0.5-1-1-1H7v-2h2c0.6,0,1-0.5,1-1v-2h2c1.1,0,2-0.9,2-2V3.3c4.2,1.7,6.2,6.4,4.5,10.5C18.3,14.7,17.7,15.6,17.1,16.3z"
			/>
		</g>
	</SvgIcon>
);

export const DeleteIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="delete">
			<path
				fill="currentColor"
				d="M5.2,18.6c0,1.1,0.8,2.1,2,2.2h7.9c1.1-0.1,2-1,2-2.2v-13H5.2V18.6z M7.2,7.8h7.9v10.8H7.2V7.8z M14.6,2.4
		l-1-1.1h-5l-1,1.1H4.2v2.2h13.9V2.4H14.6z"
			/>
			<line
				style={{ fill: 'none', stroke: 'currentColor', strokeWidth: '1.3883' }}
				x1="9.8"
				y1="10.4"
				x2="9.8"
				y2="18.7"
			/>
			<line
				style={{ fill: 'none', stroke: 'currentColor', strokeWidth: '1.3883' }}
				x1="12.6"
				y1="10.4"
				x2="12.6"
				y2="18.7"
			/>
		</g>
	</SvgIcon>
);

export const PermanentDeleteIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3796" data-name="Rectangle 3796" width="24" height="24" fill="none" />
		<path
			id="delete_forever_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
			d="M184.6-803.528l2.442-2.458,2.442,2.458.99-1-2.442-2.458,2.442-2.458-.99-1-2.442,2.458-2.442-2.458-.99,1,2.442,2.458-2.442,2.458Zm-1.965,4.108a1.634,1.634,0,0,1-1.2-.5,1.655,1.655,0,0,1-.493-1.213v-12H180v-1.418h4.226v-.836h5.635v.836h4.226v1.418h-.939v12a1.655,1.655,0,0,1-.493,1.213,1.634,1.634,0,0,1-1.2.5Zm9.1-13.706h-9.392v12a.278.278,0,0,0,.09.2.275.275,0,0,0,.2.091h8.814a.275.275,0,0,0,.2-.091.278.278,0,0,0,.09-.2Zm-9.392,0v0Z"
			transform="translate(-175 819.381)"
			// fill="#f44336"
		/>
	</SvgIcon>
);

export const RestoreDeleteIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path
			id="restore_from_trash_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
			d="M186.38-804H187.8v-4.177l1.749,1.72,1-1-3.454-3.454-3.454,3.454,1,1,1.749-1.72Zm-3.726,4.581a1.65,1.65,0,0,1-1.213-.5,1.649,1.649,0,0,1-.5-1.213v-12H180v-1.418h4.254v-.836h5.671v.836h4.254v1.418h-.945v12a1.649,1.649,0,0,1-.5,1.213,1.65,1.65,0,0,1-1.213.5Zm9.162-13.706h-9.452v12a.277.277,0,0,0,.091.2.277.277,0,0,0,.2.091h8.871a.277.277,0,0,0,.2-.091.277.277,0,0,0,.091-.2Zm-9.452,0v0Z"
			transform="translate(-175 819.402)"
			fill={props.htmlColor ?? '#7d61bc'}
		/>
		<rect id="Rectangle_3960" data-name="Rectangle 3960" width="24" height="24" fill="none" />
	</SvgIcon>
);

export const EditIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="Icon_feather-edit-3" transform="translate(-3.25 -3.818)">
			<path
				id="Path_5658"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: '1.4932',
					strokeLinecap: 'round',
					strokeLinejoin: 'round',
				}}
				d="M4.2,23.3h20.2"
			/>
			<path
				id="Path_5659"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: '1.4932',
					strokeLinecap: 'round',
					strokeLinejoin: 'round',
				}}
				d="M17.9,6.9c0.7-0.8,1.9-0.8,2.7-0.1c0,0,0.1,0.1,0.1,0.1c0.8,0.8,0.8,2.1,0,3L9,22.3l-3.7,1
		l0.9-4L17.9,6.9z"
			/>
		</g>
	</SvgIcon>
);

export const NamingTextIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3179" data-name="Rectangle 3179" width="26" height="26" fill="none" />
		<g id="Group_6799" data-name="Group 6799" transform="translate(-472 -424)">
			<path
				id="text_fields_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
				d="M86.5-779.2v-16.9H80V-800H96.9v3.9H90.4v16.9Zm11.7,0v-10.4H94.3v-3.9H106v3.9h-3.9v10.4Z"
				transform="translate(392 1227)"
				fill="#5f3fa5"
			/>
		</g>
	</SvgIcon>
);

const meta = '{meta}';
export const NamingMetadataIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3178" data-name="Rectangle 3178" width="26" height="26" fill="none" />
		<g id="Group_7947" data-name="Group 7947" transform="translate(-88 -307)">
			<path
				id="keyboard_alt_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
				d="M42.364-779.909a2.276,2.276,0,0,1-1.669-.694A2.276,2.276,0,0,1,40-782.273v-15.364a2.276,2.276,0,0,1,.694-1.669A2.276,2.276,0,0,1,42.364-800H63.636a2.276,2.276,0,0,1,1.669.694A2.276,2.276,0,0,1,66-797.636v15.364a2.276,2.276,0,0,1-.694,1.669,2.276,2.276,0,0,1-1.669.694Zm0-2.364H63.636v-15.364H42.364Zm0,0v0Z"
				transform="translate(48 1109.955)"
				fill="#5f3fa5"
			/>
			<text
				id="_meta_"
				data-name="{meta}"
				transform="translate(101 321.955)"
				fill="#5f3fa5"
				fontSize="6"
				fontFamily="Helvetica"
			>
				<tspan x="-8" y="0">
					{meta}
				</tspan>
			</text>
		</g>
	</SvgIcon>
);

export const NamingCounterIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3180" data-name="Rectangle 3180" width="26" height="26" fill="none" />
		<path
			id="counter_3_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M93-854a12.658,12.658,0,0,1-5.07-1.024A13.127,13.127,0,0,1,83.8-857.8a13.128,13.128,0,0,1-2.779-4.128A12.658,12.658,0,0,1,80-867a12.659,12.659,0,0,1,1.024-5.07A13.128,13.128,0,0,1,83.8-876.2a13.127,13.127,0,0,1,4.128-2.779A12.659,12.659,0,0,1,93-880a12.659,12.659,0,0,1,5.07,1.024A13.127,13.127,0,0,1,102.2-876.2a13.128,13.128,0,0,1,2.779,4.128A12.659,12.659,0,0,1,106-867a12.658,12.658,0,0,1-1.024,5.07A13.128,13.128,0,0,1,102.2-857.8a13.127,13.127,0,0,1-4.128,2.779A12.658,12.658,0,0,1,93-854Zm0-2.6a10.037,10.037,0,0,0,7.378-3.022A10.037,10.037,0,0,0,103.4-867a10.037,10.037,0,0,0-3.022-7.378A10.037,10.037,0,0,0,93-877.4a10.037,10.037,0,0,0-7.378,3.023A10.037,10.037,0,0,0,82.6-867a10.037,10.037,0,0,0,3.022,7.378A10.037,10.037,0,0,0,93-856.6ZM93-867Zm-3.9,6.5h5.2a2.5,2.5,0,0,0,1.836-.764A2.5,2.5,0,0,0,96.9-863.1v-1.95a1.894,1.894,0,0,0-.552-1.4,1.894,1.894,0,0,0-1.4-.552,1.894,1.894,0,0,0,1.4-.553,1.894,1.894,0,0,0,.552-1.4v-1.95a2.5,2.5,0,0,0-.764-1.836A2.5,2.5,0,0,0,94.3-873.5H89.1v2.6h5.2v2.6H91.7v2.6h2.6v2.6H89.1Z"
			transform="translate(-80 880)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const NamingFileNameIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3181" data-name="Rectangle 3181" width="26" height="26" fill="none" />
		<path
			id="description_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M165.2-859.2h10.4v-2.6H165.2Zm0-5.2h10.4V-867H165.2ZM162.6-854a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,160-856.6v-20.8a2.5,2.5,0,0,1,.764-1.836A2.5,2.5,0,0,1,162.6-880H173l7.8,7.8v15.6a2.5,2.5,0,0,1-.764,1.836A2.5,2.5,0,0,1,178.2-854Zm9.1-16.9v-6.5h-9.1v20.8h15.6v-14.3Zm-9.1-6.5v0Z"
			transform="translate(-157.4 880)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const NamingFileExtensionIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3182" data-name="Rectangle 3182" width="26" height="26" fill="none" />
		<g id="Group_7949" data-name="Group 7949" transform="translate(-473.6 -424.4)">
			<path
				id="description_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
				d="M162.6-854a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,160-856.6v-20.8a2.5,2.5,0,0,1,.764-1.836A2.5,2.5,0,0,1,162.6-880H173l7.8,7.8v15.6a2.5,2.5,0,0,1-.764,1.836A2.5,2.5,0,0,1,178.2-854Zm9.1-16.9v-6.5h-9.1v20.8h15.6v-14.3Zm-9.1-6.5v0Z"
				transform="translate(316.2 1304.4)"
				fill="#5f3fa5"
			/>
			<text
				id="_.xyz"
				data-name=".xyz"
				transform="translate(486 442)"
				fill="#5f3fa5"
				fontSize="6"
				fontFamily="Helvetica"
			>
				<tspan x="-5" y="0">
					.xyz
				</tspan>
			</text>
		</g>
	</SvgIcon>
);

export const NamingDateIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3183" data-name="Rectangle 3183" width="26" height="26" fill="none" />
		<path
			id="calendar_month_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M122.6-854a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,120-856.6v-18.2a2.5,2.5,0,0,1,.764-1.836,2.5,2.5,0,0,1,1.836-.764h1.3V-880h2.6v2.6h10.4V-880h2.6v2.6h1.3a2.5,2.5,0,0,1,1.836.764,2.5,2.5,0,0,1,.764,1.836v18.2a2.5,2.5,0,0,1-.764,1.836A2.5,2.5,0,0,1,140.8-854Zm0-2.6h18.2v-13H122.6Zm0-15.6h18.2v-2.6H122.6Zm0,0v0Zm9.1,7.8a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926A1.258,1.258,0,0,1,131.7-867a1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,131.7-864.4Zm-5.2,0a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926A1.258,1.258,0,0,1,126.5-867a1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,126.5-864.4Zm10.4,0a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926A1.258,1.258,0,0,1,136.9-867a1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,136.9-864.4Zm-5.2,5.2a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926,1.258,1.258,0,0,1,.926-.374,1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,131.7-859.2Zm-5.2,0a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926,1.258,1.258,0,0,1,.926-.374,1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,126.5-859.2Zm10.4,0a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926,1.258,1.258,0,0,1,.926-.374,1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,136.9-859.2Z"
			transform="translate(-118.7 880)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const NamingTimeIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3184" data-name="Rectangle 3184" width="26" height="26" fill="none" />
		<path
			id="schedule_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M97.29-860.89l1.82-1.82-4.81-4.81v-5.98H91.7v7.02ZM93-854a12.658,12.658,0,0,1-5.07-1.024A13.127,13.127,0,0,1,83.8-857.8a13.128,13.128,0,0,1-2.779-4.128A12.658,12.658,0,0,1,80-867a12.659,12.659,0,0,1,1.024-5.07A13.128,13.128,0,0,1,83.8-876.2a13.127,13.127,0,0,1,4.128-2.779A12.659,12.659,0,0,1,93-880a12.659,12.659,0,0,1,5.07,1.024A13.127,13.127,0,0,1,102.2-876.2a13.128,13.128,0,0,1,2.779,4.128A12.659,12.659,0,0,1,106-867a12.658,12.658,0,0,1-1.024,5.07A13.128,13.128,0,0,1,102.2-857.8a13.127,13.127,0,0,1-4.128,2.779A12.658,12.658,0,0,1,93-854ZM93-867Zm0,10.4a10.025,10.025,0,0,0,7.361-3.039A10.025,10.025,0,0,0,103.4-867a10.025,10.025,0,0,0-3.039-7.361A10.026,10.026,0,0,0,93-877.4a10.026,10.026,0,0,0-7.361,3.039A10.025,10.025,0,0,0,82.6-867a10.025,10.025,0,0,0,3.039,7.361A10.025,10.025,0,0,0,93-856.6Z"
			transform="translate(-80 880)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const NamingIDIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3185" data-name="Rectangle 3185" width="26" height="26" fill="none" />
		<path
			id="badge_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M82.6-854a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,80-856.6v-14.3a2.5,2.5,0,0,1,.764-1.836A2.5,2.5,0,0,1,82.6-873.5h6.5v-3.9a2.5,2.5,0,0,1,.764-1.836A2.5,2.5,0,0,1,91.7-880h2.6a2.5,2.5,0,0,1,1.836.764A2.5,2.5,0,0,1,96.9-877.4v3.9h6.5a2.5,2.5,0,0,1,1.836.764A2.5,2.5,0,0,1,106-870.9v14.3a2.5,2.5,0,0,1-.764,1.836A2.5,2.5,0,0,1,103.4-854Zm0-2.6h20.8v-14.3H96.9a2.5,2.5,0,0,1-.764,1.836,2.5,2.5,0,0,1-1.836.764H91.7a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,89.1-870.9H82.6Zm2.6-2.6H93v-.585a1.832,1.832,0,0,0-.309-1.024,2.041,2.041,0,0,0-.861-.731,6.7,6.7,0,0,0-1.316-.439,6.579,6.579,0,0,0-1.414-.146,6.579,6.579,0,0,0-1.414.146,6.7,6.7,0,0,0-1.316.439,2.041,2.041,0,0,0-.861.731,1.832,1.832,0,0,0-.309,1.024Zm10.4-1.95h5.2v-1.95H95.6Zm-6.5-1.95a1.881,1.881,0,0,0,1.381-.569,1.881,1.881,0,0,0,.569-1.381,1.88,1.88,0,0,0-.569-1.381A1.881,1.881,0,0,0,89.1-867a1.881,1.881,0,0,0-1.381.569,1.88,1.88,0,0,0-.569,1.381,1.881,1.881,0,0,0,.569,1.381A1.881,1.881,0,0,0,89.1-863.1Zm6.5-1.95h5.2V-867H95.6Zm-3.9-5.85h2.6v-6.5H91.7ZM93-863.75Z"
			transform="translate(-80 880)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const NamingSeparatorIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3186" data-name="Rectangle 3186" width="26" height="26" fill="none" />
		<path
			id="tab_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M82.6-781.8h20.8v-10.4H94.3v-5.2H82.6Zm0,2.6a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,80-781.8v-15.6a2.5,2.5,0,0,1,.764-1.836A2.5,2.5,0,0,1,82.6-800h20.8a2.5,2.5,0,0,1,1.836.764A2.5,2.5,0,0,1,106-797.4v15.6a2.5,2.5,0,0,1-.764,1.836,2.5,2.5,0,0,1-1.836.764Zm0-2.6v0Z"
			transform="translate(-80 802.6)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const ExportIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="icon-export" transform="translate(-0.129 -1.029)">
			<g id="Group_615">
				<g id="Group_614">
					<path
						id="Path_6034"
						fill="currentColor"
						stroke="currentColor"
						strokeWidth="0.75"
						strokeMiterlimit="10"
						d="M14.1,18.2l-2.6,2.6v-7.7c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0v7.7l-2.6-2.6
				c-0.2-0.1-0.3-0.1-0.5,0c-0.1,0.2-0.1,0.3,0,0.5l3.2,3.2c0.2,0.1,0.4,0.1,0.6,0l3.2-3.2c0.1-0.2,0.1-0.3,0-0.5
				C14.5,18.1,14.3,18.1,14.1,18.2z"
					/>
				</g>
				<path
					id="Path_6035"
					fill="currentColor"
					stroke="currentColor"
					strokeWidth="0.75"
					strokeMiterlimit="10"
					d="M16.1,16.4h-2.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h2.8c2.7,0,4.9-2.2,4.9-4.9
			c0-2.6-2.2-4.8-4.8-4.8c-0.3,0-0.5,0-0.8,0.1h-0.3L15,5.7c-0.8-1.9-2.6-3.1-4.6-3c-2.7,0-4.8,2.1-4.8,4.8v0.6H5
			c-2.1,0-3.8,1.8-3.8,3.8s1.8,3.8,3.9,3.8l0,0h4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4h-4c-2.5,0-4.5-2-4.5-4.5
			S2.5,7.5,5,7.5c0.1-3,2.5-5.3,5.5-5.4c2.2,0,4.2,1.3,5,3.3h0.7c3,0,5.5,2.5,5.5,5.5V11C21.6,14,19.1,16.3,16.1,16.4z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ImportIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="icon-import" transform="translate(-0.129 -1.029)">
			<g id="Group_617">
				<g id="Group_616">
					<path
						id="Path_6037"
						fill="currentColor"
						stroke="currentColor"
						strokeWidth="0.75"
						strokeMiterlimit="10"
						d="M14.6,15c0.1-0.2,0.1-0.3,0-0.5l-3.2-3.2c-0.2-0.1-0.4-0.1-0.6,0l-3.2,3.2
				c-0.1,0.2-0.1,0.3,0,0.5c0.2,0.1,0.3,0.1,0.5,0l2.6-2.6v7.7c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4v-7.7l2.6,2.6
				C14.2,15.1,14.4,15.1,14.6,15z"
					/>
				</g>
				<path
					id="Path_6038"
					fill="currentColor"
					stroke="currentColor"
					strokeWidth="0.75"
					strokeMiterlimit="10"
					d="M16.1,17.9h-2.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h2.8c2.7,0,4.9-2.2,4.9-4.9
			c0-2.6-2.2-4.8-4.8-4.8c-0.3,0-0.5,0-0.8,0.1h-0.3L15,7.2c-0.8-1.9-2.6-3.1-4.6-3C7.7,4.2,5.6,6.3,5.6,9v0.6H5
			c-2.1,0-3.8,1.8-3.8,3.9s1.8,3.8,3.9,3.7l0,0h4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4h-4c-2.5,0-4.5-2-4.5-4.5
			C0.6,11,2.5,9,5,9c0.1-3,2.5-5.3,5.5-5.4c2.2,0,4.2,1.3,5,3.3h0.7c3,0,5.5,2.5,5.5,5.5v0.1C21.5,15.5,19.1,17.8,16.1,17.9z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ResetIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" transform="scale(-1, 1)" viewBox="0 0 24 24" {...props}>
		<path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
	</SvgIcon>
);

export const QuickLinksIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" {...props}>
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth="1.25"
			d="M13.327 2.658h4.441l-3.992 7.828h2.747L8.23 23.342l3.441-10.319H9.319z"
			data-name="Path 6922"
		/>
		<path fill="none" d="M0 0H26V26H0z" data-name="Rectangle 2189" />
	</SvgIcon>
);

export const LayoutRowsIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 43" {...props}>
		<path
			fill="currentColor"
			d="M21115-7234v-43h43v43zm3-3h37v-7h-37zm37-10v-7h-37v7zm0-10v-7h-37v7zm0-10v-7h-37v7z"
			data-name="homepage layout 4 horizontal icon"
			transform="translate(-21115.002 7277.002)"
		/>
	</SvgIcon>
);

export const LayoutColumnsIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 43" {...props}>
		<path
			fill="currentColor"
			d="M21115-7234v-43h43v43zm3-3h37v-7h-37zm37-10v-7h-37v7zm0-10v-7h-37v7zm0-10v-7h-37v7z"
			data-name="homepage layout 4 vertical icon"
			transform="rotate(90 6940.5 -14174.502)"
		/>
	</SvgIcon>
);

export const LayoutGridIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 43" {...props}>
		<path
			fill="currentColor"
			d="M21115-7234v-43h43v43zm40-3v-17h-17v17zm-37 0h17v-17h-17zm20-20h17v-17h-17zm-3.006 0v-17h-17v17z"
			data-name="homepage layout 2x2 icon"
			transform="translate(-21115.002 7277.002)"
		/>
	</SvgIcon>
);

export const LayoutLeftIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 43" {...props}>
		<path
			fill="currentColor"
			d="M21115-7234v-43h43v43zm40-3v-10.5h-17v10.5zm-37 0h17v-37h-17zm20-13.5h17v-10h-17zm0-13h17v-10.5h-17z"
			data-name="homepage layout 1x3 icon"
			transform="translate(-21115.002 7277.002)"
		/>
	</SvgIcon>
);

export const SystemModeIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2243" />
		<g data-name="Group 5789" transform="translate(-87.889 -793.199)">
			<g fill="currentColor" data-name="Group 5755" transform="translate(90.889 797.099)">
				<path
					d="M85.4-823.8v-1.8h-3.6a1.733 1.733 0 01-1.271-.529A1.733 1.733 0 0180-827.4v-10.8a1.733 1.733 0 01.529-1.271A1.733 1.733 0 0181.8-840h14.4a1.733 1.733 0 011.271.529A1.733 1.733 0 0198-838.2v10.8a1.733 1.733 0 01-.529 1.271 1.733 1.733 0 01-1.271.529h-3.6v1.8zm-3.6-3.6h14.4v-10.8H81.8zm0 0z"
					transform="translate(-80 840)"
				/>
				<path
					d="M2.746 7.132l-.214-1.07q-.214-.089-.4-.187a3.106 3.106 0 01-.383-.241l-1.036.321L0 4.743l.82-.713a3.292 3.292 0 01-.036-.464A3.293 3.293 0 01.82 3.1L0 2.389l.713-1.212 1.034.323a3.1 3.1 0 01.383-.241q.187-.1.4-.187L2.746 0h1.426l.214 1.07a3.6 3.6 0 01.4.2 2.813 2.813 0 01.383.267l1.034-.357.713 1.248-.82.713a2.8 2.8 0 010 .892l.82.713-.711 1.209-1.034-.32a3.106 3.106 0 01-.383.241q-.187.1-.4.187l-.214 1.07zm.713-2.14a1.431 1.431 0 001.427-1.426A1.431 1.431 0 003.459 2.14a1.431 1.431 0 00-1.426 1.426 1.431 1.431 0 001.426 1.427z"
					transform="rotate(149 6.854 6.217)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const LightModeIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2241" />
		<path
			fill="currentColor"
			d="M49-908.545a2.367 2.367 0 001.739-.716 2.367 2.367 0 00.716-1.739 2.367 2.367 0 00-.716-1.739 2.367 2.367 0 00-1.739-.716 2.367 2.367 0 00-1.739.716 2.367 2.367 0 00-.716 1.739 2.367 2.367 0 00.716 1.739 2.367 2.367 0 001.739.716zm0 1.636a3.943 3.943 0 01-2.894-1.2 3.943 3.943 0 01-1.2-2.894 3.943 3.943 0 011.2-2.894 3.943 3.943 0 012.894-1.2 3.943 3.943 0 012.894 1.2 3.943 3.943 0 011.2 2.894 3.943 3.943 0 01-1.2 2.894 3.943 3.943 0 01-2.894 1.2zm-8.182-3.273a.792.792 0 01-.583-.235A.792.792 0 0140-911a.792.792 0 01.235-.583.792.792 0 01.583-.235h1.636a.792.792 0 01.583.235.792.792 0 01.235.583.792.792 0 01-.235.583.792.792 0 01-.583.235zm14.727 0a.792.792 0 01-.583-.235.792.792 0 01-.235-.583.792.792 0 01.235-.583.792.792 0 01.583-.235h1.636a.792.792 0 01.583.235A.792.792 0 0158-911a.792.792 0 01-.235.583.792.792 0 01-.583.235zM49-916.727a.792.792 0 01-.583-.235.792.792 0 01-.235-.583v-1.636a.792.792 0 01.235-.583A.792.792 0 0149-920a.791.791 0 01.583.235.792.792 0 01.235.583v1.636a.792.792 0 01-.235.583.791.791 0 01-.583.236zM49-902a.792.792 0 01-.583-.235.792.792 0 01-.235-.583v-1.636a.791.791 0 01.235-.583.792.792 0 01.583-.235.791.791 0 01.583.235.791.791 0 01.235.583v1.636a.792.792 0 01-.235.583A.792.792 0 0149-902zm-5.2-13.05l-.88-.859a.712.712 0 01-.235-.573.887.887 0 01.235-.593.808.808 0 01.593-.245.743.743 0 01.573.245l.859.88a.821.821 0 01.225.573.821.821 0 01-.225.573.7.7 0 01-.562.235.875.875 0 01-.583-.236zm10.1 10.125l-.859-.88a.834.834 0 01-.225-.583.763.763 0 01.225-.562.7.7 0 01.563-.235.875.875 0 01.583.235l.88.859a.712.712 0 01.235.573.887.887 0 01-.235.593.808.808 0 01-.593.245.743.743 0 01-.565-.245zm-.85-10.125a.7.7 0 01-.235-.562.875.875 0 01.235-.583l.859-.88a.712.712 0 01.573-.235.888.888 0 01.593.235.808.808 0 01.245.593.743.743 0 01-.245.573l-.88.859a.821.821 0 01-.573.225.821.821 0 01-.572-.225zm-10.125 10.125a.808.808 0 01-.245-.593.743.743 0 01.245-.573l.88-.859a.834.834 0 01.583-.225.763.763 0 01.563.225.7.7 0 01.235.563.875.875 0 01-.235.583l-.859.88a.712.712 0 01-.573.235.888.888 0 01-.594-.236zM49-911z"
			transform="translate(-37 923)"
		/>
	</SvgIcon>
);

export const DarkModeIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2242" />
		<path
			fill="currentColor"
			d="M129-822a8.679 8.679 0 01-6.375-2.625A8.679 8.679 0 01120-831a8.679 8.679 0 012.625-6.375A8.679 8.679 0 01129-840q.35 0 .688.025t.662.075a5.293 5.293 0 00-1.637 1.888 5.309 5.309 0 00-.613 2.513 5.207 5.207 0 001.575 3.825 5.207 5.207 0 003.825 1.574 5.287 5.287 0 002.525-.613 5.323 5.323 0 001.875-1.637q.05.325.075.662T138-831a8.679 8.679 0 01-2.625 6.375A8.679 8.679 0 01129-822zm0-2a6.772 6.772 0 003.95-1.213 7.013 7.013 0 002.55-3.162q-.5.125-1 .2a6.726 6.726 0 01-1 .075 7.133 7.133 0 01-5.238-2.163 7.133 7.133 0 01-2.162-5.237 6.732 6.732 0 01.075-1q.075-.5.2-1a7.013 7.013 0 00-3.163 2.55A6.772 6.772 0 00122-831a6.745 6.745 0 002.05 4.95A6.745 6.745 0 00129-824zm-.25-6.75z"
			transform="translate(-117 843)"
		/>
	</SvgIcon>
);

export const AdvancedMenuIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" overflow="visible" {...props}>
		<g data-name="Group 4846" transform="translate(-3, 0)">
			<path
				fill="currentColor"
				d="M23996.76 22244l-.416-3.367a5.115 5.115 0 01-.9-.416 5.727 5.727 0 01-.824-.574l-3.09 1.318-2.523-4.422 2.67-2.039a4.658 4.658 0 01-.053-.494c-.012-.166-.016-.33-.016-.494s0-.318.016-.48.027-.34.053-.533l-2.67-2.037 2.523-4.4 3.078 1.307a6.986 6.986 0 01.844-.578 5.471 5.471 0 01.883-.422l.428-3.367h5.049l.418 3.377a5.083 5.083 0 01.891.424 7.071 7.071 0 01.8.566l3.119-1.307 2.525 4.4-2.711 2.07a2.8 2.8 0 01.063.5v.469c0 .156 0 .3-.008.457a3.2 3.2 0 01-.078.533l2.691 2.049-2.523 4.422-3.082-1.328a7.281 7.281 0 01-.828.578 4.867 4.867 0 01-.867.41l-.418 3.379zm-.492-5.242a6.079 6.079 0 001.568.633l.355 2.951h2.148l.395-2.961a6.036 6.036 0 001.531-.629 6.773 6.773 0 001.336-1.045l2.719 1.152 1.078-1.879-2.373-1.8a4.4 4.4 0 00.186-.844 6.9 6.9 0 00.051-.832 6.7 6.7 0 00-.051-.832 4.122 4.122 0 00-.186-.82l2.395-1.828-1.076-1.879-2.752 1.17a5.849 5.849 0 00-1.314-1.049 5.654 5.654 0 00-1.555-.643l-.344-2.963h-2.172l-.361 2.951a5.734 5.734 0 00-1.547.611 6.572 6.572 0 00-1.354 1.064l-2.719-1.143-1.076 1.879 2.363 1.777a4.2 4.2 0 00-.193.818 7.271 7.271 0 00-.055.9 6.679 6.679 0 00.055.844 5.174 5.174 0 00.182.82l-2.352 1.8 1.076 1.879 2.709-1.16a6.163 6.163 0 001.333 1.058zm2.3-.809v-3.723h-3.686v-1.453h3.686v-3.723h1.432v3.723h3.686v1.453H24000v3.723z"
				data-name="Union 27"
				transform="translate(-23986.285 -22220.5)"
			/>
			<path fill="none" d="M0 0H26V26H0z" data-name="Rectangle 2048" />
			<path
				fill="currentColor"
				d="M5.26 0L2.98 2.272.7 0 0 .7l2.98 2.975L5.96.7z"
				data-name="↳Color"
				transform="translate(23.281 19.824)"
			/>
		</g>
	</SvgIcon>
);

export const HomeMenuIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" overflow="visible" {...props}>
		<g data-name="Group 4845" transform="translate(-3, 0)">
			<path
				fill="currentColor"
				d="M153.385-834.707h3.563v-5.908h5.1l.006 5.908h3.5l-.006-9.2-6.077-4.557-6.078 4.557zm-1.516 1.512v-11.39l7.593-5.7 7.593 5.7v11.392h-6.54v-5.914h-2.049v5.914zm7.593-8.277z"
				data-name="home_FILL0_wght500_GRAD0_opsz24 (1)"
				transform="translate(-146.463 854.739)"
			/>
			<path fill="none" d="M0 0H26V26H0z" data-name="Rectangle 2036" />
			<path
				fill="currentColor"
				d="M5.26 0L2.98 2.272.7 0 0 .7l2.98 2.975L5.96.7z"
				data-name="↳Color"
				transform="translate(23.279 17.824)"
			/>
		</g>
	</SvgIcon>
);

export const TicketIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path
				fill="currentColor"
				d="M22 10V6C22 4.89 21.1 4 20 4H4C2.9 4 2 4.89 2 6V10C3.11 10 4 10.9 4 12S3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12S20.9 10 22 10M20 8.54C18.81 9.23 18 10.53 18 12S18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.5 5.2 9.23 4 8.54L4 6H20V8.54M11 15H13V17H11M11 11H13V13H11M11 7H13V9H11Z"
			/>
		</g>
	</SvgIcon>
);

export const GridViewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path d="M11 11V3H5c-1.1 0-2 .9-2 2v6zm2 0h8V5c0-1.1-.9-2-2-2h-6zm-2 2H3v6c0 1.1.9 2 2 2h6zm2 0v8h6c1.1 0 2-.9 2-2v-6z" />
		</g>
	</SvgIcon>
);

export const ListViewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path
			id="list_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			fill="#323232"
			d="M123.806-678.1v-1.9h13.322v1.9Zm0 3.806v-1.9h13.322v1.9Zm0 3.806v-1.9h13.322v1.9Zm-2.855-7.612a.92.92 0 0 1-.678-.274.92.92 0 0 1-.274-.678.92.92 0 0 1 .274-.678.92.92 0 0 1 .678-.274.92.92 0 0 1 .678.274.92.92 0 0 1 .274.678.92.92 0 0 1-.274.678.92.92 0 0 1-.677.274Zm0 3.806a.92.92 0 0 1-.678-.273.92.92 0 0 1-.274-.678.92.92 0 0 1 .274-.678.92.92 0 0 1 .678-.274.92.92 0 0 1 .678.274.92.92 0 0 1 .274.678.92.92 0 0 1-.274.678.92.92 0 0 1-.677.276Zm0 3.806a.92.92 0 0 1-.678-.274.92.92 0 0 1-.274-.678.92.92 0 0 1 .274-.678.92.92 0 0 1 .678-.274.92.92 0 0 1 .678.274.92.92 0 0 1 .274.678.92.92 0 0 1-.274.678.92.92 0 0 1-.677.278Z"
			transform="translate(-116.564 687.242)"
		/>
		<rect id="Rectangle_3409" width="24" height="24" fill="none" data-name="Rectangle 3409" rx="3" />
	</SvgIcon>
);

export const CardViewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3409" width="24" height="24" fill="none" data-name="Rectangle 3409" rx="3" />
		<path
			id="view_agenda_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			fill="#323232"
			d="M121.717-833.133a1.65 1.65 0 0 1-1.212-.5 1.65 1.65 0 0 1-.5-1.212v-3.434a1.65 1.65 0 0 1 .5-1.212 1.65 1.65 0 0 1 1.212-.5h12.017a1.65 1.65 0 0 1 1.212.5 1.65 1.65 0 0 1 .5 1.212v3.434a1.65 1.65 0 0 1-.5 1.212 1.65 1.65 0 0 1-1.212.5Zm0-1.717h12.017v-3.434h-12.017Zm0 10.3a1.65 1.65 0 0 1-1.212-.5 1.65 1.65 0 0 1-.5-1.213v-3.437a1.65 1.65 0 0 1 .5-1.212 1.65 1.65 0 0 1 1.212-.5h12.017a1.65 1.65 0 0 1 1.212.5 1.65 1.65 0 0 1 .5 1.212v3.433a1.65 1.65 0 0 1-.5 1.213 1.65 1.65 0 0 1-1.212.5Zm0-1.717h12.017v-3.433h-12.017Zm0-3.433"
			transform="translate(-115.725 844.275)"
		/>
	</SvgIcon>
);

export const InternalAppIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3017" />
			<path
				d="M9 11.7a.884.884 0 10-.641-.259A.871.871 0 009 11.7zm0-3.6a.884.884 0 10-.641-.259A.871.871 0 009 8.1zm0-3.6a.884.884 0 00.9-.9.9.9 0 10-1.8 0 .884.884 0 00.9.9zm7.2 9.9H1.8a1.733 1.733 0 01-1.271-.529A1.733 1.733 0 010 12.6V9a1.733 1.733 0 001.271-.529 1.793 1.793 0 000-2.542A1.733 1.733 0 000 5.4V1.8A1.733 1.733 0 01.529.529 1.733 1.733 0 011.8 0h14.4a1.733 1.733 0 011.271.529A1.733 1.733 0 0118 1.8v3.6a1.805 1.805 0 00-1.8 1.8A1.805 1.805 0 0018 9v3.6a1.805 1.805 0 01-1.8 1.8zm0-1.8v-2.3a3.69 3.69 0 01-1.316-1.316 3.549 3.549 0 010-3.578A3.69 3.69 0 0116.2 4.095V1.8H1.8v2.295a3.69 3.69 0 011.316 1.316 3.549 3.549 0 010 3.578A3.69 3.69 0 011.8 10.3v2.3zM9 7.2z"
				transform="rotate(90 8.1 11.1)"
			/>
		</g>
	</SvgIcon>
);
export const ExternalAppIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3197" />
		<path
			d="M89-862a8.709 8.709 0 01-3.488-.709 9.128 9.128 0 01-2.869-1.935 9.129 9.129 0 01-1.935-2.869A8.709 8.709 0 0180-871a8.684 8.684 0 01.709-3.5 9.164 9.164 0 011.935-2.857 9.128 9.128 0 012.869-1.935A8.709 8.709 0 0189-880a8.684 8.684 0 013.5.709 9.164 9.164 0 012.857 1.935 9.165 9.165 0 011.935 2.857A8.684 8.684 0 0198-871a8.709 8.709 0 01-.709 3.488 9.129 9.129 0 01-1.935 2.869 9.164 9.164 0 01-2.857 1.935A8.684 8.684 0 0189-862zm0-1.845a11.43 11.43 0 001.012-1.687 10.654 10.654 0 00.7-1.867H87.29a10.655 10.655 0 00.7 1.867 11.43 11.43 0 001.01 1.687zm-2.34-.36a12.47 12.47 0 01-.709-1.541 13.219 13.219 0 01-.506-1.654H82.79a7.467 7.467 0 001.631 1.957 6.474 6.474 0 002.239 1.238zm4.68 0a6.474 6.474 0 002.239-1.237 7.467 7.467 0 001.631-1.958h-2.655a13.218 13.218 0 01-.506 1.654 12.469 12.469 0 01-.709 1.541zm-9.315-4.995h3.06q-.067-.45-.1-.889T84.95-871q0-.473.034-.911t.1-.889h-3.06a7.7 7.7 0 00-.169.889 7.164 7.164 0 00-.055.911 7.163 7.163 0 00.056.911 7.7 7.7 0 00.169.889zm4.86 0h4.23q.067-.45.1-.889t.035-.911q0-.473-.034-.911t-.1-.889h-4.23q-.068.45-.1.889t-.036.911q0 .473.034.911t.101.889zm6.03 0h3.06a7.7 7.7 0 00.169-.889A7.163 7.163 0 0096.2-871a7.164 7.164 0 00-.056-.911 7.7 7.7 0 00-.169-.889h-3.06q.067.45.1.889t.034.911q0 .473-.034.911t-.1.889zm-.36-5.4h2.655a7.469 7.469 0 00-1.631-1.958 6.476 6.476 0 00-2.239-1.237 12.474 12.474 0 01.709 1.541 13.219 13.219 0 01.506 1.654zm-5.265 0h3.42a10.652 10.652 0 00-.7-1.867 11.423 11.423 0 00-1.01-1.688 11.424 11.424 0 00-1.013 1.688 10.653 10.653 0 00-.697 1.867zm-4.5 0h2.655a13.22 13.22 0 01.506-1.654 12.475 12.475 0 01.709-1.541 6.476 6.476 0 00-2.239 1.237 7.468 7.468 0 00-1.631 1.958z"
			transform="translate(-77 883)"
		/>
	</SvgIcon>
);
export const UrlAppIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3198" />
			<path
				d="M81.8-785.6a1.733 1.733 0 01-1.271-.529A1.733 1.733 0 0180-787.4v-10.8a1.733 1.733 0 01.529-1.271A1.733 1.733 0 0181.8-800h14.4a1.733 1.733 0 011.271.529A1.733 1.733 0 0198-798.2v10.8a1.733 1.733 0 01-.529 1.271 1.733 1.733 0 01-1.271.529zm0-1.8h14.4v-10.8H81.8zm0 0z"
				transform="translate(-77 804.8)"
			/>
			<path
				d="M85.4-674H83a2.891 2.891 0 01-2.122-.878A2.891 2.891 0 0180-677a2.891 2.891 0 01.878-2.122A2.891 2.891 0 0183-680h2.4v1.2H83a1.736 1.736 0 00-1.275.525A1.736 1.736 0 0081.2-677a1.736 1.736 0 00.525 1.275A1.736 1.736 0 0083-675.2h2.4zm-1.8-2.4v-1.2h4.8v1.2zm3 2.4v-1.2H89a1.736 1.736 0 001.275-.525A1.736 1.736 0 0090.8-677a1.736 1.736 0 00-.525-1.275A1.736 1.736 0 0089-678.8h-2.4v-1.2H89a2.891 2.891 0 012.123.878A2.891 2.891 0 0192-677a2.891 2.891 0 01-.877 2.122A2.891 2.891 0 0189-674z"
				transform="translate(-74 688.8)"
			/>
		</g>
	</SvgIcon>
);

export const CopyLinkIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g data-name="Group 6736" transform="translate(-5764 -1811)">
			<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3102" transform="translate(5764 1811)" />
			<path
				fill="currentColor"
				d="M7.2 8H4a3.855 3.855 0 01-2.83-1.17A3.855 3.855 0 010 4a3.855 3.855 0 011.17-2.83A3.855 3.855 0 014 0h3.2v1.6H4a2.314 2.314 0 00-1.7.7A2.314 2.314 0 001.6 4a2.314 2.314 0 00.7 1.7 2.314 2.314 0 001.7.7h3.2zM4.8 4.8V3.2h6.4v1.6zm4 3.2V6.4H12a2.314 2.314 0 001.7-.7 2.314 2.314 0 00.7-1.7 2.314 2.314 0 00-.7-1.7 2.314 2.314 0 00-1.7-.7H8.8V0H12a3.855 3.855 0 012.83 1.17A3.855 3.855 0 0116 4a3.855 3.855 0 01-1.17 2.83A3.855 3.855 0 0112 8z"
				transform="rotate(-45 5087.727 -6049.092)"
			/>
		</g>
	</SvgIcon>
);
export const ServiceAppIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path
				d="M196.525-862a2.028 2.028 0 01-1.058-.281 2.045 2.045 0 01-.742-.754 1.733 1.733 0 01-1.271-.529 1.733 1.733 0 01-.529-1.271v-3.2a6.519 6.519 0 01-2.126-2.318 6.342 6.342 0 01-.8-3.128 6.294 6.294 0 011.9-4.624 6.294 6.294 0 014.624-1.9 6.294 6.294 0 014.624 1.9 6.294 6.294 0 011.9 4.624 6.3 6.3 0 01-.8 3.15 6.577 6.577 0 01-2.126 2.295v3.2a1.733 1.733 0 01-.529 1.271 1.733 1.733 0 01-1.271.529 2.045 2.045 0 01-.743.754 2.028 2.028 0 01-1.053.282zm-1.8-2.835h3.6v-.81h-3.6zm0-1.71h3.6v-.855h-3.6zm-.18-2.655h1.3v-2.43l-1.98-1.98.945-.945 1.71 1.71 1.71-1.71.945.945-1.98 1.98v2.43h1.3a4.928 4.928 0 001.98-1.721 4.469 4.469 0 00.765-2.554 4.561 4.561 0 00-1.372-3.352 4.561 4.561 0 00-3.352-1.372 4.561 4.561 0 00-3.353 1.372 4.561 4.561 0 00-1.372 3.352 4.469 4.469 0 00.765 2.554 4.928 4.928 0 001.989 1.721zm1.98-3.645zm0-.855z"
				transform="translate(-184.525 883)"
			/>
			<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3016" opacity="0.22" />
		</g>
	</SvgIcon>
);

export const PlayIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path fill="currentColor" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
	</SvgIcon>
);

export const LinkIcon = (props: Omit<MdiIconProps, 'path'>) => (
	<MdiIcon path={mdiIcons.mdiLink} {...props} className={clsx('mdi-svg-icon', props.className)} />
);

export const AppsIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path
			fill="currentColor"
			d="M162-784a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-786a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-788a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-786a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-784zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-786a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-788a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-786a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-784zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01172-786a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01174-788a1.926 1.926 0 011.413.587A1.926 1.926 0 01176-786a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01174-784zm-12-6a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-790zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-790zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01172-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01174-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01176-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01174-790zm-12-6a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-796zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-796zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01172-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01174-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01176-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01174-796z"
			transform="translate(-155 805)"
		/>
		<path fill="none" d="M0 0H26V26H0z" data-name="Rectangle 3022" />
	</SvgIcon>
);

export const CustomizeIcon = (props: Omit<MdiIconProps, 'path'>) => (
	<MdiIcon path={mdiIcons.mdiPaletteOutline} {...props} className={clsx('mdi-svg-icon', props.className)} />
);

export const CreateWorkflowIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<g data-name="Group 4395" transform="translate(-1233 -469)">
			<rect
				width="24"
				height="24"
				fill="none"
				data-name="Rectangle 2172"
				rx="12"
				transform="translate(1233 469)"
			/>
			<g fill="currentColor" data-name="Group 4394" transform="translate(37.956 -.38)">
				<path
					d="M10.238 9.073l5.9 3.76-5.9 3.76v-7.52M8 5v15.665l12.309-7.833z"
					data-name="Path 220"
					transform="translate(1193.823 467.722)"
				/>
				<path
					d="M84.606-874.826v-2.051h-2.051v-1.555h2.051v-2.051h1.555v2.051h2.051v1.555h-2.05v2.051z"
					transform="translate(1125.843 1365.24)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const AddJobIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" fill="none" data-name="Rectangle 2154" rx="12" />
		<path
			fill="currentColor"
			d="M79.621-872.628a7.558 7.558 0 01-3.027-.61 7.823 7.823 0 01-2.459-1.656 7.821 7.821 0 01-1.656-2.459 7.556 7.556 0 01-.61-3.026 7.556 7.556 0 01.61-3.026 7.822 7.822 0 011.656-2.459 7.819 7.819 0 012.459-1.656 7.555 7.555 0 013.026-.61 7.633 7.633 0 012.336.352 7.907 7.907 0 012.041.988l-1.261 1.28a6.473 6.473 0 00-1.472-.656 5.634 5.634 0 00-1.645-.236 5.81 5.81 0 00-4.263 1.758 5.8 5.8 0 00-1.76 4.266 5.8 5.8 0 001.76 4.266 5.81 5.81 0 004.263 1.758 5.846 5.846 0 001.129-.107 6.5 6.5 0 001.06-.3l1.3 1.322a8.3 8.3 0 01-1.667.6 7.632 7.632 0 01-1.82.211zm5.213-1.569v-2.279h-2.279v-1.724h2.279v-2.279h1.728v2.279h2.279v1.728h-2.278v2.279zm-6.291-2.6l-3.3-3.3 1.186-1.191 2.111 2.111 7.638-7.657 1.191 1.191z"
			transform="translate(-67.869 892.131)"
		/>
	</SvgIcon>
);

export const PinIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		{props.htmlColor === 'white' ? (
			<path
				fillRule="evenodd"
				d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"
			/>
		) : (
			<path d="M14 4v5c0 1.12.37 2.16 1 3H9c.65-.86 1-1.9 1-3V4h4m3-2H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3V4h1c.55 0 1-.45 1-1s-.45-1-1-1z" />
		)}
	</SvgIcon>
);

export const ProfileIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2233" />
		<g transform="translate(1 1)">
			<g data-name="Group 5776" transform="translate(.875 1)">
				<g fill="currentColor" data-name="Group 5777">
					<path
						d="M35.54 42.761a7.092 7.092 0 01-6.069-3.18l-.359-.532.547-.335a10.847 10.847 0 012.831-1.222 11.866 11.866 0 013.1-.406 11.355 11.355 0 013.026.406 12.915 12.915 0 012.891 1.21l.6.336-.4.556a7.628 7.628 0 01-2.637 2.326 7.435 7.435 0 01-3.53.841zm-4.65-3.334a5.939 5.939 0 001.726 1.411 6.063 6.063 0 002.924.694 6.222 6.222 0 002.955-.7 6.328 6.328 0 001.773-1.4 11.322 11.322 0 00-1.975-.758 10.128 10.128 0 00-2.7-.362 10.638 10.638 0 00-2.783.363 9.614 9.614 0 00-1.92.752zm4.744-3.1a3.842 3.842 0 01-2.807-1.2 3.887 3.887 0 01-1.187-2.821 3.77 3.77 0 011.2-2.832 3.936 3.936 0 012.795-1.13 3.8 3.8 0 012.78 1.169 3.841 3.841 0 011.16 2.793 3.934 3.934 0 01-1.155 2.814 3.753 3.753 0 01-2.786 1.203zm0-6.752a2.71 2.71 0 00-1.948.791 2.551 2.551 0 00-.818 1.943 2.664 2.664 0 00.83 1.955 2.621 2.621 0 001.936.834 2.535 2.535 0 001.9-.828 2.709 2.709 0 00.809-1.961 2.618 2.618 0 00-.8-1.928 2.575 2.575 0 00-1.909-.81z"
						transform="translate(-25.483 -25.843)"
					/>
					<path
						d="M36.725 47.675a10.96 10.96 0 01-11-10.967 10.96 10.96 0 0111-11.033 10.96 10.96 0 0111 11.033 10.96 10.96 0 01-11 10.967zm0-20.308a9.268 9.268 0 00-9.308 9.341 9.268 9.268 0 009.308 9.275 9.268 9.268 0 009.308-9.275 9.268 9.268 0 00-9.308-9.341z"
						data-name="admin_panel_settings_FILL0_wght200_GRAD0_opsz48"
						transform="translate(-26.6 -26.55)"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const PageIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 46.4 52" {...props}>
		<path d="M17.54,41.8H36.86V38.2H17.54Zm0-10.2H36.86V28H17.54ZM11.6,52a3.454,3.454,0,0,1-2.52-1.08A3.454,3.454,0,0,1,8,48.4V7.6A3.454,3.454,0,0,1,9.08,5.08,3.454,3.454,0,0,1,11.6,4H33.26L46.4,17.14V48.4A3.691,3.691,0,0,1,42.8,52ZM31.46,18.76H42.8L31.46,7.6Z" />
	</SvgIcon>
);

export const DescriptionIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 50 43.545" {...props}>
		<path d="M26,43.545a20.941,20.941,0,0,0-5.673-3.218A17.876,17.876,0,0,0,14,39.182a17.093,17.093,0,0,0-4.5.6,19.744,19.744,0,0,0-4.227,1.691,2.1,2.1,0,0,1-2.209-.055A2.108,2.108,0,0,1,2,39.509V13.218a2.344,2.344,0,0,1,.3-1.145,1.883,1.883,0,0,1,.9-.818A22.766,22.766,0,0,1,8.436,9.291,23.592,23.592,0,0,1,26,11.909v27.6a22.315,22.315,0,0,1,5.836-2.7,21.7,21.7,0,0,1,6.164-.9,26.479,26.479,0,0,1,4.282.382,13.437,13.437,0,0,1,4.445,1.582V10.327q.545.218,1.064.436a10.333,10.333,0,0,1,1.009.491,2.591,2.591,0,0,1,.873.845A2.056,2.056,0,0,1,50,13.218V39.509a2.216,2.216,0,0,1-3.273,1.964A19.744,19.744,0,0,0,42.5,39.782a17.093,17.093,0,0,0-4.5-.6,17.876,17.876,0,0,0-6.327,1.145A20.941,20.941,0,0,0,26,43.545Zm3.273-9.109V15.182L43.455,1V22.109Z" />
	</SvgIcon>
);

export const ContactUsIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 30.33 30.33" {...props}>
		<path d="M0,0H30.33V30.33H0Z" fill="none" />
		<path
			d="M14.665,2A11.443,11.443,0,0,0,3,13.19,11.443,11.443,0,0,0,14.665,24.38h.686v3.95c6.67-3.081,10.979-9.215,10.979-15.14A11.443,11.443,0,0,0,14.665,2Zm1.372,19.089H13.293V18.456h2.745Zm0-4.608H13.293c0-4.279,4.117-3.95,4.117-6.583a2.747,2.747,0,0,0-5.489,0H9.176a5.38,5.38,0,0,1,5.489-5.266A5.38,5.38,0,0,1,20.154,9.9C20.154,13.19,16.037,13.519,16.037,16.482Z"
			transform="translate(0 0)"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const NewFormIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="clip-path">
				<path fill="none" d="M0 0H19.279V20.545H0z" data-name="Rectangle 3018" />
			</clipPath>
		</defs>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3011" />
		<g data-name="Group 6515" transform="translate(2.36 2.727)">
			<g data-name="Group 6526">
				<g data-name="Group 6529">
					<g data-name="Group 6530">
						<g data-name="Group 6525">
							<path
								fill="currentColor"
								d="M0 0H1.371V1.303H0z"
								data-name="Rectangle 3012"
								transform="translate(3.419 3.411)"
							/>
							<path
								fill="currentColor"
								d="M0 0H4.114V1.303H0z"
								data-name="Rectangle 3013"
								transform="translate(7.451 3.411)"
							/>
							<path
								fill="currentColor"
								d="M0 0H1.371V1.303H0z"
								data-name="Rectangle 3014"
								transform="translate(3.419 7.001)"
							/>
							<path
								fill="currentColor"
								d="M0 0H4.114V1.303H0z"
								data-name="Rectangle 3015"
								transform="translate(7.451 7.001)"
							/>
							<path
								fill="currentColor"
								d="M0 0H1.371V1.303H0z"
								data-name="Rectangle 3016"
								transform="translate(3.419 10.592)"
							/>
							<path
								fill="currentColor"
								d="M0 0H4.114V1.303H0z"
								data-name="Rectangle 3017"
								transform="translate(7.451 10.592)"
							/>
							<g data-name="Group 6514">
								<g clipPath="url(#clip-path)" data-name="Group 6513">
									<path
										fill="currentColor"
										d="M10.278 14.269H1.3V1.295h12.883v8.858h1.3V.44a.441.441 0 00-.44-.44H.44A.44.44 0 000 .44v14.694a.44.44 0 00.44.44h9.838z"
										data-name="Path 6958"
									/>
								</g>
							</g>
						</g>
						<path
							fill="currentColor"
							d="M6.784 3.894H3.877v2.92h-.969v-2.92H0V2.92h2.908V0h.969v2.92h2.907z"
							data-name="↳Color"
							transform="translate(11.565 12.739)"
						/>
					</g>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const NewRoleIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="clip-path">
				<path fill="none" d="M0 0H20.669V20.608H0z" data-name="Rectangle 3019" />
			</clipPath>
		</defs>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3020" />
		<g data-name="Group 6517" transform="translate(2 1.696)">
			<g clipPath="url(#clip-path)" data-name="Group 6516">
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth="0.25"
					d="M7.126 8.411a4.836 4.836 0 00.35.669l.006.01c.088.149.16.272.223.4a.425.425 0 01.166.331 2.985 2.985 0 00.565.733l.015.014a2.4 2.4 0 01-.413 1.575c-.312.124-.67.248-1.063.37l.215.734c.5-.147.843-.258 1.1-.359.863-.394.907-2 .907-2.32v-.334l-.249-.247-.013-.014a1.887 1.887 0 01-.317-.4A.946.946 0 008.369 9a.6.6 0 00-.169-.334 1.5 1.5 0 01-.27-.451L7.928 8.2c-.019-.041-.036-.079-.054-.113l-.166-.249-.246-.168-.083-.082a3.354 3.354 0 01-.415-1.493l.5-.164V5.35a4.47 4.47 0 01.516-2.206 2.905 2.905 0 011.382-1.277.4.4 0 00.245-.082 4.869 4.869 0 011.158-.416 1.207 1.207 0 00.4-.1h.014c.054-.02.108-.039.169-.059v.581l.661.164a.9.9 0 01.5.167v.33l.239.25a3.606 3.606 0 01.828 2.651v.5l.412.249a2.68 2.68 0 01-.412 1.411l-.163.164-.249.167L13 8.17a2.6 2.6 0 01-.4.816L12.584 9l-.009.01c-.077.077-.157.157-.157.237l-.082.084a2.088 2.088 0 01-.412.578l-.415.249.084.5c0 .74.282 1.923.91 2.238h.166l.331.082a23.308 23.308 0 012.915 1.24l.008-.875a12.249 12.249 0 00-2.678-1.113l-.331-.082c-.152-.078-.407-.618-.5-1.575a2.371 2.371 0 00.661-.829.416.416 0 00.085-.127.438.438 0 01.081-.123 4.507 4.507 0 00.579-1.076A2.264 2.264 0 0014.313 8a4.217 4.217 0 00.5-2.242 1 1 0 00-.411-.414 4.6 4.6 0 00-1.076-3.232v-.164a1.36 1.36 0 00-1.159-.827.638.638 0 00-.079-.331 1.15 1.15 0 00-.582-.663H11.5a.3.3 0 00-.24.082l-.167.164c0 .085-.162.167-.494.249a11.568 11.568 0 00-1.23.406h-.008l-.02.007c-.09.034-.167.063-.225.083-1.5.583-2.4 2.163-2.4 4.226a.675.675 0 00-.411.411A4.079 4.079 0 006.715 8a1.018 1.018 0 00.411.411z"
					data-name="Path 6962"
				/>
				<g fill="currentColor" data-name="Group 6527">
					<path
						d="M2.988 15.335l.294-.713h.062a2.439 2.439 0 00.619-.08 3.4 3.4 0 00.746-.267l.652.483.766-.7-.516-.609a2.165 2.165 0 00.327-.679 2.054 2.054 0 00.054-.547v-.143l.75-.235-.231-1.065-.81.1a1.654 1.654 0 00-.392-.539 1.876 1.876 0 00-.582-.415l.1-.782-1.069-.23-.294.714h-.113a2.129 2.129 0 00-.615.079 2.149 2.149 0 00-.53.19l-.167.076-.652-.548-.7.7.513.675a2.141 2.141 0 00-.318.681c-.054.23-.088.419-.123.618l-.011.067L0 12.4l.231 1.06.811-.105.052.084a2.3 2.3 0 00.359.475 1.761 1.761 0 00.564.394l-.1.787 1.066.235zm.425-5.019a1.808 1.808 0 11-1.845 1.808 1.816 1.816 0 011.845-1.808"
						data-name="Path 6959"
					/>
					<path
						d="M20.669 17.688h-2.907v2.92h-.969v-2.92h-2.908v-.974h2.908v-2.92h.969v2.92h2.907z"
						data-name="Path 6960"
					/>
					<path
						d="M7.126 8.411a4.836 4.836 0 00.35.669l.006.01c.088.149.16.272.223.4a.425.425 0 01.166.331 2.985 2.985 0 00.565.733l.015.014a2.4 2.4 0 01-.413 1.575c-.312.124-.67.248-1.063.37l.215.734c.5-.147.843-.258 1.1-.359.863-.394.907-2 .907-2.32v-.334l-.249-.247-.013-.014a1.887 1.887 0 01-.317-.4A.946.946 0 008.369 9a.6.6 0 00-.169-.334 1.5 1.5 0 01-.27-.451L7.928 8.2c-.019-.041-.036-.079-.054-.113l-.166-.249-.246-.168-.083-.082a3.354 3.354 0 01-.415-1.493l.5-.164V5.35a4.47 4.47 0 01.516-2.206 2.905 2.905 0 011.382-1.277.4.4 0 00.245-.082 4.869 4.869 0 011.158-.416 1.207 1.207 0 00.4-.1h.014c.054-.02.108-.039.169-.059v.581l.661.164a.9.9 0 01.5.167v.33l.239.25a3.606 3.606 0 01.828 2.651v.5l.412.249a2.68 2.68 0 01-.412 1.411l-.163.164-.249.167L13 8.17a2.6 2.6 0 01-.4.816L12.584 9l-.009.01c-.077.077-.157.157-.157.237l-.082.084a2.088 2.088 0 01-.412.578l-.415.249.084.5c0 .74.282 1.923.91 2.238h.166l.331.082a23.308 23.308 0 012.915 1.24l.008-.875a12.249 12.249 0 00-2.678-1.113l-.331-.082c-.152-.078-.407-.618-.5-1.575a2.371 2.371 0 00.661-.829.416.416 0 00.085-.127.438.438 0 01.081-.123 4.507 4.507 0 00.579-1.076A2.264 2.264 0 0014.313 8a4.217 4.217 0 00.5-2.242 1 1 0 00-.411-.414 4.6 4.6 0 00-1.076-3.232v-.164a1.36 1.36 0 00-1.159-.827.638.638 0 00-.079-.331 1.15 1.15 0 00-.582-.663H11.5a.3.3 0 00-.24.082l-.167.164c0 .085-.162.167-.494.249a11.568 11.568 0 00-1.23.406h-.008l-.02.007c-.09.034-.167.063-.225.083-1.5.583-2.4 2.163-2.4 4.226a.675.675 0 00-.411.411A4.079 4.079 0 006.715 8a1.018 1.018 0 00.411.414"
						data-name="Path 6961"
					/>
					<path
						d="M12.644 16.785H3.989a.564.564 0 01-.58-.547V16.2c0-.068 0-.133.006-.207h-.747v.292A1.392 1.392 0 004.04 17.7h8.6z"
						data-name="Path 6963"
					/>
				</g>
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth="0.25"
					d="M12.644 16.785H3.989a.564.564 0 01-.58-.547V16.2c0-.068 0-.133.006-.207h-.747v.292A1.392 1.392 0 004.04 17.7h8.6z"
					data-name="Path 6964"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const AddAppIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath>
				<path fill="none" d="M0 0H19.279V20.545H0z" data-name="Rectangle 3018" />
			</clipPath>
		</defs>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3011" />
		<g data-name="Group 6515" transform="translate(3.36 1.727)">
			<g data-name="Group 6526">
				<g data-name="Group 6529">
					<g data-name="Group 6530">
						<path
							fill="currentColor"
							d="M6.784 3.894H3.877v2.92h-.969v-2.92H0V2.92h2.908V0h.969v2.92h2.907z"
							data-name="↳Color"
							transform="translate(11.565 12.739)"
						/>
					</g>
				</g>
			</g>
			<path
				fill="currentColor"
				d="M162-784a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-786a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-788a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-786a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-784zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-786a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-788a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-786a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-784zm-6-6a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-790zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-790zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01172-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01174-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01176-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01174-790zm-12-6a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-796zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-796zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01172-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01174-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01176-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01174-796z"
				transform="translate(-160.36 801.273)"
			/>
		</g>
	</SvgIcon>
);

export const AddSingleDeviceIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3010" />
		<g data-name="Group 6512" transform="translate(-337.167 -640.3)">
			<path
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeWidth="0.2"
				d="M343.537 662.171h-2a.59.59 0 010-1.18h2a.59.59 0 110 1.18z"
				data-name="Path 6950"
			/>
			<path
				fill="currentColor"
				d="M5.326 3.986h5.491a.59.59 0 01.59.59v2.745a.59.59 0 01-.59.59H5.326a.59.59 0 01-.59-.59V4.576a.59.59 0 01.59-.59m4.9 1.18h-4.31v1.565h4.308z"
				data-name="Path 6951"
				transform="translate(340.91 642.911)"
			/>
			<path
				fill="none"
				d="M0 0H17.933V19.971H0z"
				data-name="Rectangle 3009"
				transform="translate(340.201 642.315)"
			/>
			<g data-name="Group 6524">
				<g data-name="Group 6528">
					<g fill="currentColor" data-name="Group 6523">
						<path
							d="M3.238 17.425h-2a.59.59 0 010-1.18h2a.59.59 0 110 1.18z"
							data-name="Path 6949"
							transform="translate(340.299 644.746)"
						/>
						<path
							d="M8.388 13.045H2.177a.591.591 0 010-1.18h6.211a.591.591 0 010 1.18z"
							data-name="Path 6952"
							transform="translate(340.444 644.091)"
						/>
						<path
							d="M8.388 9.862H2.177a.591.591 0 010-1.18h6.211a.591.591 0 010 1.18z"
							data-name="Path 6953"
							transform="translate(340.444 643.614)"
						/>
						<path
							d="M5.326 3.986h5.491a.59.59 0 01.59.59v2.745a.59.59 0 01-.59.59H5.326a.59.59 0 01-.59-.59V4.576a.59.59 0 01.59-.59m4.9 1.18h-4.31v1.565h4.308z"
							data-name="Path 6954"
							transform="translate(340.91 642.911)"
						/>
						<path
							d="M7.46 16.768H1.183V1.2h3.062l.521 2.289a.592.592 0 00.575.46h7.409v6.161h1.178V3.357a.591.591 0 00-.591-.591H5.812l-.018-.08 7.044-1.507a.591.591 0 10-.246-1.15l-7.063 1.5-.24-1.054a.59.59 0 00-.575-.46H.591A.592.592 0 000 .607v16.749a.593.593 0 00.591.593H7.46z"
							data-name="Path 6956"
							transform="translate(340.201 642.314)"
						/>
					</g>
					<path
						fill="currentColor"
						d="M6.784 3.894H3.877v2.92h-.969v-2.92H0V2.92h2.908V0h.969v2.92h2.907z"
						data-name="↳Color"
						transform="translate(350.167 654.767)"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const ImportDevicesIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3010" />
		<g data-name="Group 6512" transform="translate(-337.167 -640.3)">
			<path
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeWidth="0.2"
				d="M343.537 662.171h-2a.59.59 0 010-1.18h2a.59.59 0 110 1.18z"
				data-name="Path 6950"
			/>
			<path
				fill="currentColor"
				d="M5.326 3.986h5.491a.59.59 0 01.59.59v2.745a.59.59 0 01-.59.59H5.326a.59.59 0 01-.59-.59V4.576a.59.59 0 01.59-.59m4.9 1.18h-4.31v1.565h4.308z"
				data-name="Path 6951"
				transform="translate(340.91 642.911)"
			/>
			<path
				fill="currentColor"
				d="M11.684 15.157l-2.529-2.532.709-.735 1.311 1.31V9.078h1.01v4.127l1.315-1.313.709.735zm-3.035 2.026a1.013 1.013 0 01-1.012-1.013v-1.52h1.012v1.52h6.07v-1.52h1.01v1.52a1.013 1.013 0 01-1.01 1.013z"
				data-name="Path 6955"
				transform="translate(341.875 644.372)"
			/>
			<g fill="currentColor" data-name="Group 6519">
				<path
					d="M3.238 17.425h-2a.59.59 0 010-1.18h2a.59.59 0 110 1.18z"
					data-name="Path 6949"
					transform="translate(340.298 644.746)"
				/>
				<path
					d="M8.388 13.045H2.177a.591.591 0 010-1.18h6.211a.591.591 0 010 1.18z"
					data-name="Path 6952"
					transform="translate(340.444 644.091)"
				/>
				<path
					d="M8.388 9.862H2.177a.591.591 0 010-1.18h6.211a.591.591 0 010 1.18z"
					data-name="Path 6953"
					transform="translate(340.444 643.614)"
				/>
				<path
					d="M5.326 3.986h5.491a.59.59 0 01.59.59v2.745a.59.59 0 01-.59.59H5.326a.59.59 0 01-.59-.59V4.576a.59.59 0 01.59-.59m4.9 1.18h-4.31v1.565h4.308z"
					data-name="Path 6954"
					transform="translate(340.91 642.911)"
				/>
				<path
					d="M7.46 16.768H1.183V1.2h3.062l.521 2.289a.592.592 0 00.575.46h7.409V9.11h1.178V3.357a.591.591 0 00-.591-.591H5.812l-.018-.08 7.044-1.507a.591.591 0 10-.246-1.15l-7.063 1.5-.24-1.054a.59.59 0 00-.575-.46H.591A.592.592 0 000 .607v16.749a.593.593 0 00.591.593H7.46z"
					data-name="Path 6956"
					transform="translate(340.201 642.314)"
				/>
			</g>
			<path
				fill="none"
				d="M0 0H17.933V19.971H0z"
				data-name="Rectangle 3009"
				transform="translate(340.201 642.315)"
			/>
		</g>
	</SvgIcon>
);

export const CopyFlippedIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<g id="Group_3641" data-name="Group 3641" transform="translate(9890 17702)">
			<path
				id="content_copy_FILL0_wght500_GRAD0_opsz24"
				d="M107.913-879.6a1.488,1.488,0,0,1-1.093-.451,1.488,1.488,0,0,1-.451-1.092v-9.453h1.544v9.453h7.417v1.544Zm2.9-2.9a1.488,1.488,0,0,1-1.093-.451,1.488,1.488,0,0,1-.451-1.093v-8.047a1.488,1.488,0,0,1,.451-1.093,1.488,1.488,0,0,1,1.093-.451h6.011a1.488,1.488,0,0,1,1.093.451,1.488,1.488,0,0,1,.451,1.093v8.047a1.488,1.488,0,0,1-.451,1.093,1.488,1.488,0,0,1-1.093.451Zm0-1.544h6.011v-8.047h-6.011Zm0,0v0Z"
				transform="translate(-9990.369 -16803.387)"
				fill="#7d61bc"
			/>
			<g id="Group_3627" data-name="Group 3627" transform="translate(-40 97)">
				<g id="Group_3622" data-name="Group 3622" transform="translate(-82 -22)">
					<rect
						id="Rectangle_1958"
						data-name="Rectangle 1958"
						width="24"
						height="24"
						transform="translate(-9768 -17777)"
						fill="none"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const HourglassBottomIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<g>
			<rect fill="none" height="24" width="24" />
		</g>
		<g>
			<path d="M18,22l-0.01-6L14,12l3.99-4.01L18,2H6v6l4,4l-4,3.99V22H18z M8,7.5V4h8v3.5l-4,4L8,7.5z" />
		</g>
	</SvgIcon>
);
export const JobsIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<rect fill="none" height="24" width="24" />
		<path d="M22,5.18L10.59,16.6l-4.24-4.24l1.41-1.41l2.83,2.83l10-10L22,5.18z M19.79,10.22C19.92,10.79,20,11.39,20,12 c0,4.42-3.58,8-8,8s-8-3.58-8-8c0-4.42,3.58-8,8-8c1.58,0,3.04,0.46,4.28,1.25l1.44-1.44C16.1,2.67,14.13,2,12,2C6.48,2,2,6.48,2,12 c0,5.52,4.48,10,10,10s10-4.48,10-10c0-1.19-0.22-2.33-0.6-3.39L19.79,10.22z" />
	</SvgIcon>
);
export const JobQueueIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			d="M16,1H4C2.9,1,2,1.9,2,3v14h2V3h12V1z M15,5H8C6.9,5,6,5.9,6,7l0,14c0,1.1,0.9,2,2,2h11c1.1,0,2-0.9,2-2V11L15,5z M8,21V7h6
	v5h5v9H8z"
		/>
		<polygon points="10.3,14.6 8.9,16 12.4,19.5 18.1,13.9 16.7,12.4 12.4,16.7 " />
	</SvgIcon>
);
export const JobQueueManagementIcon = (props: SvgIconProps) => (
	<SvgIcon transform="translate(-4 -4)" viewBox="0 0 19 19" overflow="visible" {...props}>
		<g transform="translate(3 3)">
			<path fill="none" d="M0 0h18v18H0z" data-name="Path 6725" />
			<path
				fill="currentColor"
				d="M13.646 1H3.664A1.618 1.618 0 002 2.557v10.9h1.664v-10.9h9.982zm-.832 3.113H6.991A1.618 1.618 0 005.327 5.67v10.9a1.618 1.618 0 001.664 1.557h9.15a1.618 1.618 0 001.659-1.562V8.783zM6.991 16.565V5.67h4.991v3.891h4.159v7z"
				data-name="Path 6726"
				transform="translate(-1.122 -.561)"
			/>
		</g>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2027" />
		<path
			fill="currentColor"
			d="M2.205 5.727l-.172-.859q-.172-.072-.322-.15a2.494 2.494 0 01-.311-.193l-.83.258L0 3.809l.659-.573a2.644 2.644 0 01-.029-.372 2.644 2.644 0 01.029-.372L0 1.919.573.945 1.4 1.2a2.491 2.491 0 01.308-.193q.15-.079.322-.15L2.205 0h1.146l.172.859a2.891 2.891 0 01.322.158 2.259 2.259 0 01.308.215l.83-.286.573 1-.656.574a2.252 2.252 0 010 .716l.659.573-.573.974-.83-.258a2.5 2.5 0 01-.308.193q-.15.079-.322.15l-.172.859zm.573-1.718a1.149 1.149 0 001.145-1.145 1.149 1.149 0 00-1.145-1.146 1.149 1.149 0 00-1.146 1.146 1.149 1.149 0 001.146 1.145z"
			transform="rotate(164 6.88 9.893)"
		/>
	</SvgIcon>
);
export const JobLockedIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<rect width="24" height="24" fill="none" />
		<g transform="translate(-34 4)">
			<path
				d="M9.143,18A1.138,1.138,0,0,1,8,16.857V8.59A1.138,1.138,0,0,1,9.143,7.448h1.333V5.619a3.489,3.489,0,0,1,1.057-2.562,3.633,3.633,0,0,1,5.124,0,3.489,3.489,0,0,1,1.057,2.562V7.448h1.333A1.138,1.138,0,0,1,20.19,8.59v8.267A1.138,1.138,0,0,1,19.048,18ZM14.1,14.19a1.43,1.43,0,0,0,1.038-.419,1.361,1.361,0,0,0,.429-1.01,1.5,1.5,0,0,0-.429-1.038,1.388,1.388,0,0,0-2.076,0,1.5,1.5,0,0,0-.429,1.038,1.361,1.361,0,0,0,.429,1.01A1.43,1.43,0,0,0,14.1,14.19ZM11.619,7.448h4.952V5.619a2.478,2.478,0,0,0-4.229-1.752,2.387,2.387,0,0,0-.724,1.752Z"
				transform="translate(31.905 -2)"
				fill="#5f3fa5"
			/>
		</g>
	</SvgIcon>
);

export const JobQueueActiveIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<g id="task-pool" transform="translate(4 4)">
			<path id="Path_6725" data-name="Path 6725" d="M0,0H16V16H0Z" fill="none" />
			<path
				id="Path_6726"
				data-name="Path 6726"
				d="M12.352,1H3.479A1.438,1.438,0,0,0,2,2.384v9.685H3.479V2.384h8.873Zm-.739,2.767H6.436A1.438,1.438,0,0,0,4.958,5.151v9.685A1.438,1.438,0,0,0,6.436,16.22H14.57a1.438,1.438,0,0,0,1.479-1.384V7.918ZM6.436,14.836V5.151h4.436V8.61h3.7v6.226Z"
				transform="translate(-1.22 -0.61)"
			/>
			<path
				id="Path_6727"
				data-name="Path 6727"
				d="M9.78,13.783l-.88.88,2.2,2.2,3.583-3.52L13.8,12.4l-2.7,2.7Z"
				transform="translate(-2.534 -3.54)"
			/>
		</g>
		<g id="task-pool-2" data-name="task-pool" transform="translate(4 4)">
			<path id="Path_6725-2" data-name="Path 6725" d="M0,0H16V16H0Z" fill="none" />
			<path
				id="Path_6726-2"
				data-name="Path 6726"
				d="M12.352,1H3.479A1.438,1.438,0,0,0,2,2.384v9.685H3.479V2.384h8.873Zm-.739,2.767H6.436A1.438,1.438,0,0,0,4.958,5.151v9.685A1.438,1.438,0,0,0,6.436,16.22H14.57a1.438,1.438,0,0,0,1.479-1.384V7.918ZM6.436,14.836V5.151h4.436V8.61h3.7v6.226Z"
				transform="translate(-1.22 -0.61)"
			/>
			<path
				id="Path_6727-2"
				data-name="Path 6727"
				d="M9.78,13.783l-.88.88,2.2,2.2,3.583-3.52L13.8,12.4l-2.7,2.7Z"
				transform="translate(-2.534 -3.54)"
			/>
		</g>
	</SvgIcon>
);

export const JobQueueInactiveIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<defs>
			<radialGradient id="radial-gradient" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox">
				<stop offset="0" stopColor="#fff" />
				<stop offset="0.482" stopColor="#fff" stopOpacity="0.38" />
				<stop offset="1" stopColor="#41b80e" stopOpacity="0.38" />
			</radialGradient>
		</defs>
		<rect id="Rectangle_596" data-name="Rectangle 596" width="24" height="24" rx="4" opacity="0" />
		<g id="task-pool" transform="translate(4 4)">
			<path id="Path_6725" data-name="Path 6725" d="M0,0H16V16H0Z" fill="none" />
			<path
				id="Path_6726"
				data-name="Path 6726"
				d="M12.352,1H3.479A1.438,1.438,0,0,0,2,2.384v9.685H3.479V2.384h8.873Zm-.739,2.767H6.436A1.438,1.438,0,0,0,4.958,5.151v9.685A1.438,1.438,0,0,0,6.436,16.22H14.57a1.438,1.438,0,0,0,1.479-1.384V7.918ZM6.436,14.836V5.151h4.436V8.61h3.7v6.226Z"
				transform="translate(-1.22 -0.61)"
			/>
		</g>
	</SvgIcon>
);

export const CampaignIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path d="M18 11v2h4v-2zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61M20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4M4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9zm5.03 1.71L11 9.53v4.94l-1.97-1.18-.48-.29H4v-2h4.55zM15.5 12c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34" />
	</SvgIcon>
);

export const CelebrationIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path d="m2 22 14-5-9-9zm10.35-5.82L5.3 18.7l2.52-7.05zm2.18-3.65 5.59-5.59c.49-.49 1.28-.49 1.77 0l.59.59 1.06-1.06-.59-.59c-1.07-1.07-2.82-1.07-3.89 0l-5.59 5.59zm-4.47-5.65-.59.59 1.06 1.06.59-.59c1.07-1.07 1.07-2.82 0-3.89l-.59-.59-1.06 1.07.59.59c.48.48.48 1.28 0 1.76m7 5-1.59 1.59 1.06 1.06 1.59-1.59c.49-.49 1.28-.49 1.77 0l1.61 1.61 1.06-1.06-1.61-1.61c-1.08-1.07-2.82-1.07-3.89 0m-2-6-3.59 3.59 1.06 1.06 3.59-3.59c1.07-1.07 1.07-2.82 0-3.89l-1.59-1.59-1.06 1.06 1.59 1.59c.48.49.48 1.29 0 1.77" />
	</SvgIcon>
);

export const StarIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path id="Rectangle_3195" fill="none" d="M0 0h24v24H0z" data-name="Rectangle 3195" />
		<path
			id="stars_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			fill="currentColor"
			d="m86-864 4-3.05 4 3.05-1.5-4.95 4-2.85h-4.9L90-877l-1.6 5.2h-4.9l4 2.85Zm4 4a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138 10.1 10.1 0 0 1-2.138-3.175A9.7 9.7 0 0 1 80-870a9.7 9.7 0 0 1 .787-3.9 10.1 10.1 0 0 1 2.138-3.175 10.1 10.1 0 0 1 3.175-2.138A9.7 9.7 0 0 1 90-880a9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138 10.1 10.1 0 0 1 2.138 3.175A9.7 9.7 0 0 1 100-870a9.7 9.7 0 0 1-.787 3.9 10.1 10.1 0 0 1-2.138 3.175 10.1 10.1 0 0 1-3.175 2.138A9.7 9.7 0 0 1 90-860m0-2a7.72 7.72 0 0 0 5.675-2.325A7.72 7.72 0 0 0 98-870a7.72 7.72 0 0 0-2.325-5.675A7.72 7.72 0 0 0 90-878a7.72 7.72 0 0 0-5.675 2.325A7.72 7.72 0 0 0 82-870a7.72 7.72 0 0 0 2.325 5.675A7.72 7.72 0 0 0 90-862m0-8"
			transform="translate(-78 882)"
		/>
	</SvgIcon>
);

export const SunnyIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path id="Rectangle_3197" fill="none" d="M0 0h24v24H0z" data-name="Rectangle 3197" />
		<path
			id="partly_cloudy_day_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			fill="currentColor"
			d="M49.091-916.364V-920h1.818v3.636Zm6.045 2.5-1.273-1.273 2.568-2.591 1.273 1.3Zm1.227 4.773v-1.818H60v1.818Zm.068 6.8-2.568-2.568 1.273-1.273 2.591 2.545Zm-11.567-11.573-2.564-2.568 1.3-1.3 2.545 2.591Zm-.318 10.227h4.091a1.32 1.32 0 0 0 .966-.4A1.32 1.32 0 0 0 50-905a1.34 1.34 0 0 0-.386-.966 1.28 1.28 0 0 0-.955-.4H47.5l-.455-1.091a2.6 2.6 0 0 0-1-1.193 2.7 2.7 0 0 0-1.5-.443 2.63 2.63 0 0 0-1.932.8 2.63 2.63 0 0 0-.8 1.932 2.63 2.63 0 0 0 .8 1.932 2.63 2.63 0 0 0 1.932.793Zm0 1.818a4.38 4.38 0 0 1-3.216-1.33 4.38 4.38 0 0 1-1.33-3.215 4.38 4.38 0 0 1 1.33-3.216 4.38 4.38 0 0 1 3.216-1.33 4.44 4.44 0 0 1 2.489.739 4.46 4.46 0 0 1 1.67 1.989 2.89 2.89 0 0 1 2.216.977 3.34 3.34 0 0 1 .9 2.341 3.03 3.03 0 0 1-.966 2.17 3.1 3.1 0 0 1-2.216.875Zm7.273-3.045q-.114-.455-.227-.886t-.227-.886a3.7 3.7 0 0 0 1.648-1.341 3.5 3.5 0 0 0 .623-2.023 3.5 3.5 0 0 0-1.068-2.568A3.5 3.5 0 0 0 50-913.636a3.53 3.53 0 0 0-2.386.886 3.5 3.5 0 0 0-1.2 2.25q-.455-.114-.932-.2t-.932-.2a5.13 5.13 0 0 1 1.875-3.273A5.5 5.5 0 0 1 50-915.455a5.26 5.26 0 0 1 3.864 1.591A5.26 5.26 0 0 1 55.455-910a5.28 5.28 0 0 1-1 3.148 5.44 5.44 0 0 1-2.637 1.988ZM50.023-910"
			transform="translate(-38 922.909)"
		/>
	</SvgIcon>
);

export const CirclePlusIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path id="Path_8158" data-name="Path 8158" d="M0,0H24V24H0Z" fill="none" />
		<path
			id="Path_8159"
			data-name="Path 8159"
			d="M10.5,2A8.5,8.5,0,1,0,19,10.5,8.5,8.5,0,0,0,10.5,2Zm4.25,9.35h-3.4v3.4H9.65v-3.4H6.25V9.65h3.4V6.25h1.7v3.4h3.4Z"
			transform="translate(1.5 1.5)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const TransferOwnershipIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_2901" data-name="Rectangle 2901" width="24" height="24" fill="none" />
		<g id="Group_7867" data-name="Group 7867" transform="translate(0.255 0.523)">
			<path
				id="supervisor_account_FILL0_wght400_GRAD0_opsz24"
				d="M484-556a1.932,1.932,0,0,1-1.42-.58A1.931,1.931,0,0,1,482-558a1.931,1.931,0,0,1,.58-1.42A1.931,1.931,0,0,1,484-560a1.931,1.931,0,0,1,1.42.58A1.931,1.931,0,0,1,486-558a1.931,1.931,0,0,1-.58,1.42A1.931,1.931,0,0,1,484-556Zm-4,4v-1.12a1.679,1.679,0,0,1,.25-.89,1.408,1.408,0,0,1,.71-.59,7.677,7.677,0,0,1,1.49-.45,8.085,8.085,0,0,1,1.55-.15,8.084,8.084,0,0,1,1.55.15,7.677,7.677,0,0,1,1.49.45,1.408,1.408,0,0,1,.71.59,1.678,1.678,0,0,1,.25.89V-552Z"
				transform="translate(-476.162 564.065)"
				fill="currentColor"
			/>
			<path
				id="supervisor_account_FILL0_wght400_GRAD0_opsz24-2"
				data-name="supervisor_account_FILL0_wght400_GRAD0_opsz24"
				d="M484-556a1.932,1.932,0,0,1-1.42-.58A1.932,1.932,0,0,1,482-558a1.931,1.931,0,0,1,.58-1.42A1.931,1.931,0,0,1,484-560a1.931,1.931,0,0,1,1.42.58A1.931,1.931,0,0,1,486-558a1.931,1.931,0,0,1-.58,1.42A1.931,1.931,0,0,1,484-556Zm-4,4v-1.12a1.679,1.679,0,0,1,.25-.89,1.408,1.408,0,0,1,.71-.59,7.672,7.672,0,0,1,1.49-.45,8.08,8.08,0,0,1,1.55-.15,8.079,8.079,0,0,1,1.55.15,7.671,7.671,0,0,1,1.49.45,1.408,1.408,0,0,1,.71.59,1.678,1.678,0,0,1,.25.89V-552Z"
				transform="translate(-468.349 570.888)"
				fill="currentColor"
			/>
			<path
				id="repeat_one_FILL0_wght400_GRAD0_opsz24"
				d="M1.618,4.446,0,2.828,1.618,1.211l.566.586-.627.627H4.319V0h.809V3.233H1.557l.627.627Z"
				transform="translate(10.061 13.065) rotate(90)"
				fill="currentColor"
			/>
			<path
				id="repeat_one_FILL0_wght400_GRAD0_opsz24-2"
				data-name="repeat_one_FILL0_wght400_GRAD0_opsz24"
				d="M1.618,4.447,0,2.829,1.618,1.211l.566.587-.627.627H4.319V0h.809V3.234H1.557l.627.627Z"
				transform="translate(13.428 10.193) rotate(-90)"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const CalendarIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<g id="Group_908" data-name="Group 908">
			<rect id="Rectangle_891" data-name="Rectangle 891" width="24" height="24" fill="none" />
		</g>
		<g id="Group_909" data-name="Group 909" transform="translate(3 2)">
			<path
				id="Path_6213"
				data-name="Path 6213"
				d="M19,4H18V2H16V4H8V2H6V4H5A1.991,1.991,0,0,0,3.01,6L3,20a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,19,4Zm0,16H5V10H19ZM19,8H5V6H19ZM9,14H7V12H9Zm4,0H11V12h2Zm4,0H15V12h2ZM9,18H7V16H9Zm4,0H11V16h2Zm4,0H15V16h2Z"
				transform="translate(-3 -2)"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const ThumbsDownIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="clip-path">
				<rect id="Rectangle_3056" data-name="Rectangle 3056" width="20" height="20" fill="#323232" />
			</clipPath>
		</defs>
		<g id="Group_7180" data-name="Group 7180" transform="translate(-6860 -1664) rotate(180)">
			<g id="Group_7178" data-name="Group 7178" transform="translate(-6882 -1686.002)">
				<g id="Group_7177" data-name="Group 7177" transform="translate(0 0.002)" clipPath="url(#clip-path)">
					<path
						id="Path_8100"
						data-name="Path 8100"
						d="M276.6,0a1.776,1.776,0,0,1,1.543,1.048,5.58,5.58,0,0,1,.566,4.241c-.257,1.264-.411,2.488-.411,2.488h6.53l0,.008a1.588,1.588,0,0,1-.15,3.162h.131a1.616,1.616,0,0,1,1.624,1.5,1.566,1.566,0,0,1-1.537,1.67H284.5a1.592,1.592,0,0,1-.667,3.047H283.5a1.627,1.627,0,0,1,.482,1.866,1.514,1.514,0,0,1-1.426.969h-5.531a11.36,11.36,0,0,1-5.687-1.511l-.027-.016V9.366c2.817-.181,4.261-4.557,4.364-5.3s.262-3.917.262-3.917A1.532,1.532,0,0,1,276.6,0"
						transform="translate(-266.431 -0.002)"
						fill={props.htmlColor ? props.htmlColor : '#323232'}
					/>
					<path
						id="Path_8101"
						data-name="Path 8101"
						d="M3.388,481.63H.81A.822.822,0,0,1,0,480.8V472.11a.822.822,0,0,1,.81-.834H3.388a.822.822,0,0,1,.81.834V480.8a.822.822,0,0,1-.81.834"
						transform="translate(0 -462.556)"
						fill={props.htmlColor ? props.htmlColor : '#323232'}
					/>
				</g>
			</g>
			<rect
				id="Rectangle_3057"
				data-name="Rectangle 3057"
				width="24"
				height="24"
				transform="translate(-6884 -1688)"
				fill="none"
			/>
		</g>
	</SvgIcon>
);

export const ThumbsUpIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="clip-path">
				<rect id="Rectangle_3056" data-name="Rectangle 3056" width="20" height="20" fill="#323232" />
			</clipPath>
		</defs>
		<g id="Group_7178" data-name="Group 7178" transform="translate(2 1.998)">
			<g id="Group_7177" data-name="Group 7177" transform="translate(0 0.002)" clipPath="url(#clip-path)">
				<path
					id="Path_8100"
					data-name="Path 8100"
					d="M276.6,0a1.776,1.776,0,0,1,1.543,1.048,5.58,5.58,0,0,1,.566,4.241c-.257,1.264-.411,2.488-.411,2.488h6.53l0,.008a1.588,1.588,0,0,1-.15,3.162h.131a1.616,1.616,0,0,1,1.624,1.5,1.566,1.566,0,0,1-1.537,1.67H284.5a1.592,1.592,0,0,1-.667,3.047H283.5a1.627,1.627,0,0,1,.482,1.866,1.514,1.514,0,0,1-1.426.969h-5.531a11.36,11.36,0,0,1-5.687-1.511l-.027-.016V9.366c2.817-.181,4.261-4.557,4.364-5.3s.262-3.917.262-3.917A1.532,1.532,0,0,1,276.6,0"
					transform="translate(-266.431 -0.002)"
					fill={props.htmlColor ? props.htmlColor : '#323232'}
				/>
				<path
					id="Path_8101"
					data-name="Path 8101"
					d="M3.388,481.63H.81A.822.822,0,0,1,0,480.8V472.11a.822.822,0,0,1,.81-.834H3.388a.822.822,0,0,1,.81.834V480.8a.822.822,0,0,1-.81.834"
					transform="translate(0 -462.556)"
					fill={props.htmlColor ? props.htmlColor : '#323232'}
				/>
			</g>
		</g>
		<rect id="Rectangle_3057" data-name="Rectangle 3057" width="24" height="24" fill="none" />
	</SvgIcon>
);

export const ApprovalIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path id="Path_6765" data-name="Path 6765" d="M0,0H24V24H0Z" fill="none" />
		<path
			id="verified_FILL0_wght400_GRAD0_opsz24_1_"
			data-name="verified_FILL0_wght400_GRAD0_opsz24 (1)"
			d="M47.6-879l-1.9-3.2-3.6-.8.35-3.7L40-889.5l2.45-2.8L42.1-896l3.6-.8,1.9-3.2,3.4,1.45L54.4-900l1.9,3.2,3.6.8-.35,3.7L62-889.5l-2.45,2.8.35,3.7-3.6.8L54.4-879,51-880.45Zm.85-2.55,2.55-1.1,2.6,1.1,1.4-2.4,2.75-.65-.25-2.8,1.85-2.1-1.85-2.15.25-2.8-2.75-.6-1.45-2.4L51-896.35l-2.6-1.1-1.4,2.4-2.75.6.25,2.8-1.85,2.15,1.85,2.1-.25,2.85,2.75.6ZM51-889.5Zm-1.05,3.55,5.65-5.65-1.4-1.45-4.25,4.25-2.15-2.1-1.4,1.4Z"
			transform="translate(-38.926 902)"
			fill={props.htmlColor ? props.htmlColor : '#323232'}
		/>
	</SvgIcon>
);

export const SignatureTypeBackgroundIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 76 76" {...props}>
		<g id="Group_6957" data-name="Group 6957" transform="translate(-915.704 -480.501)">
			<path
				id="Path_7941"
				data-name="Path 7941"
				d="M0,0V65"
				transform="translate(978.5 486.5)"
				fill="none"
				stroke="#f2eff9"
				strokeWidth="2"
			/>
			<g id="Group_6956" data-name="Group 6956" transform="translate(929.907 496.496)">
				<path
					id="Path_6092"
					data-name="Path 6092"
					d="M14.413,38.223,9.422,52.779H3.6L19.4,6.2h7.07L42.693,53.195H36.455L31.464,38.639H14.413ZM29.8,33.648,25.226,20.34c-.832-2.911-1.664-5.822-2.5-8.318h0c-.832,2.5-1.664,5.406-2.5,7.9L15.661,33.232H29.8Z"
					transform="translate(-3.6 -6.2)"
					fill="#f2eff9"
				/>
			</g>
		</g>
		<rect id="Rectangle_3176" data-name="Rectangle 3176" width="76" height="76" fill="none" />
	</SvgIcon>
);

export const SignatureDrawBackgroundIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 82 76" {...props}>
		<g id="Group_6960" data-name="Group 6960" transform="translate(2420.931 4574.999)">
			<g id="Group_6958" data-name="Group 6958" transform="translate(-2418.483 -4565.462)">
				<path
					id="Path_7936"
					data-name="Path 7936"
					d="M77.1,46H16.85a78.893,78.893,0,0,0,2.882-8.278q.526-1.858.958-3.74A5.532,5.532,0,0,1,26.227,36.7a4.432,4.432,0,0,1,.311,3.126,6.539,6.539,0,0,0-1.72,2.665,1.167,1.167,0,0,0,.411,1.392c.912.611,2.852-.134,3.192-.417a6.84,6.84,0,0,0,1.84-2.381c1.209-.655,3.109-.591,5.67.207l.882.274A22.353,22.353,0,0,0,43.6,42.939h.033A3.138,3.138,0,0,0,45.979,41.6a1.151,1.151,0,0,0,.037-1.165,1.5,1.5,0,0,0-1.409-.628H44.6a19.66,19.66,0,0,1-5.52-1.132,17.133,17.133,0,0,0-7.116-1.129c-.394.04-.771.1-1.135.177-.007-.07-.017-.144-.027-.217a7.481,7.481,0,0,0-4.187-5.74,10.243,10.243,0,0,0-5.263-.945,79.137,79.137,0,0,0,1.356-13.788,62.765,62.765,0,0,0-.478-9.48c-.291-2.024-.935-4.892-3.142-6.442-4.331-3.035-9.767.661-13.1,4.745C1.376,11.513.257,18.756,3.139,24.313A14.471,14.471,0,0,0,16.092,32.3l.174,0a18.349,18.349,0,0,0-3.59,2.361A28.945,28.945,0,0,0,4.6,46H0v3.693H3.55c-.033.16-.083.324-.107.484a5.736,5.736,0,0,0,2.848,6.191,4.555,4.555,0,0,0,2.047.488,5.479,5.479,0,0,0,3.914-1.82,17.305,17.305,0,0,0,3.089-5.343H77.1ZM8.9,25.411A13.879,13.879,0,0,1,6.3,13.323c.925-3.376,3.857-8.669,7.487-9.861a3.57,3.57,0,0,1,1.085-.194,2.017,2.017,0,0,1,1.172.354c2.01,1.386,2.241,6.361,2.351,8.749l.023.481a75.826,75.826,0,0,1-.935,16.309l-.127.007A9.778,9.778,0,0,1,8.9,25.411m.965,18.637a24.888,24.888,0,0,1,6.151-8.011c-.25.962-.521,1.923-.808,2.878C14.476,41.347,13.6,43.7,12.656,46H8.933c.3-.671.614-1.329.935-1.95m.4,7.206-.264.538c-.431.9-.494,1.045-1.332,1.062a6.025,6.025,0,0,1-.785-.013,1.844,1.844,0,0,1-.237-.568,3.931,3.931,0,0,1-.08-1.423,8.793,8.793,0,0,1,.164-1.159H10.98c-.244.511-.451,1.059-.708,1.563"
					transform="translate(0 0)"
					fill="#f2eff9"
				/>
				<g id="Group_6953" data-name="Group 6953" transform="translate(47.689 0.701)">
					<path
						id="Path_7937"
						data-name="Path 7937"
						d="M36.19,6.308a1.31,1.31,0,0,0-.751-1.553C32.928,3.4,31.675,2.718,29.164,1.363c-.371-.2-1.3-.417-1.71.214A147.16,147.16,0,0,0,15.473,24.317L23.7,28.775A147.747,147.747,0,0,0,36.19,6.308"
						transform="translate(-11.493 2.007)"
						fill="#f2eff9"
					/>
					<path
						id="Path_7938"
						data-name="Path 7938"
						d="M14.769,22.6c.578.314,1.443-.094,2.484-1.439,0,0,2.595-.25,7.71-8.131L17.236,8.84c-3.907,8.762-2.625,10.913-2.625,10.913-.264.8-.658,2.4.157,2.845"
						transform="translate(-14.281 19.977)"
						fill="#f2eff9"
					/>
					<path
						id="Path_7939"
						data-name="Path 7939"
						d="M20.723,16.884a1.344,1.344,0,0,0,1.88-.391A76.743,76.743,0,0,0,28.811,5.043a1.357,1.357,0,0,0-2.488-1.085A74.135,74.135,0,0,1,20.332,15a1.374,1.374,0,0,0,.391,1.88"
						transform="translate(-0.614 6.665)"
						fill="#f2eff9"
					/>
					<path
						id="Path_7940"
						data-name="Path 7940"
						d="M26.145,3.432c.19-.354-.067-.872-.584-1.149l-3.5-1.9c-.511-.277-1.089-.217-1.282.14l-.755,1.392,5.37,2.909Z"
						transform="translate(-0.854 -0.21)"
						fill="#f2eff9"
					/>
				</g>
			</g>
		</g>
		<rect id="Rectangle_3175" data-name="Rectangle 3175" width="82" height="76" fill="none" />
	</SvgIcon>
);

export const R2mRegisterIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path
			id="Union_51"
			fill="currentColor"
			d="M14019.93 1222.268a1.91 1.91 0 0 1-1.93-1.93v-16.409a1.91 1.91 0 0 1 1.93-1.927h8.471l5.6 5.6v12.736a1.913 1.913 0 0 1-1.931 1.93Zm-.226-1.7a.3.3 0 0 0 .226.1h12.141a.3.3 0 0 0 .226-.1.3.3 0 0 0 .105-.225V1208.4h-4.8v-4.8h-7.671a.31.31 0 0 0-.226.1.3.3 0 0 0-.105.225v16.409a.3.3 0 0 0 .1.229Zm4.259-2.399a.95.95 0 0 1-.687-.275.92.92 0 0 1-.274-.68v-3.128a.92.92 0 0 1 .274-.68.95.95 0 0 1 .688-.275h.116v-1.057a1.9 1.9 0 0 1 .584-1.409 2.037 2.037 0 0 1 2.85 0 1.9 1.9 0 0 1 .585 1.409v1.057h.092a.93.93 0 0 1 .687.275.91.91 0 0 1 .278.68v3.128a.91.91 0 0 1-.278.68.93.93 0 0 1-.687.275Zm1.362-6.843a1 1 0 0 0-.306.75v1.057h2.134v-1.057a1 1 0 0 0-.307-.75 1.107 1.107 0 0 0-1.521 0"
			data-name="Union 51"
			transform="translate(-14014.001 -1200.002)"
		/>
	</SvgIcon>
);

export const UnivPrintEnableIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_4145" data-name="Rectangle 4145" width="24" height="24" rx="4" fill="#4b9c14" opacity="0" />
		<rect id="Rectangle_4143" data-name="Rectangle 4143" width="24" height="24" fill="none" />
		<path
			id="Union_101"
			data-name="Union 101"
			d="M14025.187,1219.215v-2.41h-2.234v-3.428a1.487,1.487,0,0,1,1.5-1.508h8.086a1.481,1.481,0,0,1,1.508,1.508v3.428h-2.237v2.41Zm.905-.905h4.82v-2.572h-4.82Zm5.722-3.474v1.064h1.332v-2.523a.59.59,0,0,0-.6-.6h-8.086a.573.573,0,0,0-.427.173.582.582,0,0,0-.176.43v2.523h1.332v-1.064Zm1.332-2.061h0Zm1.558,1.755a2.4,2.4,0,0,0,1.694-.648,2.166,2.166,0,0,0,0-3.178,2.381,2.381,0,0,0-1.694-.648h-1.431v-1.79a4.183,4.183,0,0,0-1.4-3.167,5.016,5.016,0,0,0-6.754,0,4.183,4.183,0,0,0-1.4,3.167h-.479a3.339,3.339,0,0,0-2.36.916,2.993,2.993,0,0,0,0,4.429,3.441,3.441,0,0,0,.853.68v2.029a8.69,8.69,0,0,1-2.113-1.374,4.661,4.661,0,0,1-1.628-3.481,4.772,4.772,0,0,1,1.124-3.111,5.005,5.005,0,0,1,2.935-1.744,6.064,6.064,0,0,1,2.386-3.333,6.826,6.826,0,0,1,4.059-1.276,6.668,6.668,0,0,1,4.735,1.822,5.866,5.866,0,0,1,1.944,4.443,4.26,4.26,0,0,1,2.73,1.332,3.873,3.873,0,0,1-.165,5.546,4.278,4.278,0,0,1-3.044,1.177Zm-3.133-.423a.579.579,0,0,1-.173-.43.609.609,0,0,1,1.033-.43.6.6,0,0,1,.172.43.594.594,0,0,1-.172.43.622.622,0,0,1-.86,0Zm-.658-2.237v-1.807h-4.82v1.807h-.905v-2.709h6.627v2.709Z"
			transform="translate(-14016.5 -1198.608)"
			fill="#7d61bc"
		/>
	</SvgIcon>
)

export const UnivPrintStatusIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<svg
			id="universal-print-connector"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<rect id="Rectangle_4145" data-name="Rectangle 4145" width="24" height="24" rx="4" fill={props.htmlColor} />
			<rect id="Rectangle_4143" data-name="Rectangle 4143" width="24" height="24" fill="none" />
			<path
				id="Union_101"
				data-name="Union 101"
				d="M14025.187,1219.215v-2.41h-2.234v-3.428a1.487,1.487,0,0,1,1.5-1.508h8.086a1.481,1.481,0,0,1,1.508,1.508v3.428h-2.237v2.41Zm.905-.905h4.82v-2.572h-4.82Zm5.722-3.474v1.064h1.332v-2.523a.59.59,0,0,0-.6-.6h-8.086a.573.573,0,0,0-.427.173.582.582,0,0,0-.176.43v2.523h1.332v-1.064Zm1.332-2.061h0Zm1.558,1.755a2.4,2.4,0,0,0,1.694-.648,2.166,2.166,0,0,0,0-3.178,2.381,2.381,0,0,0-1.694-.648h-1.431v-1.79a4.183,4.183,0,0,0-1.4-3.167,5.016,5.016,0,0,0-6.754,0,4.183,4.183,0,0,0-1.4,3.167h-.479a3.339,3.339,0,0,0-2.36.916,2.993,2.993,0,0,0,0,4.429,3.441,3.441,0,0,0,.853.68v2.029a8.69,8.69,0,0,1-2.113-1.374,4.661,4.661,0,0,1-1.628-3.481,4.772,4.772,0,0,1,1.124-3.111,5.005,5.005,0,0,1,2.935-1.744,6.064,6.064,0,0,1,2.386-3.333,6.826,6.826,0,0,1,4.059-1.276,6.668,6.668,0,0,1,4.735,1.822,5.866,5.866,0,0,1,1.944,4.443,4.26,4.26,0,0,1,2.73,1.332,3.873,3.873,0,0,1-.165,5.546,4.278,4.278,0,0,1-3.044,1.177Zm-3.133-.423a.579.579,0,0,1-.173-.43.609.609,0,0,1,1.033-.43.6.6,0,0,1,.172.43.594.594,0,0,1-.172.43.622.622,0,0,1-.86,0Zm-.658-2.237v-1.807h-4.82v1.807h-.905v-2.709h6.627v2.709Z"
				transform="translate(-14016.5 -1198.608)"
				fill="#fff"
			/>
		</svg>
	</SvgIcon>
);

export const UnivPrintDisabledIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_4145" data-name="Rectangle 4145" width="24" height="24" rx="4" fill="#4b9c14" opacity="0"/>
		<rect id="Rectangle_4143" data-name="Rectangle 4143" width="24" height="24" fill="none"/>
		<path
			id="Union_101"
			data-name="Union 101"
			d="M14025.187,1219.215v-2.41h-2.234v-3.428a1.487,1.487,0,0,1,1.5-1.508h8.086a1.481,1.481,0,0,1,1.508,1.508v3.428h-2.237v2.41Zm.905-.905h4.82v-2.572h-4.82Zm5.722-3.474v1.064h1.332v-2.523a.59.59,0,0,0-.6-.6h-8.086a.573.573,0,0,0-.427.173.582.582,0,0,0-.176.43v2.523h1.332v-1.064Zm1.332-2.061h0Zm1.558,1.755a2.4,2.4,0,0,0,1.694-.648,2.166,2.166,0,0,0,0-3.178,2.381,2.381,0,0,0-1.694-.648h-1.431v-1.79a4.183,4.183,0,0,0-1.4-3.167,5.016,5.016,0,0,0-6.754,0,4.183,4.183,0,0,0-1.4,3.167h-.479a3.339,3.339,0,0,0-2.36.916,2.993,2.993,0,0,0,0,4.429,3.441,3.441,0,0,0,.853.68v2.029a8.69,8.69,0,0,1-2.113-1.374,4.661,4.661,0,0,1-1.628-3.481,4.772,4.772,0,0,1,1.124-3.111,5.005,5.005,0,0,1,2.935-1.744,6.064,6.064,0,0,1,2.386-3.333,6.826,6.826,0,0,1,4.059-1.276,6.668,6.668,0,0,1,4.735,1.822,5.866,5.866,0,0,1,1.944,4.443,4.26,4.26,0,0,1,2.73,1.332,3.873,3.873,0,0,1-.165,5.546,4.278,4.278,0,0,1-3.044,1.177Zm-3.133-.423a.579.579,0,0,1-.173-.43.609.609,0,0,1,1.033-.43.6.6,0,0,1,.172.43.594.594,0,0,1-.172.43.622.622,0,0,1-.86,0Zm-.658-2.237v-1.807h-4.82v1.807h-.905v-2.709h6.627v2.709Z"
			transform="translate(-14016.5 -1198.608)"
			fill="#d1d1d1"
		/>
	</SvgIcon>
)

export const SignatureUploadBackgroundIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 76 76" {...props}>
		<g id="Group_7946" data-name="Group 7946" transform="translate(928.771 4283.303)">
			<g id="Group_3172" data-name="Group 3172" transform="translate(-1128.539 -4775.303)">
				<g id="Group_6951" data-name="Group 6951" transform="translate(2.768)">
					<g
						id="Rectangle_1474"
						data-name="Rectangle 1474"
						transform="translate(200 495)"
						fill="#f2eff9"
						stroke="#f2eff9"
						strokeWidth="0.5"
					>
						<rect width="69.535" height="69.535" stroke="none" />
						<rect x="0.25" y="0.25" width="69.035" height="69.035" fill="none" />
					</g>
					<path
						id="image_FILL0_wght400_GRAD0_opsz48"
						d="M9.551,42.769H73.258L54.107,17.234,36.91,39.512,24.794,22.967Z"
						transform="translate(193.365 514.618)"
						fill="#dfd8ef"
					/>
				</g>
			</g>
		</g>
		<rect id="Rectangle_3174" data-name="Rectangle 3174" width="76" height="76" fill="none" />
	</SvgIcon>
);

export const ResetPasswordIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3248" data-name="Rectangle 3248" width="24" height="24" fill="none" />
		<g id="Group_8020" data-name="Group 8020" transform="translate(-690.308 -961.949)">
			<path
				id="Union_47"
				data-name="Union 47"
				d="M4.009,1.747A5.787,5.787,0,0,0,2.247,6v.5L.869,5.114,0,5.986,2.868,8.853,5.731,5.986l-.869-.872L3.485,6.495V6a4.6,4.6,0,0,1,1.4-3.373,4.662,4.662,0,0,1,3.4-1.387,4.387,4.387,0,0,1,.944.1,4.53,4.53,0,0,1,.923.309l.027.012L11.1.737,11.049.71A6.221,6.221,0,0,0,9.7.18,5.8,5.8,0,0,0,8.28,0,5.881,5.881,0,0,0,4.009,1.747Zm9.581,1.426L10.752,6.01l.869.869L13,5.5V6a4.588,4.588,0,0,1-1.4,3.37,4.665,4.665,0,0,1-3.4,1.387,4.427,4.427,0,0,1-.943-.1,4.31,4.31,0,0,1-.919-.309l-.027-.012-.926.926.051.027a6,6,0,0,0,1.348.53,5.635,5.635,0,0,0,1.417.18,5.867,5.867,0,0,0,4.273-1.747A5.785,5.785,0,0,0,14.236,6V5.5l1.378,1.378.872-.869L13.619,3.143Z"
				transform="translate(710.794 976.941) rotate(180)"
				fill={props.htmlColor ? props.htmlColor : '#323232'}
			/>
			<path
				id="password_FILL1_wght400_GRAD0_opsz24"
				d="M2.611,11.245l-.974-.535.637-1.07H1V8.57H2.274L1.637,7.535,2.611,7l.637,1.035L3.885,7l.974.535L4.222,8.57H5.5V9.64H4.222l.637,1.07-.974.535-.637-1.07Zm5.995,0-.974-.535.637-1.07H6.995V8.57H8.269L7.632,7.535,8.606,7l.637,1.035L9.88,7l.974.535L10.217,8.57h1.274V9.64H10.217l.637,1.07-.974.535-.637-1.07Zm5.995,0-.974-.535.637-1.07H12.99V8.57h1.274l-.637-1.035L14.6,7l.637,1.035L15.875,7l.974.535L16.212,8.57h1.274V9.64H16.212l.637,1.07-.974.535-.637-1.07Z"
				transform="translate(693.308 971.704)"
				fill={props.htmlColor ? props.htmlColor : '#323232'}
			/>
		</g>
	</SvgIcon>
);

export const PurpleCircleOneIcon = (props: SvgIconProps) => (
	<SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
		<path id="Path_6923" d="M14,0c7.7,0,14,6.3,14,14s-6.3,14-14,14S0,21.7,0,14,6.3,0,14,0Z" fill="#603fa5" />
		<g id="_1" style={{ isolation: 'isolate' }}>
			<g style={{ isolation: 'isolate' }}>
				<path
					d="M16.4,21h-2.7v-8.7s0-1.3,0-1.3c-.5.5-.8.7-.9.9l-1.5,1.2-1.3-1.6,4.1-3.3h2.2v12.8Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PurpleCircleTwoIcon = (props: SvgIconProps) => (
	<SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
		<path id="Path_6923" d="M14,0c7.7,0,14,6.3,14,14s-6.3,14-14,14S0,21.7,0,14,6.3,0,14,0Z" fill="#603fa5" />
		<g id="_2" style={{ isolation: 'isolate' }}>
			<g style={{ isolation: 'isolate' }}>
				<path
					d="M18.7,21h-9v-1.9l3.2-3.3c1-1,1.6-1.7,1.9-2,.3-.4.5-.7.6-1s.2-.7.2-1c0-.5-.1-.9-.4-1.2-.3-.3-.7-.4-1.1-.4s-1,.1-1.5.3-1,.6-1.5,1l-1.5-1.7c.6-.5,1.2-.9,1.6-1.1s.9-.4,1.4-.5,1-.2,1.7-.2,1.5.1,2.1.4,1.1.7,1.4,1.2.5,1.1.5,1.8-.1,1.1-.3,1.7c-.2.5-.5,1.1-1,1.6-.4.5-1.2,1.3-2.3,2.3l-1.7,1.6h0c0,.1,5.6.1,5.6.1v2.3Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PurpleCircleThreeIcon = (props: SvgIconProps) => (
	<SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
		<path id="Path_6923" d="M14,0c7.7,0,14,6.3,14,14s-6.3,14-14,14S0,21.7,0,14,6.3,0,14,0Z" fill="#603fa5" />
		<g id="_3" style={{ isolation: 'isolate' }}>
			<g style={{ isolation: 'isolate' }}>
				<path
					d="M18.2,11c0,.8-.2,1.5-.7,2s-1.2.9-2,1.2h0c1,.2,1.8.5,2.4,1,.5.5.8,1.2.8,2,0,1.2-.4,2.2-1.3,2.9-.9.7-2.2,1-3.8,1s-2.6-.2-3.7-.7v-2.3c.5.3,1,.5,1.6.6s1.2.2,1.8.2c.9,0,1.6-.2,2-.5s.6-.8.6-1.5-.2-1-.7-1.3-1.3-.4-2.4-.4h-1v-2.1h1c1,0,1.7-.1,2.2-.4.5-.3.7-.7.7-1.3,0-1-.6-1.5-1.8-1.5s-.9,0-1.3.2-.9.4-1.5.7l-1.3-1.9c1.2-.8,2.6-1.3,4.2-1.3s2.4.3,3.2.8c.8.5,1.2,1.3,1.2,2.2Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PurpleCircleFourIcon = (props: SvgIconProps) => (
	<SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
		<path id="Path_6923" d="M14,0c7.7,0,14,6.3,14,14s-6.3,14-14,14S0,21.7,0,14,6.3,0,14,0Z" fill="#603fa5" />
		<g id="_4" style={{ isolation: 'isolate' }}>
			<g style={{ isolation: 'isolate' }}>
				<path
					d="M19,18.3h-1.5v2.7h-2.7v-2.7h-5.5v-1.9l5.6-8.3h2.5v8.1h1.5v2.1ZM14.8,16.2v-2.2c0-.4,0-.9,0-1.6s0-1.1,0-1.2h0c-.2.5-.5.9-.8,1.4l-2.4,3.6h3.1Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PurpleCircleBypassIcon = (props: SvgIconProps) => (
	<SvgIcon width="36" height="36" viewBox="0 0 36 36" {...props}>
		<path id="Path_6923" d="M18,0c9.9,0,18,8.1,18,18s-8.1,18-18,18S0,27.9,0,18,8.1,0,18,0Z" fill="#603fa5" />
		<g id="Bypass" style={{ isolation: 'isolate' }}>
			<g style={{ isolation: 'isolate' }}>
				<path
					d="M3.8,14.6h2c.9,0,1.6.1,2,.4.4.3.6.7.6,1.2s0,.7-.3.9c-.2.2-.4.4-.7.4h0c.4.1.7.3.9.6.2.2.3.6.3,1,0,.6-.2,1-.6,1.4-.4.3-1,.5-1.7.5h-2.4v-6.4ZM5.2,17.1h.8c.4,0,.6,0,.8-.2s.2-.3.2-.6,0-.4-.3-.5c-.2-.1-.5-.2-.9-.2h-.7v1.4ZM5.2,18.2v1.7h.9c.4,0,.7,0,.8-.2s.3-.4.3-.7c0-.5-.4-.8-1.1-.8h-.8Z"
					fill="#fff"
				/>
				<path
					d="M9,16.1h1.5l.9,2.8c0,.2.1.5.2.9h0c0-.3,0-.6.2-.9l.9-2.8h1.4l-2.1,5.5c-.2.5-.5.9-.8,1.2-.4.3-.8.4-1.2.4s-.5,0-.7,0v-1.1c.2,0,.3,0,.5,0s.4,0,.6-.2c.2-.1.3-.4.4-.7v-.2c0,0-1.9-4.9-1.9-4.9Z"
					fill="#fff"
				/>
				<path
					d="M17.6,21.1c-.6,0-1-.2-1.4-.6h0c0,.4,0,.6,0,.7v2h-1.3v-7.1h1.1l.2.6h0c.3-.5.8-.7,1.4-.7s1,.2,1.4.7c.3.4.5,1.1.5,1.9s0,1-.2,1.4-.4.7-.7.9c-.3.2-.6.3-1,.3ZM17.2,17.1c-.3,0-.6.1-.7.3-.2.2-.2.5-.2,1h0c0,.7,0,1.1.2,1.3s.4.3.7.3c.6,0,.9-.5.9-1.5s0-.8-.2-1.1c-.1-.2-.4-.4-.7-.4Z"
					fill="#fff"
				/>
				<path
					d="M23.7,21l-.3-.7h0c-.2.3-.5.5-.7.6-.2.1-.5.2-.9.2s-.8-.1-1.1-.4c-.3-.3-.4-.7-.4-1.2s.2-.9.5-1.2c.4-.2.9-.4,1.7-.4h.9v-.2c0-.5-.3-.7-.8-.7s-.9.1-1.4.4l-.4-.9c.6-.3,1.2-.4,1.9-.4s1.2.1,1.5.4c.4.3.5.7.5,1.3v3.3h-.9ZM23.3,18.7h-.5c-.4,0-.7,0-.9.2-.2.1-.3.3-.3.6,0,.4.2.6.7.6s.6,0,.7-.3c.2-.2.3-.4.3-.7v-.4Z"
					fill="#fff"
				/>
				<path
					d="M29.4,19.5c0,.5-.2.9-.5,1.2-.3.3-.9.4-1.6.4s-.7,0-.9,0c-.3,0-.5-.1-.7-.2v-1.1c.2.1.5.2.8.3.3,0,.6.1.8.1.5,0,.7-.1.7-.4s0-.2,0-.3c0,0-.2-.1-.3-.2-.2,0-.4-.2-.6-.3-.4-.2-.7-.3-.8-.4-.2-.1-.3-.3-.4-.5,0-.2-.1-.4-.1-.6,0-.4.2-.8.5-1,.3-.2.8-.4,1.4-.4s1.2.1,1.7.4l-.4,1c-.2-.1-.5-.2-.7-.3-.2,0-.4-.1-.7-.1-.4,0-.6.1-.6.3s0,.2.2.3c.1,0,.4.2.8.4.4.2.7.3.8.4s.3.3.4.5c0,.2.1.4.1.6Z"
					fill="#fff"
				/>
				<path
					d="M33.9,19.5c0,.5-.2.9-.5,1.2-.3.3-.9.4-1.6.4s-.7,0-.9,0c-.3,0-.5-.1-.7-.2v-1.1c.2.1.5.2.8.3.3,0,.6.1.8.1.5,0,.7-.1.7-.4s0-.2,0-.3c0,0-.2-.1-.3-.2-.2,0-.4-.2-.6-.3-.4-.2-.7-.3-.8-.4-.2-.1-.3-.3-.4-.5,0-.2-.1-.4-.1-.6,0-.4.2-.8.5-1,.3-.2.8-.4,1.4-.4s1.2.1,1.7.4l-.4,1c-.2-.1-.5-.2-.7-.3-.2,0-.4-.1-.7-.1-.4,0-.6.1-.6.3s0,.2.2.3c.1,0,.4.2.8.4.4.2.7.3.8.4s.3.3.4.5c0,.2.1.4.1.6Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const SefIcon = (props: SvgIconProps) => (
	<SvgIcon width="47.001" height="38.365" viewBox="0 0 47.001 38.365" {...props}>
		<defs>
			<filter id="Rectangle_2306" x="0" y="0" width="47.001" height="38.365" filterUnits="userSpaceOnUse">
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1.5" result="blur" />
				<feFlood floodOpacity="0.278" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="landscape-sef-icon-paper-trays" transform="translate(4.501 3.5)">
			<g id="Group_9890" data-name="Group 9890" transform="translate(-20320 -10199) rotate(90)">
				<g transform="matrix(0, -1, 1, 0, 10195.5, -20315.5)" filter="url(#Rectangle_2306)">
					<g
						id="Rectangle_2305-2"
						data-name="Rectangle 2305"
						transform="translate(42.5 3.5) rotate(90)"
						fill="#fff"
						stroke="#262626"
						strokeWidth="0.5"
					>
						<rect width="29.365" height="38.001" stroke="none" />
						<rect x="0.25" y="0.25" width="28.865" height="37.501" fill="none" />
					</g>
				</g>
				<path
					id="Path_10459"
					data-name="Path 10459"
					d="M4.509-1.709A1.576,1.576,0,0,1,3.894-.387a2.668,2.668,0,0,1-1.67.475A4.183,4.183,0,0,1,.466-.207V-.927a4.628,4.628,0,0,0,.861.264,4.532,4.532,0,0,0,.923.1A1.862,1.862,0,0,0,3.375-.85a.93.93,0,0,0,.378-.789,1.013,1.013,0,0,0-.134-.547,1.245,1.245,0,0,0-.448-.393,6.271,6.271,0,0,0-.956-.409,3.051,3.051,0,0,1-1.281-.76A1.678,1.678,0,0,1,.549-4.9a1.426,1.426,0,0,1,.558-1.182,2.319,2.319,0,0,1,1.477-.439,4.352,4.352,0,0,1,1.762.352l-.233.65a3.982,3.982,0,0,0-1.547-.334,1.5,1.5,0,0,0-.927.255.84.84,0,0,0-.334.708,1.084,1.084,0,0,0,.123.547,1.158,1.158,0,0,0,.415.391,5.16,5.16,0,0,0,.894.393,3.54,3.54,0,0,1,1.391.773A1.521,1.521,0,0,1,4.509-1.709ZM9.4,0H5.823V-6.425H9.4v.664H6.57v2.07H9.233v.659H6.57V-.668H9.4Zm2.171,0h-.747V-6.425H14.41v.664H11.575V-3.41h2.663v.664H11.575Z"
					transform="translate(10216.684 -20331.316) rotate(-90)"
					fill="#d7d7d7"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const LefIcon = (props: SvgIconProps) => (
	<SvgIcon width="38.365" height="47.001" viewBox="0 0 38.365 47.001" {...props}>
		<defs>
			<filter id="Rectangle_2305" x="0" y="0" width="38.365" height="47.001" filterUnits="userSpaceOnUse">
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1.5" result="blur" />
				<feFlood floodOpacity="0.278" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="portrait-lef-icon-paper-trays" transform="translate(4.5 3.5)">
			<g transform="matrix(1, 0, 0, 1, -4.5, -3.5)" filter="url(#Rectangle_2305)">
				<g
					id="Rectangle_2305-2"
					data-name="Rectangle 2305"
					transform="translate(4.5 3.5)"
					fill="#fff"
					stroke="#262626"
					strokeWidth="0.5"
				>
					<rect width="29.365" height="38.001" stroke="none" />
					<rect x="0.25" y="0.25" width="28.865" height="37.501" fill="none" />
				</g>
			</g>
			<path
				id="Path_10460"
				data-name="Path 10460"
				d="M.883,0V-6.425H1.63V-.677H4.465V0ZM9.136,0H5.555V-6.425H9.136v.664H6.3v2.07H8.965v.659H6.3V-.668H9.136Zm2.171,0H10.56V-6.425h3.582v.664H11.307V-3.41H13.97v.664H11.307Z"
				transform="translate(8 23)"
				fill="#d7d7d7"
			/>
		</g>
	</SvgIcon>
);
export * from './print.icons';
